
    
    var g_ltc_2 = [1, 0, 0, 0, 
        1, 7.91421e-31, 0, 0, 
        1, 1.04392e-24, 0, 0, 
        1, 3.49405e-21, 0, 0, 
        1, 1.09923e-18, 0, 0, 
        1, 9.47414e-17, 0, 0, 
        1, 3.59627e-15, 0, 0, 
        1, 7.72053e-14, 0, 0, 
        1, 1.08799e-12, 0, 0, 
        1, 1.10655e-11, 0, 0, 
        1, 8.65818e-11, 0, 0, 
        0.999998, 5.45037e-10, 0, 0, 
        0.999994, 2.85095e-09, 0, 0, 
        0.999989, 1.26931e-08, 0, 0, 
        0.999973, 4.89938e-08, 0, 0, 
        0.999947, 1.66347e-07, 0, 0, 
        0.999894, 5.02694e-07, 0, 0, 
        0.999798, 1.36532e-06, 0, 0, 
        0.999617, 3.35898e-06, 0, 0, 
        0.999234, 7.52126e-06, 0, 0, 
        0.998258, 1.52586e-05, 0, 0, 
        0.99504, 2.66207e-05, 0, 0, 
        0.980816, 2.36802e-05, 0, 0, 
        0.967553, 2.07684e-06, 0, 0, 
        0.966877, 4.03733e-06, 0, 0, 
        0.965752, 7.41174e-06, 0, 0, 
        0.96382, 1.27746e-05, 0, 0, 
        0.960306, 2.02792e-05, 0, 0, 
        0.953619, 2.80232e-05, 0, 0, 
        0.941103, 2.78816e-05, 0, 0, 
        0.926619, 1.60221e-05, 0, 0, 
        0.920983, 2.35164e-05, 0, 0, 
        0.912293, 3.11924e-05, 0, 0.0158731, 
        0.899277, 3.48118e-05, 0, 0.0476191, 
        0.880884, 2.6041e-05, 0, 0.0793651, 
        0.870399, 3.38726e-05, 0, 0.111111, 
        0.856138, 3.92906e-05, 0, 0.142857, 
        0.837436, 3.72874e-05, 0, 0.174603, 
        0.820973, 3.92558e-05, 0, 0.206349, 
        0.803583, 4.34658e-05, 0, 0.238095, 
        0.782168, 4.0256e-05, 0, 0.269841, 
        0.764107, 4.48159e-05, 0, 0.301587, 
        0.743092, 4.57627e-05, 0, 0.333333, 
        0.721626, 4.55314e-05, 0, 0.365079, 
        0.700375, 4.77335e-05, 0, 0.396825, 
        0.677334, 4.61072e-05, 0, 0.428571, 
        0.655702, 4.84393e-05, 0, 0.460317, 
        0.632059, 4.64583e-05, 0, 0.492064, 
        0.610125, 4.83923e-05, 0, 0.52381, 
        0.58653, 4.64342e-05, 0, 0.555556, 
        0.564508, 4.77033e-05, 0, 0.587302, 
        0.541405, 4.59263e-05, 0, 0.619048, 
        0.519556, 4.6412e-05, 0, 0.650794, 
        0.497292, 4.48913e-05, 0, 0.68254, 
        0.475898, 4.45789e-05, 0, 0.714286, 
        0.454722, 4.33496e-05, 0, 0.746032, 
        0.434042, 4.23054e-05, 0, 0.777778, 
        0.414126, 4.13737e-05, 0, 0.809524, 
        0.394387, 3.97265e-05, 0, 0.84127, 
        0.375841, 3.90709e-05, 0, 0.873016, 
        0.357219, 3.69938e-05, 0, 0.904762, 
        0.340084, 3.65618e-05, 0, 0.936508, 
        0.322714, 3.42533e-05, 0, 0.968254, 
        0.306974, 3.39596e-05, 0, 1, 
        1, 1.01524e-18, 0, 0, 
        1, 1.0292e-18, 0, 0, 
        1, 1.30908e-18, 0, 0, 
        1, 4.73331e-18, 0, 0, 
        1, 6.25319e-17, 0, 0, 
        1, 1.07932e-15, 0, 0, 
        1, 1.63779e-14, 0, 0, 
        1, 2.03198e-13, 0, 0, 
        1, 2.04717e-12, 0, 0, 
        0.999999, 1.68995e-11, 0, 0, 
        0.999998, 1.15855e-10, 0, 0, 
        0.999996, 6.6947e-10, 0, 0, 
        0.999991, 3.30863e-09, 0, 0, 
        0.999983, 1.41737e-08, 0, 0, 
        0.999968, 5.32626e-08, 0, 0, 
        0.99994, 1.77431e-07, 0, 0, 
        0.999891, 5.28835e-07, 0, 0, 
        0.999797, 1.42169e-06, 0, 0, 
        0.999617, 3.47057e-06, 0, 0, 
        0.999227, 7.7231e-06, 0, 0, 
        0.998239, 1.55753e-05, 0, 0, 
        0.994937, 2.68495e-05, 0, 0, 
        0.980225, 2.13742e-05, 0, 0, 
        0.967549, 2.1631e-06, 0, 0, 
        0.966865, 4.17989e-06, 0, 0, 
        0.965739, 7.63341e-06, 0, 0, 
        0.963794, 1.30892e-05, 0, 0, 
        0.960244, 2.06456e-05, 0, 0, 
        0.953495, 2.82016e-05, 0, 0.000148105, 
        0.940876, 2.71581e-05, 0, 0.002454, 
        0.926569, 1.64159e-05, 0, 0.00867491, 
        0.920905, 2.39521e-05, 0, 0.01956, 
        0.912169, 3.15127e-05, 0, 0.035433, 
        0.899095, 3.46626e-05, 0, 0.056294, 
        0.882209, 2.90223e-05, 0, 0.0818191, 
        0.870272, 3.42992e-05, 0, 0.111259, 
        0.855977, 3.94164e-05, 0, 0.142857, 
        0.837431, 3.72343e-05, 0, 0.174603, 
        0.820826, 3.96691e-05, 0, 0.206349, 
        0.803408, 4.35395e-05, 0, 0.238095, 
        0.782838, 4.19579e-05, 0, 0.269841, 
        0.763941, 4.50953e-05, 0, 0.301587, 
        0.742904, 4.55847e-05, 0, 0.333333, 
        0.721463, 4.58833e-05, 0, 0.365079, 
        0.700197, 4.77159e-05, 0, 0.396825, 
        0.677501, 4.70641e-05, 0, 0.428571, 
        0.655527, 4.84732e-05, 0, 0.460317, 
        0.6324, 4.76834e-05, 0, 0.492064, 
        0.609964, 4.84213e-05, 0, 0.52381, 
        0.586839, 4.75541e-05, 0, 0.555556, 
        0.564353, 4.76951e-05, 0, 0.587302, 
        0.541589, 4.67611e-05, 0, 0.619048, 
        0.519413, 4.63493e-05, 0, 0.650794, 
        0.497337, 4.53994e-05, 0, 0.68254, 
        0.475797, 4.45308e-05, 0, 0.714286, 
        0.454659, 4.35787e-05, 0, 0.746032, 
        0.434065, 4.24839e-05, 0, 0.777778, 
        0.414018, 4.1436e-05, 0, 0.809524, 
        0.39455, 4.01902e-05, 0, 0.84127, 
        0.375742, 3.90813e-05, 0, 0.873016, 
        0.357501, 3.77116e-05, 0, 0.904762, 
        0.339996, 3.6535e-05, 0, 0.936508, 
        0.323069, 3.51265e-05, 0, 0.968254, 
        0.306897, 3.39112e-05, 0, 1, 
        1, 1.0396e-15, 0, 0, 
        1, 1.04326e-15, 0, 0, 
        1, 1.10153e-15, 0, 0, 
        1, 1.44668e-15, 0, 0, 
        1, 3.4528e-15, 0, 0, 
        1, 1.75958e-14, 0, 0, 
        1, 1.2627e-13, 0, 0, 
        1, 9.36074e-13, 0, 0, 
        1, 6.45742e-12, 0, 0, 
        0.999998, 4.01228e-11, 0, 0, 
        0.999997, 2.22338e-10, 0, 0, 
        0.999995, 1.0967e-09, 0, 0, 
        0.999991, 4.82132e-09, 0, 0, 
        0.999981, 1.89434e-08, 0, 0, 
        0.999967, 6.67716e-08, 0, 0, 
        0.999938, 2.12066e-07, 0, 0, 
        0.999886, 6.0977e-07, 0, 0, 
        0.999792, 1.59504e-06, 0, 0, 
        0.999608, 3.81191e-06, 0, 0, 
        0.999209, 8.33727e-06, 0, 0, 
        0.998179, 1.65288e-05, 0, 0, 
        0.994605, 2.74387e-05, 0, 0, 
        0.979468, 1.67316e-05, 0, 0, 
        0.967529, 2.42877e-06, 0, 0, 
        0.966836, 4.61696e-06, 0, 0, 
        0.96569, 8.30977e-06, 0, 0, 
        0.963706, 1.40427e-05, 0, 2.44659e-06, 
        0.960063, 2.17353e-05, 0, 0.000760774, 
        0.953113, 2.86606e-05, 0, 0.00367261, 
        0.940192, 2.47691e-05, 0, 0.00940263, 
        0.927731, 1.95814e-05, 0, 0.018333, 
        0.920669, 2.52531e-05, 0, 0.0306825, 
        0.911799, 3.24277e-05, 0, 0.0465556, 
        0.89857, 3.40982e-05, 0, 0.0659521, 
        0.883283, 3.19622e-05, 0, 0.0887677, 
        0.86989, 3.5548e-05, 0, 0.114784, 
        0.855483, 3.97143e-05, 0, 0.143618, 
        0.837987, 3.91665e-05, 0, 0.174606, 
        0.820546, 4.11306e-05, 0, 0.206349, 
        0.802878, 4.36753e-05, 0, 0.238095, 
        0.783402, 4.44e-05, 0, 0.269841, 
        0.763439, 4.58726e-05, 0, 0.301587, 
        0.742925, 4.67097e-05, 0, 0.333333, 
        0.721633, 4.78887e-05, 0, 0.365079, 
        0.69985, 4.81251e-05, 0, 0.396825, 
        0.67783, 4.91811e-05, 0, 0.428571, 
        0.655126, 4.88199e-05, 0, 0.460318, 
        0.632697, 4.96025e-05, 0, 0.492064, 
        0.609613, 4.8829e-05, 0, 0.52381, 
        0.587098, 4.92754e-05, 0, 0.555556, 
        0.564119, 4.82625e-05, 0, 0.587302, 
        0.541813, 4.82807e-05, 0, 0.619048, 
        0.519342, 4.71552e-05, 0, 0.650794, 
        0.497514, 4.66765e-05, 0, 0.68254, 
        0.475879, 4.55582e-05, 0, 0.714286, 
        0.454789, 4.46007e-05, 0, 0.746032, 
        0.434217, 4.35382e-05, 0, 0.777778, 
        0.414086, 4.21753e-05, 0, 0.809524, 
        0.394744, 4.12093e-05, 0, 0.84127, 
        0.375782, 3.96634e-05, 0, 0.873016, 
        0.357707, 3.86419e-05, 0, 0.904762, 
        0.340038, 3.70345e-05, 0, 0.936508, 
        0.323284, 3.59725e-05, 0, 0.968254, 
        0.306954, 3.436e-05, 0, 1, 
        1, 5.99567e-14, 0, 0, 
        1, 6.00497e-14, 0, 0, 
        1, 6.14839e-14, 0, 0, 
        1, 6.86641e-14, 0, 0, 
        1, 9.72658e-14, 0, 0, 
        1, 2.21271e-13, 0, 0, 
        1, 8.33195e-13, 0, 0, 
        1, 4.03601e-12, 0, 0, 
        0.999999, 2.06001e-11, 0, 0, 
        0.999998, 1.01739e-10, 0, 0, 
        0.999997, 4.70132e-10, 0, 0, 
        0.999993, 2.00436e-09, 0, 0, 
        0.999988, 7.83682e-09, 0, 0, 
        0.999979, 2.80338e-08, 0, 0, 
        0.999962, 9.17033e-08, 0, 0, 
        0.999933, 2.74514e-07, 0, 0, 
        0.999881, 7.53201e-07, 0, 0, 
        0.999783, 1.89826e-06, 0, 0, 
        0.999594, 4.40279e-06, 0, 0, 
        0.999178, 9.3898e-06, 0, 0, 
        0.998073, 1.81265e-05, 0, 0, 
        0.993993, 2.80487e-05, 0, 0, 
        0.979982, 1.49422e-05, 0, 0, 
        0.968145, 3.78481e-06, 0, 0, 
        0.966786, 5.3771e-06, 0, 0, 
        0.965611, 9.47508e-06, 0, 3.88934e-05, 
        0.963557, 1.56616e-05, 0, 0.0009693, 
        0.959752, 2.35144e-05, 0, 0.00370329, 
        0.952461, 2.91568e-05, 0, 0.00868428, 
        0.940193, 2.40102e-05, 0, 0.0161889, 
        0.929042, 2.31235e-05, 0, 0.0263948, 
        0.920266, 2.73968e-05, 0, 0.0394088, 
        0.911178, 3.37915e-05, 0, 0.0552818, 
        0.897873, 3.33629e-05, 0, 0.0740138, 
        0.884053, 3.51405e-05, 0, 0.0955539, 
        0.869455, 3.78034e-05, 0, 0.119795, 
        0.854655, 3.99378e-05, 0, 0.14656, 
        0.838347, 4.19108e-05, 0, 0.175573, 
        0.820693, 4.40831e-05, 0, 0.206388, 
        0.802277, 4.45599e-05, 0, 0.238095, 
        0.783634, 4.72691e-05, 0, 0.269841, 
        0.763159, 4.76984e-05, 0, 0.301587, 
        0.742914, 4.91487e-05, 0, 0.333333, 
        0.721662, 5.02312e-05, 0, 0.365079, 
        0.699668, 5.02817e-05, 0, 0.396825, 
        0.677839, 5.1406e-05, 0, 0.428571, 
        0.655091, 5.11095e-05, 0, 0.460317, 
        0.632665, 5.16067e-05, 0, 0.492064, 
        0.609734, 5.12255e-05, 0, 0.52381, 
        0.587043, 5.10263e-05, 0, 0.555556, 
        0.564298, 5.0565e-05, 0, 0.587302, 
        0.541769, 4.97951e-05, 0, 0.619048, 
        0.519529, 4.92698e-05, 0, 0.650794, 
        0.497574, 4.82066e-05, 0, 0.68254, 
        0.476028, 4.73689e-05, 0, 0.714286, 
        0.454961, 4.61941e-05, 0, 0.746032, 
        0.434341, 4.50618e-05, 0, 0.777778, 
        0.414364, 4.38355e-05, 0, 0.809524, 
        0.394832, 4.24196e-05, 0, 0.84127, 
        0.376109, 4.12563e-05, 0, 0.873016, 
        0.35779, 3.96226e-05, 0, 0.904762, 
        0.340379, 3.84886e-05, 0, 0.936508, 
        0.323385, 3.68214e-05, 0, 0.968254, 
        0.307295, 3.56636e-05, 0, 1, 
        1, 1.06465e-12, 0, 0, 
        1, 1.06555e-12, 0, 0, 
        1, 1.07966e-12, 0, 0, 
        1, 1.14601e-12, 0, 0, 
        1, 1.37123e-12, 0, 0, 
        1, 2.1243e-12, 0, 0, 
        0.999999, 4.89653e-12, 0, 0, 
        0.999999, 1.60283e-11, 0, 0, 
        0.999998, 6.2269e-11, 0, 0, 
        0.999997, 2.51859e-10, 0, 0, 
        0.999996, 9.96192e-10, 0, 0, 
        0.999992, 3.74531e-09, 0, 0, 
        0.999986, 1.32022e-08, 0, 0, 
        0.999975, 4.33315e-08, 0, 0, 
        0.999959, 1.31956e-07, 0, 0, 
        0.999927, 3.72249e-07, 0, 0, 
        0.999871, 9.72461e-07, 0, 0, 
        0.999771, 2.35343e-06, 0, 0, 
        0.999572, 5.2768e-06, 0, 0, 
        0.999133, 1.09237e-05, 0, 0, 
        0.997912, 2.03675e-05, 0, 0, 
        0.993008, 2.79396e-05, 0, 0, 
        0.980645, 1.39604e-05, 0, 0, 
        0.970057, 6.46596e-06, 0, 0, 
        0.966717, 6.5089e-06, 0, 4.74145e-05, 
        0.965497, 1.11863e-05, 0, 0.00089544, 
        0.96334, 1.79857e-05, 0, 0.0032647, 
        0.959294, 2.59045e-05, 0, 0.0075144, 
        0.951519, 2.92327e-05, 0, 0.0138734, 
        0.940517, 2.49769e-05, 0, 0.0224952, 
        0.93014, 2.6803e-05, 0, 0.0334828, 
        0.91972, 3.03656e-05, 0, 0.0468973, 
        0.910294, 3.53323e-05, 0, 0.0627703, 
        0.897701, 3.51002e-05, 0, 0.0811019, 
        0.884522, 3.88104e-05, 0, 0.10186, 
        0.869489, 4.12932e-05, 0, 0.124985, 
        0.853983, 4.15781e-05, 0, 0.150372, 
        0.838425, 4.54066e-05, 0, 0.177868, 
        0.820656, 4.71624e-05, 0, 0.207245, 
        0.801875, 4.75243e-05, 0, 0.238143, 
        0.783521, 5.05621e-05, 0, 0.269841, 
        0.763131, 5.0721e-05, 0, 0.301587, 
        0.74261, 5.23293e-05, 0, 0.333333, 
        0.72148, 5.28699e-05, 0, 0.365079, 
        0.699696, 5.38677e-05, 0, 0.396825, 
        0.677592, 5.39255e-05, 0, 0.428571, 
        0.65525, 5.46367e-05, 0, 0.460317, 
        0.632452, 5.41348e-05, 0, 0.492064, 
        0.609903, 5.44976e-05, 0, 0.52381, 
        0.586928, 5.36201e-05, 0, 0.555556, 
        0.564464, 5.35185e-05, 0, 0.587302, 
        0.541801, 5.24949e-05, 0, 0.619048, 
        0.519681, 5.1812e-05, 0, 0.650794, 
        0.497685, 5.07687e-05, 0, 0.68254, 
        0.47622, 4.96243e-05, 0, 0.714286, 
        0.455135, 4.85714e-05, 0, 0.746032, 
        0.4346, 4.71847e-05, 0, 0.777778, 
        0.414564, 4.59294e-05, 0, 0.809524, 
        0.395165, 4.44705e-05, 0, 0.84127, 
        0.376333, 4.30772e-05, 0, 0.873016, 
        0.358197, 4.16229e-05, 0, 0.904762, 
        0.34064, 4.01019e-05, 0, 0.936508, 
        0.323816, 3.86623e-05, 0, 0.968254, 
        0.307581, 3.70933e-05, 0, 1, 
        1, 9.91541e-12, 0, 0, 
        1, 9.92077e-12, 0, 0, 
        1, 1.00041e-11, 0, 0, 
        1, 1.0385e-11, 0, 0, 
        1, 1.15777e-11, 0, 0, 
        1, 1.50215e-11, 0, 0, 
        0.999999, 2.54738e-11, 0, 0, 
        0.999999, 5.98822e-11, 0, 0, 
        0.999998, 1.79597e-10, 0, 0, 
        0.999997, 6.02367e-10, 0, 0, 
        0.999994, 2.06835e-09, 0, 0, 
        0.99999, 6.94952e-09, 0, 0, 
        0.999984, 2.23363e-08, 0, 0, 
        0.999972, 6.78578e-08, 0, 0, 
        0.999952, 1.93571e-07, 0, 0, 
        0.999919, 5.16594e-07, 0, 0, 
        0.99986, 1.28739e-06, 0, 0, 
        0.999753, 2.99298e-06, 0, 0, 
        0.999546, 6.48258e-06, 0, 0, 
        0.999074, 1.29985e-05, 0, 0, 
        0.997671, 2.32176e-05, 0, 0, 
        0.991504, 2.56701e-05, 0, 0, 
        0.981148, 1.31141e-05, 0, 0, 
        0.971965, 8.69048e-06, 0, 2.80182e-05, 
        0.966624, 8.08301e-06, 0, 0.000695475, 
        0.965344, 1.35235e-05, 0, 0.00265522, 
        0.963048, 2.10592e-05, 0, 0.00622975, 
        0.958673, 2.87473e-05, 0, 0.0116234, 
        0.950262, 2.81379e-05, 0, 0.018976, 
        0.940836, 2.71089e-05, 0, 0.0283844, 
        0.930996, 3.0926e-05, 0, 0.0399151, 
        0.919848, 3.48359e-05, 0, 0.0536063, 
        0.909136, 3.66092e-05, 0, 0.0694793, 
        0.897554, 3.84162e-05, 0, 0.0875342, 
        0.884691, 4.30971e-05, 0, 0.107749, 
        0.869414, 4.47803e-05, 0, 0.130087, 
        0.853462, 4.52858e-05, 0, 0.154481, 
        0.838187, 4.95769e-05, 0, 0.180833, 
        0.820381, 5.02709e-05, 0, 0.209005, 
        0.801844, 5.22713e-05, 0, 0.238791, 
        0.783061, 5.41505e-05, 0, 0.269869, 
        0.763205, 5.53712e-05, 0, 0.301587, 
        0.742362, 5.64909e-05, 0, 0.333333, 
        0.721393, 5.72646e-05, 0, 0.365079, 
        0.699676, 5.81012e-05, 0, 0.396825, 
        0.677395, 5.8096e-05, 0, 0.428571, 
        0.655208, 5.85766e-05, 0, 0.460317, 
        0.632451, 5.83602e-05, 0, 0.492064, 
        0.609839, 5.80234e-05, 0, 0.52381, 
        0.587093, 5.77161e-05, 0, 0.555556, 
        0.564467, 5.68447e-05, 0, 0.587302, 
        0.542043, 5.63166e-05, 0, 0.619048, 
        0.519826, 5.5156e-05, 0, 0.650794, 
        0.497952, 5.41682e-05, 0, 0.68254, 
        0.476477, 5.28971e-05, 0, 0.714286, 
        0.455412, 5.14952e-05, 0, 0.746032, 
        0.434926, 5.02222e-05, 0, 0.777778, 
        0.4149, 4.85779e-05, 0, 0.809524, 
        0.395552, 4.72242e-05, 0, 0.84127, 
        0.376712, 4.54891e-05, 0, 0.873016, 
        0.358622, 4.40924e-05, 0, 0.904762, 
        0.341048, 4.22984e-05, 0, 0.936508, 
        0.324262, 4.08582e-05, 0, 0.968254, 
        0.308013, 3.90839e-05, 0, 1, 
        1, 6.13913e-11, 0, 0, 
        1, 6.14145e-11, 0, 0, 
        1, 6.17708e-11, 0, 0, 
        1, 6.33717e-11, 0, 0, 
        1, 6.81648e-11, 0, 0, 
        1, 8.08291e-11, 0, 0, 
        1, 1.14608e-10, 0, 0, 
        0.999998, 2.10507e-10, 0, 0, 
        0.999997, 4.99595e-10, 0, 0, 
        0.999995, 1.39897e-09, 0, 0, 
        0.999994, 4.19818e-09, 0, 0, 
        0.999988, 1.27042e-08, 0, 0, 
        0.999979, 3.75153e-08, 0, 0, 
        0.999965, 1.06206e-07, 0, 0, 
        0.999945, 2.85381e-07, 0, 0, 
        0.999908, 7.23611e-07, 0, 0, 
        0.999846, 1.7255e-06, 0, 0, 
        0.999733, 3.86104e-06, 0, 0, 
        0.999511, 8.08493e-06, 0, 0, 
        0.998993, 1.56884e-05, 0, 0, 
        0.997326, 2.65538e-05, 0, 0, 
        0.989706, 2.06466e-05, 0, 0, 
        0.981713, 1.30756e-05, 0, 7.0005e-06, 
        0.973636, 1.06473e-05, 0, 0.000464797, 
        0.966509, 1.0194e-05, 0, 0.00201743, 
        0.965149, 1.65881e-05, 0, 0.00497549, 
        0.962669, 2.49147e-05, 0, 0.00953262, 
        0.95786, 3.17449e-05, 0, 0.0158211, 
        0.949334, 2.81045e-05, 0, 0.0239343, 
        0.941041, 3.03263e-05, 0, 0.0339372, 
        0.931575, 3.56754e-05, 0, 0.0458738, 
        0.920102, 3.97075e-05, 0, 0.059772, 
        0.908002, 3.84886e-05, 0, 0.075645, 
        0.897269, 4.3027e-05, 0, 0.0934929, 
        0.884559, 4.79925e-05, 0, 0.113302, 
        0.869161, 4.8246e-05, 0, 0.135045, 
        0.853342, 5.09505e-05, 0, 0.158678, 
        0.837633, 5.42846e-05, 0, 0.184136, 
        0.820252, 5.54139e-05, 0, 0.211325, 
        0.801872, 5.81412e-05, 0, 0.240113, 
        0.782418, 5.85535e-05, 0, 0.270306, 
        0.7631, 6.10923e-05, 0, 0.301594, 
        0.742183, 6.13678e-05, 0, 0.333333, 
        0.721098, 6.27275e-05, 0, 0.365079, 
        0.699512, 6.29413e-05, 0, 0.396825, 
        0.677372, 6.36351e-05, 0, 0.428571, 
        0.655059, 6.33555e-05, 0, 0.460317, 
        0.632567, 6.36513e-05, 0, 0.492064, 
        0.609784, 6.28965e-05, 0, 0.52381, 
        0.587237, 6.25546e-05, 0, 0.555556, 
        0.564525, 6.15825e-05, 0, 0.587302, 
        0.542181, 6.05048e-05, 0, 0.619048, 
        0.520017, 5.96329e-05, 0, 0.650794, 
        0.498204, 5.81516e-05, 0, 0.68254, 
        0.476742, 5.69186e-05, 0, 0.714286, 
        0.455803, 5.53833e-05, 0, 0.746032, 
        0.435251, 5.37807e-05, 0, 0.777778, 
        0.415374, 5.22025e-05, 0, 0.809524, 
        0.395921, 5.03421e-05, 0, 0.84127, 
        0.377253, 4.88211e-05, 0, 0.873016, 
        0.359021, 4.68234e-05, 0, 0.904762, 
        0.341637, 4.53269e-05, 0, 0.936508, 
        0.3247, 4.33014e-05, 0, 0.968254, 
        0.308625, 4.18007e-05, 0, 1, 
        1, 2.86798e-10, 0, 0, 
        1, 2.86877e-10, 0, 0, 
        1, 2.88094e-10, 0, 0, 
        1, 2.93506e-10, 0, 0, 
        1, 3.09262e-10, 0, 0, 
        0.999999, 3.48593e-10, 0, 0, 
        0.999999, 4.44582e-10, 0, 0, 
        0.999998, 6.88591e-10, 0, 0, 
        0.999996, 1.34391e-09, 0, 0, 
        0.999993, 3.17438e-09, 0, 0, 
        0.999989, 8.35609e-09, 0, 0, 
        0.999983, 2.28677e-08, 0, 0, 
        0.999974, 6.23361e-08, 0, 0, 
        0.999959, 1.65225e-07, 0, 0, 
        0.999936, 4.19983e-07, 0, 0, 
        0.999896, 1.01546e-06, 0, 0, 
        0.99983, 2.32376e-06, 0, 0, 
        0.999709, 5.0156e-06, 0, 0, 
        0.999469, 1.0167e-05, 0, 0, 
        0.998886, 1.90775e-05, 0, 0, 
        0.996819, 3.00511e-05, 0, 0, 
        0.988837, 1.85092e-05, 0, 1.68222e-07, 
        0.982178, 1.34622e-05, 0, 0.000259622, 
        0.975017, 1.25961e-05, 0, 0.00142595, 
        0.967101, 1.3507e-05, 0, 0.00382273, 
        0.964905, 2.05003e-05, 0, 0.00764164, 
        0.96218, 2.9546e-05, 0, 0.0130121, 
        0.956821, 3.43738e-05, 0, 0.0200253, 
        0.948829, 3.05063e-05, 0, 0.0287452, 
        0.941092, 3.46487e-05, 0, 0.039218, 
        0.931883, 4.12061e-05, 0, 0.0514748, 
        0.920211, 4.44651e-05, 0, 0.0655351, 
        0.907307, 4.31252e-05, 0, 0.0814082, 
        0.89684, 4.90382e-05, 0, 0.0990939, 
        0.884119, 5.3334e-05, 0, 0.118583, 
        0.869148, 5.4114e-05, 0, 0.139856, 
        0.853377, 5.78536e-05, 0, 0.162882, 
        0.836753, 5.92285e-05, 0, 0.187615, 
        0.820063, 6.22787e-05, 0, 0.213991, 
        0.801694, 6.45492e-05, 0, 0.241918, 
        0.782116, 6.5353e-05, 0, 0.271267, 
        0.762673, 6.74344e-05, 0, 0.301847, 
        0.742133, 6.82788e-05, 0, 0.333333, 
        0.720779, 6.91959e-05, 0, 0.365079, 
        0.699386, 6.96817e-05, 0, 0.396826, 
        0.67732, 6.99583e-05, 0, 0.428572, 
        0.654888, 6.98447e-05, 0, 0.460318, 
        0.632499, 6.94063e-05, 0, 0.492064, 
        0.609825, 6.91612e-05, 0, 0.52381, 
        0.587287, 6.81576e-05, 0, 0.555556, 
        0.564743, 6.74138e-05, 0, 0.587302, 
        0.542409, 6.61617e-05, 0, 0.619048, 
        0.520282, 6.47785e-05, 0, 0.650794, 
        0.498506, 6.33836e-05, 0, 0.68254, 
        0.477102, 6.15905e-05, 0, 0.714286, 
        0.456167, 6.01013e-05, 0, 0.746032, 
        0.435728, 5.81457e-05, 0, 0.777778, 
        0.415809, 5.64215e-05, 0, 0.809524, 
        0.396517, 5.44997e-05, 0, 0.84127, 
        0.377737, 5.25061e-05, 0, 0.873016, 
        0.359698, 5.06831e-05, 0, 0.904762, 
        0.342164, 4.8568e-05, 0, 0.936508, 
        0.325417, 4.67826e-05, 0, 0.968254, 
        0.309186, 4.46736e-05, 0, 1, 
        1, 1.09018e-09, 0, 0, 
        1, 1.0904e-09, 0, 0, 
        1, 1.09393e-09, 0, 0, 
        1, 1.1095e-09, 0, 0, 
        1, 1.154e-09, 0, 0, 
        1, 1.26089e-09, 0, 0, 
        0.999999, 1.5059e-09, 0, 0, 
        0.999997, 2.07899e-09, 0, 0, 
        0.999994, 3.48164e-09, 0, 0, 
        0.999993, 7.05728e-09, 0, 0, 
        0.999987, 1.63692e-08, 0, 0, 
        0.999981, 4.06033e-08, 0, 0, 
        0.999969, 1.0245e-07, 0, 0, 
        0.999953, 2.55023e-07, 0, 0, 
        0.999925, 6.1511e-07, 0, 0, 
        0.999881, 1.42218e-06, 0, 0, 
        0.99981, 3.13086e-06, 0, 0, 
        0.99968, 6.53119e-06, 0, 0, 
        0.999418, 1.2832e-05, 0, 0, 
        0.998748, 2.32497e-05, 0, 0, 
        0.996066, 3.29522e-05, 0, 0, 
        0.988379, 1.79613e-05, 0, 0.000108799, 
        0.982567, 1.43715e-05, 0, 0.000921302, 
        0.976097, 1.48096e-05, 0, 0.00280738, 
        0.968475, 1.78905e-05, 0, 0.00596622, 
        0.964606, 2.53921e-05, 0, 0.0105284, 
        0.961564, 3.48623e-05, 0, 0.0165848, 
        0.955517, 3.57612e-05, 0, 0.0242, 
        0.948381, 3.43493e-05, 0, 0.03342, 
        0.941095, 4.05849e-05, 0, 0.0442777, 
        0.931923, 4.75394e-05, 0, 0.0567958, 
        0.91996, 4.84328e-05, 0, 0.0709879, 
        0.907419, 5.02146e-05, 0, 0.086861, 
        0.89618, 5.61654e-05, 0, 0.104415, 
        0.88337, 5.87612e-05, 0, 0.123643, 
        0.869046, 6.18057e-05, 0, 0.144531, 
        0.853278, 6.57392e-05, 0, 0.167057, 
        0.836091, 6.6303e-05, 0, 0.191188, 
        0.819644, 7.04445e-05, 0, 0.216878, 
        0.801246, 7.14071e-05, 0, 0.244062, 
        0.782031, 7.40093e-05, 0, 0.272649, 
        0.762066, 7.4685e-05, 0, 0.302509, 
        0.741964, 7.66647e-05, 0, 0.333442, 
        0.720554, 7.66328e-05, 0, 0.365079, 
        0.699098, 7.77857e-05, 0, 0.396826, 
        0.677189, 7.74633e-05, 0, 0.428572, 
        0.65484, 7.76235e-05, 0, 0.460318, 
        0.632496, 7.70316e-05, 0, 0.492064, 
        0.609908, 7.62669e-05, 0, 0.52381, 
        0.587312, 7.53972e-05, 0, 0.555556, 
        0.564938, 7.39994e-05, 0, 0.587302, 
        0.542577, 7.28382e-05, 0, 0.619048, 
        0.52062, 7.1112e-05, 0, 0.650794, 
        0.498819, 6.94004e-05, 0, 0.68254, 
        0.477555, 6.75575e-05, 0, 0.714286, 
        0.456568, 6.53449e-05, 0, 0.746032, 
        0.436278, 6.36068e-05, 0, 0.777778, 
        0.41637, 6.13466e-05, 0, 0.809524, 
        0.397144, 5.94177e-05, 0, 0.84127, 
        0.378412, 5.70987e-05, 0, 0.873016, 
        0.360376, 5.50419e-05, 0, 0.904762, 
        0.342906, 5.27422e-05, 0, 0.936508, 
        0.326136, 5.06544e-05, 0, 0.968254, 
        0.30997, 4.84307e-05, 0, 1, 
        1, 3.54014e-09, 0, 0, 
        1, 3.54073e-09, 0, 0, 
        1, 3.54972e-09, 0, 0, 
        1, 3.58929e-09, 0, 0, 
        1, 3.70093e-09, 0, 0, 
        0.999999, 3.96194e-09, 0, 0, 
        0.999998, 4.53352e-09, 0, 0, 
        0.999997, 5.78828e-09, 0, 0, 
        0.999994, 8.63812e-09, 0, 0, 
        0.999991, 1.53622e-08, 0, 0, 
        0.999985, 3.16356e-08, 0, 0, 
        0.999977, 7.12781e-08, 0, 0, 
        0.999964, 1.66725e-07, 0, 0, 
        0.999945, 3.90501e-07, 0, 0, 
        0.999912, 8.95622e-07, 0, 0, 
        0.999866, 1.98428e-06, 0, 0, 
        0.999786, 4.21038e-06, 0, 0, 
        0.999647, 8.50239e-06, 0, 0, 
        0.999356, 1.62059e-05, 0, 0, 
        0.998563, 2.82652e-05, 0, 0, 
        0.994928, 3.36309e-05, 0, 2.44244e-05, 
        0.987999, 1.78458e-05, 0, 0.000523891, 
        0.982893, 1.59162e-05, 0, 0.00194729, 
        0.977044, 1.78056e-05, 0, 0.00451099, 
        0.969972, 2.30624e-05, 0, 0.00835132, 
        0.964237, 3.13922e-05, 0, 0.013561, 
        0.960791, 4.06145e-05, 0, 0.0202056, 
        0.954292, 3.72796e-05, 0, 0.0283321, 
        0.948052, 4.03199e-05, 0, 0.0379739, 
        0.940938, 4.79537e-05, 0, 0.0491551, 
        0.931689, 5.45292e-05, 0, 0.0618918, 
        0.91987, 5.4038e-05, 0, 0.0761941, 
        0.907665, 5.89909e-05, 0, 0.0920672, 
        0.895281, 6.42651e-05, 0, 0.109511, 
        0.882621, 6.59707e-05, 0, 0.12852, 
        0.86873, 7.09973e-05, 0, 0.149085, 
        0.853008, 7.42221e-05, 0, 0.171189, 
        0.835944, 7.61754e-05, 0, 0.194809, 
        0.818949, 7.97052e-05, 0, 0.21991, 
        0.800951, 8.12434e-05, 0, 0.246447, 
        0.781847, 8.38075e-05, 0, 0.274352, 
        0.761649, 8.4501e-05, 0, 0.303535, 
        0.74152, 8.60258e-05, 0, 0.333857, 
        0.720495, 8.66233e-05, 0, 0.365104, 
        0.698742, 8.68326e-05, 0, 0.396826, 
        0.677096, 8.7133e-05, 0, 0.428572, 
        0.654782, 8.63497e-05, 0, 0.460318, 
        0.632335, 8.60206e-05, 0, 0.492064, 
        0.610031, 8.49337e-05, 0, 0.52381, 
        0.587457, 8.38279e-05, 0, 0.555556, 
        0.56513, 8.2309e-05, 0, 0.587302, 
        0.542877, 8.03542e-05, 0, 0.619048, 
        0.5209, 7.86928e-05, 0, 0.650794, 
        0.499291, 7.65171e-05, 0, 0.68254, 
        0.477971, 7.44753e-05, 0, 0.714286, 
        0.457221, 7.2209e-05, 0, 0.746032, 
        0.436803, 6.97448e-05, 0, 0.777778, 
        0.417083, 6.75333e-05, 0, 0.809524, 
        0.397749, 6.48058e-05, 0, 0.84127, 
        0.379177, 6.25759e-05, 0, 0.873016, 
        0.361061, 5.98584e-05, 0, 0.904762, 
        0.343713, 5.75797e-05, 0, 0.936508, 
        0.326894, 5.49999e-05, 0, 0.968254, 
        0.310816, 5.27482e-05, 0, 1, 
        1, 1.0153e-08, 0, 0, 
        1, 1.01544e-08, 0, 0, 
        1, 1.01751e-08, 0, 0, 
        1, 1.02662e-08, 0, 0, 
        1, 1.0521e-08, 0, 0, 
        0.999999, 1.11049e-08, 0, 0, 
        0.999999, 1.23408e-08, 0, 0, 
        0.999996, 1.4924e-08, 0, 0, 
        0.999992, 2.04471e-08, 0, 0, 
        0.999989, 3.26539e-08, 0, 0, 
        0.99998, 6.03559e-08, 0, 0, 
        0.999971, 1.23936e-07, 0, 0, 
        0.999955, 2.69058e-07, 0, 0, 
        0.999933, 5.93604e-07, 0, 0, 
        0.999901, 1.29633e-06, 0, 0, 
        0.999847, 2.75621e-06, 0, 0, 
        0.999761, 5.64494e-06, 0, 0, 
        0.999607, 1.10485e-05, 0, 0, 
        0.999282, 2.04388e-05, 0, 0, 
        0.99831, 3.41084e-05, 0, 2.2038e-07, 
        0.993288, 2.94949e-05, 0, 0.000242388, 
        0.987855, 1.92736e-05, 0, 0.0012503, 
        0.983167, 1.82383e-05, 0, 0.0032745, 
        0.977908, 2.18633e-05, 0, 0.00646321, 
        0.971194, 2.90662e-05, 0, 0.0109133, 
        0.963867, 3.86401e-05, 0, 0.0166927, 
        0.95982, 4.62827e-05, 0, 0.0238494, 
        0.953497, 4.20705e-05, 0, 0.0324178, 
        0.947621, 4.77743e-05, 0, 0.0424225, 
        0.940611, 5.68258e-05, 0, 0.0538808, 
        0.931174, 6.18061e-05, 0, 0.0668047, 
        0.919919, 6.27098e-05, 0, 0.0812014, 
        0.907856, 6.94714e-05, 0, 0.0970745, 
        0.894509, 7.35008e-05, 0, 0.114424, 
        0.881954, 7.63369e-05, 0, 0.133246, 
        0.868309, 8.21896e-05, 0, 0.153534, 
        0.852511, 8.3769e-05, 0, 0.175275, 
        0.835821, 8.81615e-05, 0, 0.198453, 
        0.817981, 8.96368e-05, 0, 0.223042, 
        0.800504, 9.30906e-05, 0, 0.249009, 
        0.78141, 9.45056e-05, 0, 0.276304, 
        0.761427, 9.63605e-05, 0, 0.304862, 
        0.74094, 9.68088e-05, 0, 0.334584, 
        0.720233, 9.81481e-05, 0, 0.365322, 
        0.698592, 9.79122e-05, 0, 0.396826, 
        0.676763, 9.81057e-05, 0, 0.428571, 
        0.654808, 9.73956e-05, 0, 0.460318, 
        0.632326, 9.62619e-05, 0, 0.492064, 
        0.610049, 9.52996e-05, 0, 0.52381, 
        0.58763, 9.33334e-05, 0, 0.555556, 
        0.565261, 9.17573e-05, 0, 0.587302, 
        0.543244, 8.96636e-05, 0, 0.619048, 
        0.521273, 8.73304e-05, 0, 0.650794, 
        0.499818, 8.52648e-05, 0, 0.68254, 
        0.478536, 8.23961e-05, 0, 0.714286, 
        0.457826, 7.9939e-05, 0, 0.746032, 
        0.437549, 7.7126e-05, 0, 0.777778, 
        0.41776, 7.43043e-05, 0, 0.809524, 
        0.39863, 7.16426e-05, 0, 0.84127, 
        0.379954, 6.86456e-05, 0, 0.873016, 
        0.362025, 6.60514e-05, 0, 0.904762, 
        0.344581, 6.30755e-05, 0, 0.936508, 
        0.327909, 6.05439e-05, 0, 0.968254, 
        0.311736, 5.76345e-05, 0, 1, 
        1, 2.63344e-08, 0, 0, 
        1, 2.63373e-08, 0, 0, 
        1, 2.63815e-08, 0, 0, 
        1, 2.65753e-08, 0, 0, 
        1, 2.71132e-08, 0, 0, 
        0.999999, 2.83279e-08, 0, 0, 
        0.999997, 3.0833e-08, 0, 0, 
        0.999995, 3.58711e-08, 0, 0, 
        0.999992, 4.61266e-08, 0, 0, 
        0.999985, 6.7574e-08, 0, 0, 
        0.999977, 1.1358e-07, 0, 0, 
        0.999966, 2.13657e-07, 0, 0, 
        0.999948, 4.31151e-07, 0, 0, 
        0.999923, 8.96656e-07, 0, 0, 
        0.999884, 1.86603e-06, 0, 0, 
        0.999826, 3.81115e-06, 0, 0, 
        0.999732, 7.54184e-06, 0, 0, 
        0.999561, 1.43192e-05, 0, 0, 
        0.999191, 2.57061e-05, 0, 0, 
        0.997955, 4.05724e-05, 0, 7.44132e-05, 
        0.992228, 2.76537e-05, 0, 0.000716477, 
        0.987638, 2.08885e-05, 0, 0.0022524, 
        0.983395, 2.15226e-05, 0, 0.00484816, 
        0.978614, 2.70795e-05, 0, 0.00860962, 
        0.972389, 3.65282e-05, 0, 0.0136083, 
        0.964392, 4.74747e-05, 0, 0.0198941, 
        0.95861, 5.09141e-05, 0, 0.0275023, 
        0.952806, 4.8963e-05, 0, 0.0364584, 
        0.94712, 5.71119e-05, 0, 0.04678, 
        0.940104, 6.71704e-05, 0, 0.0584799, 
        0.930398, 6.87586e-05, 0, 0.0715665, 
        0.919866, 7.38161e-05, 0, 0.086045, 
        0.907853, 8.13235e-05, 0, 0.101918, 
        0.894078, 8.34582e-05, 0, 0.119186, 
        0.881177, 8.92093e-05, 0, 0.137845, 
        0.867575, 9.44548e-05, 0, 0.157891, 
        0.852107, 9.69607e-05, 0, 0.179316, 
        0.835502, 0.000101456, 0, 0.202106, 
        0.81756, 0.000103256, 0, 0.226243, 
        0.79984, 0.000106954, 0, 0.251704, 
        0.780998, 0.000108066, 0, 0.278451, 
        0.761132, 0.000110111, 0, 0.306436, 
        0.740429, 0.000110459, 0, 0.335586, 
        0.719836, 0.000111219, 0, 0.365796, 
        0.698467, 0.00011145, 0, 0.3969, 
        0.676446, 0.000110393, 0, 0.428571, 
        0.654635, 0.000110035, 0, 0.460318, 
        0.632411, 0.000108548, 0, 0.492064, 
        0.609986, 0.000106963, 0, 0.52381, 
        0.587872, 0.000105238, 0, 0.555556, 
        0.565528, 0.000102665, 0, 0.587302, 
        0.543563, 0.000100543, 0, 0.619048, 
        0.52176, 9.76182e-05, 0, 0.650794, 
        0.500188, 9.47099e-05, 0, 0.68254, 
        0.479204, 9.19929e-05, 0, 0.714286, 
        0.458413, 8.86139e-05, 0, 0.746032, 
        0.438314, 8.57839e-05, 0, 0.777778, 
        0.418573, 8.2411e-05, 0, 0.809524, 
        0.39947, 7.92211e-05, 0, 0.84127, 
        0.380892, 7.59546e-05, 0, 0.873016, 
        0.362953, 7.27571e-05, 0, 0.904762, 
        0.345601, 6.95738e-05, 0, 0.936508, 
        0.328895, 6.64907e-05, 0, 0.968254, 
        0.312808, 6.34277e-05, 0, 1, 
        1, 6.28647e-08, 0, 0, 
        1, 6.28705e-08, 0, 0, 
        1, 6.29587e-08, 0, 0, 
        1, 6.33441e-08, 0, 0, 
        0.999999, 6.44087e-08, 0, 0, 
        0.999998, 6.67856e-08, 0, 0, 
        0.999997, 7.15889e-08, 0, 0, 
        0.999995, 8.09577e-08, 0, 0, 
        0.999989, 9.92764e-08, 0, 0, 
        0.999983, 1.35834e-07, 0, 0, 
        0.999974, 2.10482e-07, 0, 0, 
        0.999959, 3.65215e-07, 0, 0, 
        0.999939, 6.86693e-07, 0, 0, 
        0.999911, 1.3472e-06, 0, 0, 
        0.999868, 2.6731e-06, 0, 0, 
        0.999804, 5.24756e-06, 0, 0, 
        0.9997, 1.00403e-05, 0, 0, 
        0.99951, 1.85019e-05, 0, 0, 
        0.999078, 3.22036e-05, 0, 6.20676e-06, 
        0.997428, 4.70002e-05, 0, 0.000341552, 
        0.99162, 2.87123e-05, 0, 0.00143727, 
        0.987479, 2.34706e-05, 0, 0.00349201, 
        0.983582, 2.60083e-05, 0, 0.0066242, 
        0.979186, 3.37927e-05, 0, 0.0109113, 
        0.97325, 4.54689e-05, 0, 0.0164064, 
        0.965221, 5.73759e-05, 0, 0.0231463, 
        0.957262, 5.44114e-05, 0, 0.0311571, 
        0.952211, 5.87006e-05, 0, 0.0404572, 
        0.946631, 6.92256e-05, 0, 0.0510592, 
        0.939391, 7.87819e-05, 0, 0.0629723, 
        0.929795, 7.92368e-05, 0, 0.0762025, 
        0.91965, 8.75075e-05, 0, 0.090753, 
        0.907737, 9.50903e-05, 0, 0.106626, 
        0.893899, 9.72963e-05, 0, 0.123822, 
        0.880239, 0.00010459, 0, 0.142337, 
        0.866562, 0.000107689, 0, 0.16217, 
        0.85164, 0.000113081, 0, 0.183314, 
        0.835021, 0.000116636, 0, 0.20576, 
        0.817311, 0.000120074, 0, 0.229496, 
        0.798845, 0.000121921, 0, 0.254502, 
        0.780479, 0.00012475, 0, 0.280753, 
        0.760694, 0.000125255, 0, 0.308212, 
        0.740142, 0.000126719, 0, 0.336825, 
        0.719248, 0.00012636, 0, 0.366517, 
        0.698209, 0.000126712, 0, 0.397167, 
        0.676398, 0.000125769, 0, 0.428578, 
        0.654378, 0.000124432, 0, 0.460318, 
        0.632484, 0.000123272, 0, 0.492064, 
        0.610113, 0.00012085, 0, 0.52381, 
        0.587931, 0.000118411, 0, 0.555556, 
        0.565872, 0.00011569, 0, 0.587302, 
        0.543814, 0.000112521, 0, 0.619048, 
        0.522265, 0.000109737, 0, 0.650794, 
        0.500835, 0.000106228, 0, 0.68254, 
        0.479818, 0.000102591, 0, 0.714286, 
        0.459258, 9.91288e-05, 0, 0.746032, 
        0.439061, 9.52325e-05, 0, 0.777778, 
        0.419552, 9.1895e-05, 0, 0.809524, 
        0.400399, 8.79051e-05, 0, 0.84127, 
        0.381976, 8.44775e-05, 0, 0.873016, 
        0.364009, 8.06316e-05, 0, 0.904762, 
        0.346761, 7.71848e-05, 0, 0.936508, 
        0.330049, 7.35429e-05, 0, 0.968254, 
        0.314018, 7.02103e-05, 0, 1, 
        1, 1.39968e-07, 0, 0, 
        1, 1.39979e-07, 0, 0, 
        1, 1.40145e-07, 0, 0, 
        1, 1.4087e-07, 0, 0, 
        0.999999, 1.42865e-07, 0, 0, 
        0.999998, 1.47279e-07, 0, 0, 
        0.999997, 1.56057e-07, 0, 0, 
        0.999992, 1.7276e-07, 0, 0, 
        0.999989, 2.04352e-07, 0, 0, 
        0.99998, 2.6494e-07, 0, 0, 
        0.999969, 3.83435e-07, 0, 0, 
        0.999953, 6.18641e-07, 0, 0, 
        0.999929, 1.08755e-06, 0, 0, 
        0.999898, 2.01497e-06, 0, 0, 
        0.999849, 3.81346e-06, 0, 0, 
        0.999778, 7.19815e-06, 0, 0, 
        0.999661, 1.33215e-05, 0, 0, 
        0.999451, 2.38313e-05, 0, 0, 
        0.998936, 4.01343e-05, 0, 0.000113724, 
        0.99662, 5.17346e-05, 0, 0.000820171, 
        0.991094, 3.04323e-05, 0, 0.00238143, 
        0.987487, 2.81757e-05, 0, 0.00493527, 
        0.983731, 3.20048e-05, 0, 0.00856859, 
        0.979647, 4.23905e-05, 0, 0.0133393, 
        0.973837, 5.62935e-05, 0, 0.0192863, 
        0.96584, 6.77442e-05, 0, 0.0264369, 
        0.956309, 6.23073e-05, 0, 0.03481, 
        0.951523, 7.04131e-05, 0, 0.0444184, 
        0.946003, 8.36594e-05, 0, 0.0552713, 
        0.938454, 9.11736e-05, 0, 0.0673749, 
        0.929279, 9.38264e-05, 0, 0.0807329, 
        0.919239, 0.000103754, 0, 0.0953479, 
        0.907293, 0.000109928, 0, 0.111221, 
        0.893936, 0.000115257, 0, 0.128352, 
        0.879674, 0.000122265, 0, 0.14674, 
        0.865668, 0.000125733, 0, 0.166382, 
        0.850998, 0.000132305, 0, 0.187276, 
        0.834498, 0.000134844, 0, 0.209413, 
        0.816903, 0.000139276, 0, 0.232786, 
        0.798235, 0.000140984, 0, 0.257382, 
        0.779724, 0.00014378, 0, 0.283181, 
        0.760251, 0.000144623, 0, 0.310156, 
        0.739808, 0.000145228, 0, 0.338269, 
        0.718762, 0.00014539, 0, 0.367461, 
        0.697815, 0.000144432, 0, 0.397646, 
        0.67631, 0.000143893, 0, 0.428685, 
        0.654278, 0.000141846, 0, 0.460318, 
        0.632347, 0.00013935, 0, 0.492064, 
        0.610296, 0.000137138, 0, 0.52381, 
        0.588039, 0.000133806, 0, 0.555556, 
        0.566218, 0.000130755, 0, 0.587302, 
        0.544346, 0.000127128, 0, 0.619048, 
        0.522701, 0.000123002, 0, 0.650794, 
        0.501542, 0.000119443, 0, 0.68254, 
        0.480508, 0.000115055, 0, 0.714286, 
        0.460092, 0.000111032, 0, 0.746032, 
        0.440021, 0.000106635, 0, 0.777778, 
        0.420446, 0.000102162, 0, 0.809524, 
        0.401512, 9.8184e-05, 0, 0.84127, 
        0.38299, 9.36497e-05, 0, 0.873016, 
        0.365232, 8.9813e-05, 0, 0.904762, 
        0.347865, 8.53073e-05, 0, 0.936508, 
        0.331342, 8.17068e-05, 0, 0.968254, 
        0.315202, 7.73818e-05, 0, 1, 
        1, 2.9368e-07, 0, 0, 
        1, 2.937e-07, 0, 0, 
        1, 2.93998e-07, 0, 0, 
        1, 2.95298e-07, 0, 0, 
        0.999999, 2.98865e-07, 0, 0, 
        0.999998, 3.067e-07, 0, 0, 
        0.999995, 3.22082e-07, 0, 0, 
        0.999992, 3.50767e-07, 0, 0, 
        0.999986, 4.03538e-07, 0, 0, 
        0.999976, 5.01372e-07, 0, 0, 
        0.999964, 6.8562e-07, 0, 0, 
        0.999945, 1.0374e-06, 0, 0, 
        0.999919, 1.71269e-06, 0, 0, 
        0.999882, 3.00175e-06, 0, 0, 
        0.999829, 5.42144e-06, 0, 0, 
        0.999749, 9.84182e-06, 0, 0, 
        0.99962, 1.76213e-05, 0, 0, 
        0.999382, 3.05995e-05, 0, 1.38418e-05, 
        0.998751, 4.96686e-05, 0, 0.000389844, 
        0.995344, 5.10733e-05, 0, 0.00150343, 
        0.990768, 3.45829e-05, 0, 0.00352451, 
        0.987464, 3.42841e-05, 0, 0.00655379, 
        0.983846, 3.99072e-05, 0, 0.0106554, 
        0.980007, 5.33219e-05, 0, 0.0158723, 
        0.974494, 6.96992e-05, 0, 0.0222333, 
        0.96622, 7.76754e-05, 0, 0.029758, 
        0.956273, 7.47718e-05, 0, 0.0384596, 
        0.950952, 8.64611e-05, 0, 0.0483473, 
        0.945215, 0.000100464, 0, 0.0594266, 
        0.937287, 0.000103729, 0, 0.0717019, 
        0.928649, 0.000111665, 0, 0.0851752, 
        0.918791, 0.00012353, 0, 0.0998479, 
        0.906685, 0.000127115, 0, 0.115721, 
        0.893706, 0.00013628, 0, 0.132794, 
        0.879248, 0.000142427, 0, 0.151067, 
        0.864685, 0.000148091, 0, 0.170538, 
        0.850032, 0.000153517, 0, 0.191204, 
        0.833853, 0.000157322, 0, 0.213063, 
        0.816353, 0.000161086, 0, 0.236107, 
        0.797834, 0.000164111, 0, 0.260329, 
        0.778831, 0.000165446, 0, 0.285714, 
        0.759756, 0.000167492, 0, 0.312243, 
        0.739419, 0.000166928, 0, 0.339887, 
        0.718491, 0.000167, 0, 0.368604, 
        0.697392, 0.000165674, 0, 0.398329, 
        0.676102, 0.000163815, 0, 0.428961, 
        0.654243, 0.000162003, 0, 0.460331, 
        0.632176, 0.000158831, 0, 0.492064, 
        0.610407, 0.000155463, 0, 0.52381, 
        0.588394, 0.000152062, 0, 0.555556, 
        0.56645, 0.000147665, 0, 0.587302, 
        0.5449, 0.00014375, 0, 0.619048, 
        0.523276, 0.000138905, 0, 0.650794, 
        0.502179, 0.000134189, 0, 0.68254, 
        0.481359, 0.000129392, 0, 0.714286, 
        0.46092, 0.000124556, 0, 0.746032, 
        0.441084, 0.00011957, 0, 0.777778, 
        0.421517, 0.000114652, 0, 0.809524, 
        0.402721, 0.000109688, 0, 0.84127, 
        0.384222, 0.000104667, 0, 0.873016, 
        0.366534, 9.99633e-05, 0, 0.904762, 
        0.349205, 9.50177e-05, 0, 0.936508, 
        0.332702, 9.07301e-05, 0, 0.968254, 
        0.316599, 8.59769e-05, 0, 1, 
        1, 5.85473e-07, 0, 0, 
        1, 5.85507e-07, 0, 0, 
        1, 5.8602e-07, 0, 0, 
        0.999999, 5.88259e-07, 0, 0, 
        0.999999, 5.94381e-07, 0, 0, 
        0.999998, 6.07754e-07, 0, 0, 
        0.999995, 6.33729e-07, 0, 0, 
        0.99999, 6.8137e-07, 0, 0, 
        0.999984, 7.67003e-07, 0, 0, 
        0.999973, 9.21212e-07, 0, 0, 
        0.999959, 1.20218e-06, 0, 0, 
        0.999936, 1.72024e-06, 0, 0, 
        0.999907, 2.68088e-06, 0, 0, 
        0.999866, 4.45512e-06, 0, 0, 
        0.999806, 7.68481e-06, 0, 0, 
        0.999716, 1.342e-05, 0, 0, 
        0.999576, 2.32473e-05, 0, 0, 
        0.9993, 3.91694e-05, 0, 0.000129917, 
        0.998498, 6.08429e-05, 0, 0.000845035, 
        0.994132, 4.89743e-05, 0, 0.00237616, 
        0.99031, 3.84644e-05, 0, 0.00484456, 
        0.987409, 4.21768e-05, 0, 0.00832472, 
        0.983981, 5.04854e-05, 0, 0.0128643, 
        0.980268, 6.71028e-05, 0, 0.0184947, 
        0.974875, 8.52749e-05, 0, 0.025237, 
        0.966063, 8.5531e-05, 0, 0.0331046, 
        0.956779, 9.00588e-05, 0, 0.0421067, 
        0.950259, 0.00010577, 0, 0.0522487, 
        0.944239, 0.000119458, 0, 0.0635343, 
        0.936341, 0.000122164, 0, 0.0759654, 
        0.928047, 0.000134929, 0, 0.0895434, 
        0.918065, 0.000145544, 0, 0.104269, 
        0.906267, 0.000150531, 0, 0.120142, 
        0.893419, 0.000161652, 0, 0.137163, 
        0.878758, 0.00016593, 0, 0.15533, 
        0.863699, 0.000174014, 0, 0.174645, 
        0.848876, 0.000177877, 0, 0.195106, 
        0.833032, 0.000184049, 0, 0.21671, 
        0.815557, 0.000186088, 0, 0.239454, 
        0.797323, 0.00019054, 0, 0.263332, 
        0.778124, 0.000191765, 0, 0.288336, 
        0.758929, 0.000192535, 0, 0.314451, 
        0.738979, 0.000192688, 0, 0.341658, 
        0.718213, 0.000191522, 0, 0.369924, 
        0.696947, 0.000190491, 0, 0.399202, 
        0.675807, 0.000187913, 0, 0.429416, 
        0.654147, 0.000184451, 0, 0.460447, 
        0.63229, 0.000181442, 0, 0.492064, 
        0.610499, 0.000177139, 0, 0.523809, 
        0.588747, 0.000172596, 0, 0.555555, 
        0.566783, 0.000167457, 0, 0.587301, 
        0.545359, 0.000162518, 0, 0.619048, 
        0.523984, 0.000156818, 0, 0.650794, 
        0.502917, 0.000151884, 0, 0.68254, 
        0.482294, 0.000145514, 0, 0.714286, 
        0.461945, 0.000140199, 0, 0.746032, 
        0.442133, 0.000134101, 0, 0.777778, 
        0.422705, 0.000128374, 0, 0.809524, 
        0.403916, 0.000122996, 0, 0.84127, 
        0.38554, 0.000116808, 0, 0.873016, 
        0.367909, 0.000111973, 0, 0.904762, 
        0.350651, 0.000105938, 0, 0.936508, 
        0.334208, 0.000101355, 0, 0.968254, 
        0.318123, 9.57629e-05, 0, 1, 
        1, 1.11633e-06, 0, 0, 
        1, 1.11639e-06, 0, 0, 
        1, 1.11725e-06, 0, 0, 
        1, 1.12096e-06, 0, 0, 
        0.999999, 1.1311e-06, 0, 0, 
        0.999997, 1.15315e-06, 0, 0, 
        0.999995, 1.1956e-06, 0, 0, 
        0.999989, 1.27239e-06, 0, 0, 
        0.999981, 1.40772e-06, 0, 0, 
        0.999969, 1.64541e-06, 0, 0, 
        0.999952, 2.06607e-06, 0, 0, 
        0.999928, 2.81783e-06, 0, 0, 
        0.999895, 4.16835e-06, 0, 0, 
        0.999848, 6.58728e-06, 0, 0, 
        0.999781, 1.08648e-05, 0, 0, 
        0.999682, 1.82579e-05, 0, 0, 
        0.999523, 3.06003e-05, 0, 1.59122e-05, 
        0.999205, 4.99862e-05, 0, 0.000391184, 
        0.998131, 7.3306e-05, 0, 0.00147534, 
        0.993334, 5.13229e-05, 0, 0.0034227, 
        0.99016, 4.67783e-05, 0, 0.00632232, 
        0.987321, 5.23413e-05, 0, 0.0102295, 
        0.984099, 6.4267e-05, 0, 0.0151794, 
        0.980432, 8.43042e-05, 0, 0.0211947, 
        0.974976, 0.000102819, 0, 0.0282899, 
        0.966429, 9.96234e-05, 0, 0.0364739, 
        0.957633, 0.000111074, 0, 0.0457522, 
        0.949422, 0.000128644, 0, 0.0561278, 
        0.943045, 0.000140076, 0, 0.0676023, 
        0.935448, 0.000146349, 0, 0.0801762, 
        0.927225, 0.000161854, 0, 0.0938499, 
        0.917033, 0.000169135, 0, 0.108623, 
        0.905762, 0.000179987, 0, 0.124496, 
        0.892879, 0.000189832, 0, 0.141469, 
        0.878435, 0.000195881, 0, 0.159541, 
        0.863114, 0.00020466, 0, 0.178713, 
        0.84776, 0.000209473, 0, 0.198985, 
        0.832084, 0.000214861, 0, 0.220355, 
        0.814915, 0.000217695, 0, 0.242823, 
        0.796711, 0.000220313, 0, 0.266385, 
        0.777603, 0.00022313, 0, 0.291036, 
        0.757991, 0.000222471, 0, 0.316767, 
        0.738371, 0.000222869, 0, 0.343563, 
        0.717872, 0.000221243, 0, 0.371402, 
        0.696619, 0.000218089, 0, 0.400248, 
        0.675379, 0.00021562, 0, 0.430047, 
        0.65411, 0.00021169, 0, 0.460709, 
        0.63241, 0.000206947, 0, 0.492079, 
        0.61046, 0.000201709, 0, 0.52381, 
        0.58903, 0.000196753, 0, 0.555556, 
        0.567267, 0.000189637, 0, 0.587302, 
        0.545886, 0.000184735, 0, 0.619048, 
        0.524714, 0.000177257, 0, 0.650794, 
        0.503789, 0.000171424, 0, 0.68254, 
        0.483204, 0.000164688, 0, 0.714286, 
        0.462976, 0.000157172, 0, 0.746032, 
        0.443294, 0.000151341, 0, 0.777778, 
        0.423988, 0.000143737, 0, 0.809524, 
        0.405325, 0.000138098, 0, 0.84127, 
        0.386981, 0.000130698, 0, 0.873016, 
        0.369436, 0.000125276, 0, 0.904762, 
        0.35219, 0.000118349, 0, 0.936508, 
        0.335804, 0.00011312, 0, 0.968254, 
        0.319749, 0.000106687, 0, 1, 
        1, 2.04685e-06, 0, 0, 
        1, 2.04694e-06, 0, 0, 
        1, 2.04831e-06, 0, 0, 
        0.999999, 2.05428e-06, 0, 0, 
        0.999999, 2.07056e-06, 0, 0, 
        0.999997, 2.10581e-06, 0, 0, 
        0.999993, 2.1732e-06, 0, 0, 
        0.999987, 2.29365e-06, 0, 0, 
        0.999979, 2.50243e-06, 0, 0, 
        0.999965, 2.86127e-06, 0, 0, 
        0.999947, 3.48028e-06, 0, 0, 
        0.999918, 4.55588e-06, 0, 0, 
        0.999881, 6.43303e-06, 0, 0, 
        0.999828, 9.70064e-06, 0, 0, 
        0.999753, 1.53233e-05, 0, 0, 
        0.999642, 2.4793e-05, 0, 0, 
        0.999464, 4.02032e-05, 0, 0.000122947, 
        0.999089, 6.35852e-05, 0, 0.000807414, 
        0.997567, 8.57026e-05, 0, 0.00227206, 
        0.992903, 5.94912e-05, 0, 0.00462812, 
        0.990011, 5.78515e-05, 0, 0.00794162, 
        0.987192, 6.5399e-05, 0, 0.0122534, 
        0.98418, 8.19675e-05, 0, 0.0175888, 
        0.980491, 0.000105514, 0, 0.0239635, 
        0.974779, 0.000121532, 0, 0.031387, 
        0.96675, 0.000119144, 0, 0.0398644, 
        0.958248, 0.000136125, 0, 0.0493982, 
        0.948884, 0.000155408, 0, 0.0599896, 
        0.941673, 0.000162281, 0, 0.0716382, 
        0.934521, 0.000176754, 0, 0.0843437, 
        0.926205, 0.000192873, 0, 0.0981056, 
        0.916089, 0.000200038, 0, 0.112923, 
        0.904963, 0.000213624, 0, 0.128796, 
        0.892089, 0.000221834, 0, 0.145725, 
        0.878028, 0.000232619, 0, 0.163709, 
        0.86249, 0.000238632, 0, 0.182749, 
        0.846587, 0.000247002, 0, 0.202847, 
        0.830988, 0.000250702, 0, 0.224001, 
        0.814165, 0.000255562, 0, 0.246214, 
        0.796135, 0.000257505, 0, 0.269482, 
        0.777052, 0.000258625, 0, 0.293805, 
        0.757201, 0.000258398, 0, 0.319176, 
        0.737655, 0.000256714, 0, 0.345587, 
        0.717477, 0.000255187, 0, 0.373021, 
        0.696433, 0.000251792, 0, 0.401454, 
        0.675084, 0.000247223, 0, 0.430844, 
        0.653907, 0.000242213, 0, 0.461125, 
        0.632561, 0.000237397, 0, 0.492187, 
        0.610658, 0.000229313, 0, 0.52381, 
        0.589322, 0.000224402, 0, 0.555556, 
        0.567857, 0.000216116, 0, 0.587302, 
        0.54652, 0.000209124, 0, 0.619048, 
        0.525433, 0.000201601, 0, 0.650794, 
        0.504679, 0.000192957, 0, 0.68254, 
        0.484203, 0.000186052, 0, 0.714286, 
        0.464203, 0.000177672, 0, 0.746032, 
        0.444549, 0.000170005, 0, 0.777778, 
        0.425346, 0.000162401, 0, 0.809524, 
        0.406706, 0.0001544, 0, 0.84127, 
        0.388576, 0.000147437, 0, 0.873016, 
        0.37094, 0.000139493, 0, 0.904762, 
        0.353996, 0.000133219, 0, 0.936508, 
        0.337391, 0.000125573, 0, 0.968254, 
        0.321648, 0.000119867, 0, 1, 
        1, 3.62511e-06, 0, 0, 
        1, 3.62525e-06, 0, 0, 
        1, 3.62739e-06, 0, 0, 
        0.999999, 3.63673e-06, 0, 0, 
        0.999998, 3.66214e-06, 0, 0, 
        0.999996, 3.71698e-06, 0, 0, 
        0.999992, 3.82116e-06, 0, 0, 
        0.999986, 4.00554e-06, 0, 0, 
        0.999976, 4.32058e-06, 0, 0, 
        0.999961, 4.85194e-06, 0, 0, 
        0.999938, 5.74808e-06, 0, 0, 
        0.999908, 7.26643e-06, 0, 0, 
        0.999865, 9.84707e-06, 0, 0, 
        0.999807, 1.42217e-05, 0, 0, 
        0.999723, 2.15581e-05, 0, 0, 
        0.999602, 3.36114e-05, 0, 1.19113e-05, 
        0.999398, 5.27353e-05, 0, 0.000355813, 
        0.998946, 8.05809e-05, 0, 0.00137768, 
        0.996647, 9.42908e-05, 0, 0.00322469, 
        0.992298, 6.68733e-05, 0, 0.00597897, 
        0.989802, 7.16564e-05, 0, 0.00968903, 
        0.987019, 8.21355e-05, 0, 0.0143845, 
        0.984219, 0.000104555, 0, 0.0200831, 
        0.980425, 0.000131245, 0, 0.0267948, 
        0.974241, 0.000139613, 0, 0.034525, 
        0.967006, 0.000145931, 0, 0.0432757, 
        0.95893, 0.000167153, 0, 0.0530471, 
        0.949157, 0.000188146, 0, 0.0638386, 
        0.94062, 0.000194625, 0, 0.0756487, 
        0.933509, 0.000213721, 0, 0.0884762, 
        0.925088, 0.000229616, 0, 0.10232, 
        0.915178, 0.000239638, 0, 0.117178, 
        0.904093, 0.000254814, 0, 0.133051, 
        0.891337, 0.000263685, 0, 0.149939, 
        0.877326, 0.000274789, 0, 0.167841, 
        0.861794, 0.000280534, 0, 0.18676, 
        0.845758, 0.000289534, 0, 0.206696, 
        0.829792, 0.000294446, 0, 0.22765, 
        0.813037, 0.000296877, 0, 0.249625, 
        0.795285, 0.000300217, 0, 0.27262, 
        0.776323, 0.000299826, 0, 0.296636, 
        0.756673, 0.000299787, 0, 0.321671, 
        0.736856, 0.000297867, 0, 0.347718, 
        0.716883, 0.000294052, 0, 0.374768, 
        0.696089, 0.000289462, 0, 0.402804, 
        0.67505, 0.000285212, 0, 0.431796, 
        0.653509, 0.00027653, 0, 0.461695, 
        0.63258, 0.000271759, 0, 0.49242, 
        0.61104, 0.000262811, 0, 0.523822, 
        0.589567, 0.000255151, 0, 0.555556, 
        0.568322, 0.000246434, 0, 0.587302, 
        0.547235, 0.000237061, 0, 0.619048, 
        0.52616, 0.000228343, 0, 0.650794, 
        0.505716, 0.000219236, 0, 0.68254, 
        0.485274, 0.000209595, 0, 0.714286, 
        0.465411, 0.000201011, 0, 0.746032, 
        0.445854, 0.00019109, 0, 0.777778, 
        0.426911, 0.000182897, 0, 0.809524, 
        0.408222, 0.000173569, 0, 0.84127, 
        0.390307, 0.000165496, 0, 0.873016, 
        0.372624, 0.000156799, 0, 0.904762, 
        0.355804, 0.00014917, 0, 0.936508, 
        0.33924, 0.000140907, 0, 0.968254, 
        0.323534, 0.000134062, 0, 1, 
        1, 6.22487e-06, 0, 0, 
        1, 6.2251e-06, 0, 0, 
        1, 6.22837e-06, 0, 0, 
        0.999999, 6.24259e-06, 0, 0, 
        0.999998, 6.28127e-06, 0, 0, 
        0.999996, 6.36451e-06, 0, 0, 
        0.999991, 6.5218e-06, 0, 0, 
        0.999984, 6.79782e-06, 0, 0, 
        0.999973, 7.26361e-06, 0, 0, 
        0.999955, 8.03644e-06, 0, 0, 
        0.999931, 9.31397e-06, 0, 0, 
        0.999896, 1.14299e-05, 0, 0, 
        0.999847, 1.49402e-05, 0, 0, 
        0.999784, 2.07461e-05, 0, 0, 
        0.999692, 3.02493e-05, 0, 0, 
        0.999554, 4.54957e-05, 0, 9.97275e-05, 
        0.999326, 6.90762e-05, 0, 0.000724813, 
        0.998757, 0.000101605, 0, 0.0020972, 
        0.995367, 9.58745e-05, 0, 0.00432324, 
        0.99209, 8.32808e-05, 0, 0.00746347, 
        0.989517, 8.87601e-05, 0, 0.0115534, 
        0.987008, 0.00010564, 0, 0.0166134, 
        0.98421, 0.000133179, 0, 0.0226552, 
        0.98021, 0.000161746, 0, 0.0296838, 
        0.973676, 0.000161821, 0, 0.0377016, 
        0.967052, 0.000178635, 0, 0.0467079, 
        0.959385, 0.000206765, 0, 0.0567013, 
        0.949461, 0.00022476, 0, 0.0676796, 
        0.939578, 0.00023574, 0, 0.0796403, 
        0.932416, 0.00025893, 0, 0.0925812, 
        0.923759, 0.000271228, 0, 0.106501, 
        0.914223, 0.000289165, 0, 0.121397, 
        0.902942, 0.000301156, 0, 0.13727, 
        0.890419, 0.000313852, 0, 0.15412, 
        0.876639, 0.000324408, 0, 0.171946, 
        0.861316, 0.00033249, 0, 0.190751, 
        0.84496, 0.000338497, 0, 0.210537, 
        0.828427, 0.000345861, 0, 0.231305, 
        0.811871, 0.000347863, 0, 0.253057, 
        0.794397, 0.000350225, 0, 0.275797, 
        0.775726, 0.000349915, 0, 0.299525, 
        0.75617, 0.000347297, 0, 0.324242, 
        0.736091, 0.000344232, 0, 0.349947, 
        0.716213, 0.000340835, 0, 0.376633, 
        0.695736, 0.000332369, 0, 0.404289, 
        0.674961, 0.000327943, 0, 0.432895, 
        0.653518, 0.000318533, 0, 0.462415, 
        0.632574, 0.000310391, 0, 0.492788, 
        0.61134, 0.000300755, 0, 0.523909, 
        0.590017, 0.000290506, 0, 0.555556, 
        0.568752, 0.000280446, 0, 0.587302, 
        0.548061, 0.000269902, 0, 0.619048, 
        0.52711, 0.000258815, 0, 0.650794, 
        0.506682, 0.000248481, 0, 0.68254, 
        0.486524, 0.000237141, 0, 0.714286, 
        0.466812, 0.000226872, 0, 0.746032, 
        0.44732, 0.000216037, 0, 0.777778, 
        0.428473, 0.000205629, 0, 0.809524, 
        0.409921, 0.000195691, 0, 0.84127, 
        0.392028, 0.000185457, 0, 0.873016, 
        0.374606, 0.000176436, 0, 0.904762, 
        0.357601, 0.000166508, 0, 0.936508, 
        0.341348, 0.000158385, 0, 0.968254, 
        0.32542, 0.000149203, 0, 1, 
        1, 1.03967e-05, 0, 0, 
        1, 1.0397e-05, 0, 0, 
        1, 1.04019e-05, 0, 0, 
        0.999999, 1.04231e-05, 0, 0, 
        0.999998, 1.04806e-05, 0, 0, 
        0.999995, 1.06042e-05, 0, 0, 
        0.999991, 1.08366e-05, 0, 0, 
        0.999982, 1.12415e-05, 0, 0, 
        0.999968, 1.19174e-05, 0, 0, 
        0.99995, 1.30227e-05, 0, 0, 
        0.999922, 1.48176e-05, 0, 0, 
        0.999884, 1.77303e-05, 0, 0, 
        0.99983, 2.24564e-05, 0, 0, 
        0.999758, 3.00966e-05, 0, 0, 
        0.999654, 4.23193e-05, 0, 5.49083e-06, 
        0.999503, 6.14848e-05, 0, 0.000296087, 
        0.999237, 9.03576e-05, 0, 0.00123144, 
        0.998491, 0.0001271, 0, 0.00295954, 
        0.994594, 0.000107754, 0, 0.00555829, 
        0.99178, 0.000103025, 0, 0.00907209, 
        0.989265, 0.00011154, 0, 0.0135257, 
        0.986998, 0.000136296, 0, 0.0189327, 
        0.984137, 0.000169154, 0, 0.0252993, 
        0.979798, 0.000196671, 0, 0.0326272, 
        0.97337, 0.000196678, 0, 0.0409157, 
        0.967239, 0.000223121, 0, 0.0501623, 
        0.959543, 0.000253809, 0, 0.0603638, 
        0.949466, 0.000265972, 0, 0.0715171, 
        0.939074, 0.000288372, 0, 0.0836187, 
        0.931118, 0.000310983, 0, 0.0966657, 
        0.922525, 0.000325561, 0, 0.110656, 
        0.912983, 0.000345725, 0, 0.125588, 
        0.901617, 0.0003556, 0, 0.141461, 
        0.889487, 0.000374012, 0, 0.158275, 
        0.875787, 0.000383445, 0, 0.176031, 
        0.860654, 0.000393972, 0, 0.19473, 
        0.844417, 0.000400311, 0, 0.214374, 
        0.82741, 0.000405004, 0, 0.234967, 
        0.810545, 0.000407378, 0, 0.256512, 
        0.793312, 0.000407351, 0, 0.279011, 
        0.774847, 0.000406563, 0, 0.302468, 
        0.755621, 0.000404903, 0, 0.326887, 
        0.735511, 0.000397486, 0, 0.352266, 
        0.715435, 0.00039357, 0, 0.378605, 
        0.695403, 0.000384739, 0, 0.405897, 
        0.674681, 0.000376108, 0, 0.43413, 
        0.65359, 0.000365997, 0, 0.463277, 
        0.632471, 0.000354957, 0, 0.493295, 
        0.61151, 0.000343593, 0, 0.524106, 
        0.59064, 0.000331841, 0, 0.555561, 
        0.569386, 0.000318891, 0, 0.587302, 
        0.548785, 0.0003072, 0, 0.619048, 
        0.528146, 0.00029361, 0, 0.650794, 
        0.507872, 0.000281709, 0, 0.68254, 
        0.487805, 0.000268627, 0, 0.714286, 
        0.468196, 0.000255887, 0, 0.746032, 
        0.448922, 0.000243997, 0, 0.777778, 
        0.430093, 0.000231662, 0, 0.809524, 
        0.411845, 0.000220339, 0, 0.84127, 
        0.393808, 0.000208694, 0, 0.873016, 
        0.376615, 0.000198045, 0, 0.904762, 
        0.359655, 0.000187375, 0, 0.936508, 
        0.343452, 0.000177371, 0, 0.968254, 
        0.32765, 0.000167525, 0, 1, 
        1, 1.69351e-05, 0, 0, 
        1, 1.69356e-05, 0, 0, 
        1, 1.69427e-05, 0, 0, 
        0.999999, 1.69736e-05, 0, 0, 
        0.999998, 1.70575e-05, 0, 0, 
        0.999995, 1.72372e-05, 0, 0, 
        0.99999, 1.75739e-05, 0, 0, 
        0.999979, 1.81568e-05, 0, 0, 
        0.999966, 1.91206e-05, 0, 0, 
        0.999944, 2.0677e-05, 0, 0, 
        0.999912, 2.31644e-05, 0, 0, 
        0.999869, 2.71268e-05, 0, 0, 
        0.999811, 3.34272e-05, 0, 0, 
        0.99973, 4.33979e-05, 0, 0, 
        0.999617, 5.90083e-05, 0, 6.80315e-05, 
        0.999445, 8.29497e-05, 0, 0.000612796, 
        0.999138, 0.000118019, 0, 0.00187408, 
        0.998095, 0.000156712, 0, 0.00395791, 
        0.993919, 0.000125054, 0, 0.00692144, 
        0.991333, 0.000126091, 0, 0.0107962, 
        0.989226, 0.000144912, 0, 0.0155986, 
        0.986954, 0.000175737, 0, 0.0213364, 
        0.983982, 0.000213883, 0, 0.0280114, 
        0.979128, 0.000234526, 0, 0.0356226, 
        0.973327, 0.000243725, 0, 0.0441668, 
        0.967416, 0.0002773, 0, 0.0536399, 
        0.959729, 0.000308799, 0, 0.0640376, 
        0.949758, 0.000322447, 0, 0.0753554, 
        0.939173, 0.000350021, 0, 0.0875893, 
        0.9296, 0.000370089, 0, 0.100736, 
        0.921181, 0.000391365, 0, 0.114793, 
        0.91164, 0.000413636, 0, 0.129759, 
        0.900435, 0.000427068, 0, 0.145632, 
        0.888183, 0.000441046, 0, 0.162412, 
        0.874772, 0.000454968, 0, 0.180101, 
        0.859566, 0.000461882, 0, 0.1987, 
        0.843579, 0.000471556, 0, 0.218213, 
        0.826453, 0.000474335, 0, 0.238641, 
        0.809164, 0.000477078, 0, 0.259989, 
        0.792179, 0.00047755, 0, 0.282262, 
        0.773866, 0.000472573, 0, 0.305464, 
        0.754944, 0.000469765, 0, 0.329599, 
        0.735133, 0.000462371, 0, 0.35467, 
        0.714858, 0.000453674, 0, 0.380678, 
        0.694829, 0.000443888, 0, 0.407622, 
        0.674453, 0.000432052, 0, 0.435493, 
        0.653685, 0.000420315, 0, 0.464275, 
        0.632666, 0.000406829, 0, 0.493938, 
        0.611676, 0.000392234, 0, 0.524422, 
        0.591193, 0.000379208, 0, 0.555624, 
        0.570145, 0.00036319, 0, 0.587302, 
        0.549566, 0.000349111, 0, 0.619048, 
        0.529278, 0.000334166, 0, 0.650794, 
        0.509026, 0.000318456, 0, 0.68254, 
        0.489186, 0.00030449, 0, 0.714286, 
        0.469662, 0.000289051, 0, 0.746032, 
        0.450691, 0.000275494, 0, 0.777778, 
        0.431841, 0.000261437, 0, 0.809524, 
        0.413752, 0.000247846, 0, 0.84127, 
        0.395951, 0.000235085, 0, 0.873016, 
        0.378633, 0.000222245, 0, 0.904762, 
        0.36194, 0.000210533, 0, 0.936508, 
        0.345599, 0.000198494, 0, 0.968254, 
        0.329999, 0.000188133, 0, 1, 
        1, 2.69663e-05, 0, 0, 
        1, 2.6967e-05, 0, 0, 
        1, 2.69772e-05, 0, 0, 
        0.999999, 2.70214e-05, 0, 0, 
        0.999998, 2.71415e-05, 0, 0, 
        0.999994, 2.7398e-05, 0, 0, 
        0.999988, 2.78771e-05, 0, 0, 
        0.999977, 2.87019e-05, 0, 0, 
        0.999961, 3.00544e-05, 0, 0, 
        0.999937, 3.22138e-05, 0, 0, 
        0.999904, 3.56163e-05, 0, 0, 
        0.999854, 4.09465e-05, 0, 0, 
        0.99979, 4.92651e-05, 0, 0, 
        0.999699, 6.21722e-05, 0, 8.8288e-07, 
        0.999572, 8.19715e-05, 0, 0.000223369, 
        0.999381, 0.000111689, 0, 0.00105414, 
        0.999016, 0.000153862, 0, 0.0026493, 
        0.997437, 0.000187667, 0, 0.00508608, 
        0.993545, 0.000155672, 0, 0.00840554, 
        0.991135, 0.000161455, 0, 0.012629, 
        0.989157, 0.000188241, 0, 0.0177661, 
        0.986874, 0.000226229, 0, 0.0238198, 
        0.983714, 0.000268668, 0, 0.0307887, 
        0.978301, 0.000277109, 0, 0.0386688, 
        0.973227, 0.000303446, 0, 0.0474554, 
        0.967317, 0.000341851, 0, 0.0571428, 
        0.959477, 0.000370885, 0, 0.0677256, 
        0.950012, 0.000392753, 0, 0.0791988, 
        0.939484, 0.00042781, 0, 0.0915576, 
        0.928135, 0.000443866, 0, 0.104798, 
        0.919819, 0.000472959, 0, 0.118918, 
        0.910049, 0.000491551, 0, 0.133915, 
        0.899181, 0.000512616, 0, 0.149788, 
        0.886881, 0.000523563, 0, 0.166537, 
        0.87359, 0.000540183, 0, 0.184164, 
        0.858613, 0.000547386, 0, 0.202669, 
        0.842809, 0.000554809, 0, 0.222056, 
        0.825727, 0.000558316, 0, 0.242329, 
        0.808086, 0.000557824, 0, 0.263492, 
        0.790728, 0.000556346, 0, 0.285551, 
        0.772987, 0.000552672, 0, 0.30851, 
        0.7541, 0.000543738, 0, 0.332376, 
        0.734669, 0.000536107, 0, 0.357153, 
        0.714411, 0.000523342, 0, 0.382845, 
        0.694196, 0.000512238, 0, 0.409454, 
        0.674252, 0.000497465, 0, 0.436977, 
        0.65357, 0.000481096, 0, 0.465404, 
        0.632999, 0.000467054, 0, 0.494713, 
        0.611994, 0.000448771, 0, 0.524864, 
        0.591604, 0.000431889, 0, 0.555779, 
        0.571134, 0.000415238, 0, 0.587302, 
        0.550528, 0.000396369, 0, 0.619048, 
        0.530292, 0.000379477, 0, 0.650794, 
        0.510364, 0.000361488, 0, 0.68254, 
        0.490749, 0.000343787, 0, 0.714286, 
        0.471266, 0.000327822, 0, 0.746032, 
        0.452462, 0.000310626, 0, 0.777778, 
        0.433907, 0.000295352, 0, 0.809524, 
        0.415659, 0.000279179, 0, 0.84127, 
        0.398138, 0.000264685, 0, 0.873016, 
        0.380833, 0.000249905, 0, 0.904762, 
        0.364247, 0.000236282, 0, 0.936508, 
        0.348041, 0.000222905, 0, 0.968254, 
        0.332389, 0.000210522, 0, 1, 
        1, 4.20604e-05, 0, 0, 
        1, 4.20614e-05, 0, 0, 
        1, 4.20757e-05, 0, 0, 
        0.999999, 4.2138e-05, 0, 0, 
        0.999997, 4.23067e-05, 0, 0, 
        0.999993, 4.26668e-05, 0, 0, 
        0.999986, 4.33372e-05, 0, 0, 
        0.999974, 4.44857e-05, 0, 0, 
        0.999956, 4.63554e-05, 0, 0, 
        0.99993, 4.93105e-05, 0, 0, 
        0.999892, 5.39077e-05, 0, 0, 
        0.999838, 6.10005e-05, 0, 0, 
        0.999767, 7.18822e-05, 0, 0, 
        0.999666, 8.84581e-05, 0, 3.65471e-05, 
        0.999525, 0.000113398, 0, 0.000485623, 
        0.999311, 0.000150043, 0, 0.00162096, 
        0.998865, 0.000200063, 0, 0.00355319, 
        0.996278, 0.000211014, 0, 0.00633818, 
        0.992956, 0.000189672, 0, 0.0100043, 
        0.991017, 0.000210262, 0, 0.0145648, 
        0.989055, 0.000244292, 0, 0.0200237, 
        0.986741, 0.000290481, 0, 0.0263798, 
        0.983288, 0.000334303, 0, 0.033629, 
        0.977784, 0.000340307, 0, 0.0417652, 
        0.973037, 0.000377864, 0, 0.0507821, 
        0.967181, 0.0004239, 0, 0.060673, 
        0.958971, 0.000443854, 0, 0.0714314, 
        0.950093, 0.000483039, 0, 0.0830518, 
        0.939552, 0.000517934, 0, 0.0955288, 
        0.927678, 0.000539449, 0, 0.108859, 
        0.918278, 0.000568604, 0, 0.123038, 
        0.908449, 0.000588505, 0, 0.138065, 
        0.897713, 0.000612473, 0, 0.153938, 
        0.885533, 0.000625575, 0, 0.170657, 
        0.872131, 0.00063854, 0, 0.188224, 
        0.857517, 0.000647034, 0, 0.20664, 
        0.841796, 0.00065209, 0, 0.225909, 
        0.824726, 0.0006544, 0, 0.246035, 
        0.807297, 0.000655744, 0, 0.267022, 
        0.789058, 0.000646716, 0, 0.288878, 
        0.77189, 0.000643898, 0, 0.311607, 
        0.753082, 0.000629973, 0, 0.335216, 
        0.7341, 0.000621564, 0, 0.359713, 
        0.714094, 0.000605171, 0, 0.385103, 
        0.693839, 0.000588752, 0, 0.41139, 
        0.673891, 0.000573294, 0, 0.438576, 
        0.653565, 0.000552682, 0, 0.466656, 
        0.633326, 0.000533446, 0, 0.495617, 
        0.612582, 0.000514635, 0, 0.525431, 
        0.59205, 0.00049303, 0, 0.556041, 
        0.571918, 0.000471842, 0, 0.587338, 
        0.551572, 0.000451713, 0, 0.619048, 
        0.531553, 0.000430049, 0, 0.650794, 
        0.51175, 0.000410445, 0, 0.68254, 
        0.49238, 0.000390098, 0, 0.714286, 
        0.473143, 0.000370033, 0, 0.746032, 
        0.45423, 0.000351205, 0, 0.777778, 
        0.435963, 0.000332049, 0, 0.809524, 
        0.41787, 0.000315021, 0, 0.84127, 
        0.400387, 0.000297315, 0, 0.873016, 
        0.383332, 0.000281385, 0, 0.904762, 
        0.366665, 0.000265397, 0, 0.936508, 
        0.350633, 0.000250601, 0, 0.968254, 
        0.334964, 0.00023589, 0, 1, 
        1, 6.43736e-05, 0, 0, 
        1, 6.4375e-05, 0, 0, 
        1, 6.43947e-05, 0, 0, 
        0.999999, 6.4481e-05, 0, 0, 
        0.999997, 6.47143e-05, 0, 0, 
        0.999994, 6.52119e-05, 0, 0, 
        0.999985, 6.61359e-05, 0, 0, 
        0.999972, 6.77116e-05, 0, 0, 
        0.999952, 7.02599e-05, 0, 0, 
        0.999922, 7.42517e-05, 0, 0, 
        0.99988, 8.03906e-05, 0, 0, 
        0.99982, 8.97315e-05, 0, 0, 
        0.999741, 0.000103838, 0, 0, 
        0.999629, 0.00012496, 0, 0.000149024, 
        0.999474, 0.000156161, 0, 0.000861027, 
        0.999229, 0.000201034, 0, 0.00231198, 
        0.998662, 0.000259069, 0, 0.00458147, 
        0.995299, 0.000245439, 0, 0.00770895, 
        0.992732, 0.00024498, 0, 0.0117126, 
        0.990847, 0.000273211, 0, 0.0165989, 
        0.988911, 0.000316492, 0, 0.0223674, 
        0.98654, 0.00037161, 0, 0.0290135, 
        0.982636, 0.000410352, 0, 0.0365309, 
        0.977346, 0.000421756, 0, 0.0449117, 
        0.972909, 0.000475578, 0, 0.0541481, 
        0.966821, 0.000522482, 0, 0.0642326, 
        0.958686, 0.000545008, 0, 0.075158, 
        0.949754, 0.000589286, 0, 0.0869181, 
        0.939184, 0.000619995, 0, 0.0995074, 
        0.927505, 0.000654266, 0, 0.112922, 
        0.916606, 0.000682362, 0, 0.127157, 
        0.906707, 0.000704286, 0, 0.142212, 
        0.895937, 0.000725909, 0, 0.158085, 
        0.883913, 0.000743939, 0, 0.174776, 
        0.870642, 0.000755157, 0, 0.192287, 
        0.856241, 0.000764387, 0, 0.210619, 
        0.84069, 0.000771032, 0, 0.229775, 
        0.823728, 0.000765906, 0, 0.249761, 
        0.806481, 0.000767604, 0, 0.270582, 
        0.787924, 0.000754385, 0, 0.292243, 
        0.770588, 0.000749668, 0, 0.314753, 
        0.751991, 0.000731613, 0, 0.338118, 
        0.733407, 0.000717655, 0, 0.362347, 
        0.713688, 0.000700604, 0, 0.387447, 
        0.693595, 0.000678765, 0, 0.413424, 
        0.673426, 0.000657042, 0, 0.440284, 
        0.65359, 0.000635892, 0, 0.468027, 
        0.633576, 0.000611569, 0, 0.496645, 
        0.613144, 0.000586011, 0, 0.526122, 
        0.592711, 0.000563111, 0, 0.556417, 
        0.572722, 0.000537699, 0, 0.587451, 
        0.552762, 0.000512556, 0, 0.619048, 
        0.532985, 0.000489757, 0, 0.650794, 
        0.513219, 0.000464139, 0, 0.68254, 
        0.493992, 0.000442193, 0, 0.714286, 
        0.47509, 0.000418629, 0, 0.746032, 
        0.456287, 0.000397045, 0, 0.777778, 
        0.438152, 0.000375504, 0, 0.809524, 
        0.420294, 0.00035492, 0, 0.84127, 
        0.402749, 0.000335327, 0, 0.873016, 
        0.385879, 0.000316422, 0, 0.904762, 
        0.369352, 0.000298333, 0, 0.936508, 
        0.353301, 0.000281417, 0, 0.968254, 
        0.337781, 0.000265203, 0, 1, 
        1, 9.68267e-05, 0, 0, 
        1, 9.68284e-05, 0, 0, 
        1, 9.68556e-05, 0, 0, 
        0.999999, 9.69733e-05, 0, 0, 
        0.999997, 9.72913e-05, 0, 0, 
        0.999993, 9.79688e-05, 0, 0, 
        0.999984, 9.92239e-05, 0, 0, 
        0.999969, 0.000101356, 0, 0, 
        0.999946, 0.000104784, 0, 0, 
        0.999913, 0.000110111, 0, 0, 
        0.999868, 0.000118217, 0, 0, 
        0.999801, 0.000130396, 0, 0, 
        0.999712, 0.000148523, 0, 1.24907e-05, 
        0.999589, 0.000175233, 0, 0.000355405, 
        0.999416, 0.000213999, 0, 0.0013528, 
        0.999136, 0.000268529, 0, 0.00312557, 
        0.998367, 0.000333088, 0, 0.00573045, 
        0.994701, 0.000304757, 0, 0.00919397, 
        0.992497, 0.000318031, 0, 0.0135261, 
        0.990608, 0.000353863, 0, 0.0187278, 
        0.988715, 0.000409044, 0, 0.0247947, 
        0.986241, 0.000472967, 0, 0.0317196, 
        0.981696, 0.000495104, 0, 0.039494, 
        0.977097, 0.000532873, 0, 0.0481087, 
        0.972583, 0.000594447, 0, 0.0575549, 
        0.966142, 0.000636867, 0, 0.0678242, 
        0.95823, 0.000669899, 0, 0.0789089, 
        0.949677, 0.000719499, 0, 0.0908023, 
        0.939226, 0.000750584, 0, 0.103499, 
        0.927501, 0.000793183, 0, 0.116993, 
        0.915199, 0.00081995, 0, 0.131282, 
        0.90498, 0.000847654, 0, 0.146364, 
        0.894243, 0.000868929, 0, 0.162237, 
        0.882154, 0.000884278, 0, 0.178902, 
        0.869161, 0.000898108, 0, 0.196358, 
        0.854751, 0.000901254, 0, 0.21461, 
        0.839368, 0.00090679, 0, 0.23366, 
        0.822874, 0.000901541, 0, 0.253512, 
        0.805514, 0.000897297, 0, 0.274174, 
        0.78716, 0.000881856, 0, 0.29565, 
        0.769061, 0.000870032, 0, 0.31795, 
        0.751, 0.000851719, 0, 0.341081, 
        0.732614, 0.000830671, 0, 0.365053, 
        0.713171, 0.000806569, 0, 0.389874, 
        0.693472, 0.00078338, 0, 0.415553, 
        0.673528, 0.000756404, 0, 0.442098, 
        0.653397, 0.000726872, 0, 0.469512, 
        0.633781, 0.000700494, 0, 0.497794, 
        0.613877, 0.00067105, 0, 0.526935, 
        0.593506, 0.000640361, 0, 0.556908, 
        0.573667, 0.000613502, 0, 0.587657, 
        0.553932, 0.000583177, 0, 0.61906, 
        0.534345, 0.000554375, 0, 0.650794, 
        0.515042, 0.000527811, 0, 0.68254, 
        0.495674, 0.000499367, 0, 0.714286, 
        0.477132, 0.00047429, 0, 0.746032, 
        0.458609, 0.000447726, 0, 0.777778, 
        0.440354, 0.000424205, 0, 0.809524, 
        0.422765, 0.000399549, 0, 0.84127, 
        0.405472, 0.000378315, 0, 0.873016, 
        0.388482, 0.000355327, 0, 0.904762, 
        0.372191, 0.000336122, 0, 0.936508, 
        0.356099, 0.000315247, 0, 0.968254, 
        0.340737, 0.00029794, 0, 1, 
        1, 0.000143327, 0, 0, 
        1, 0.00014333, 0, 0, 
        1, 0.000143366, 0, 0, 
        0.999999, 0.000143524, 0, 0, 
        0.999996, 0.000143952, 0, 0, 
        0.999991, 0.000144862, 0, 0, 
        0.999981, 0.000146544, 0, 0, 
        0.999966, 0.000149391, 0, 0, 
        0.999941, 0.000153946, 0, 0, 
        0.999905, 0.000160971, 0, 0, 
        0.999852, 0.000171562, 0, 0, 
        0.99978, 0.00018729, 0, 0, 
        0.999681, 0.000210386, 0, 8.26239e-05, 
        0.999546, 0.000243906, 0, 0.000664807, 
        0.999352, 0.000291739, 0, 0.00196192, 
        0.999027, 0.000357419, 0, 0.00405941, 
        0.997886, 0.000422349, 0, 0.00699664, 
        0.99419, 0.000385008, 0, 0.0107896, 
        0.99214, 0.000409775, 0, 0.0154415, 
        0.990274, 0.000456418, 0, 0.0209488, 
        0.988455, 0.000527008, 0, 0.0273037, 
        0.985804, 0.000597685, 0, 0.0344969, 
        0.98103, 0.000613124, 0, 0.0425183, 
        0.976674, 0.000668321, 0, 0.0513575, 
        0.972021, 0.000736985, 0, 0.0610046, 
        0.965274, 0.000773789, 0, 0.0714508, 
        0.958046, 0.000830852, 0, 0.0826877, 
        0.949333, 0.000875766, 0, 0.0947085, 
        0.939135, 0.000917088, 0, 0.107507, 
        0.927119, 0.000952244, 0, 0.121078, 
        0.91469, 0.000990626, 0, 0.135419, 
        0.903006, 0.00101304, 0, 0.150526, 
        0.892368, 0.00103834, 0, 0.166399, 
        0.880231, 0.00105002, 0, 0.183038, 
        0.867432, 0.00106331, 0, 0.200443, 
        0.853208, 0.00106783, 0, 0.218618, 
        0.837956, 0.00106458, 0, 0.237566, 
        0.821772, 0.00105945, 0, 0.257291, 
        0.804328, 0.00104685, 0, 0.2778, 
        0.786465, 0.00103178, 0, 0.2991, 
        0.768004, 0.00101077, 0, 0.321199, 
        0.74972, 0.000985504, 0, 0.344106, 
        0.731682, 0.000962893, 0, 0.36783, 
        0.712813, 0.000932146, 0, 0.392383, 
        0.693139, 0.00089871, 0, 0.417774, 
        0.673566, 0.000869678, 0, 0.444013, 
        0.653483, 0.000835525, 0, 0.471107, 
        0.633891, 0.000799853, 0, 0.49906, 
        0.614433, 0.000766838, 0, 0.527869, 
        0.594586, 0.000732227, 0, 0.557517, 
        0.574769, 0.000696442, 0, 0.587966, 
        0.555149, 0.000663935, 0, 0.61913, 
        0.535898, 0.000629826, 0, 0.650794, 
        0.516753, 0.000596486, 0, 0.68254, 
        0.497816, 0.000567078, 0, 0.714286, 
        0.479034, 0.000534399, 0, 0.746032, 
        0.460975, 0.000507013, 0, 0.777778, 
        0.442935, 0.000477421, 0, 0.809524, 
        0.425263, 0.000451101, 0, 0.84127, 
        0.408248, 0.000424964, 0, 0.873016, 
        0.391339, 0.00039993, 0, 0.904762, 
        0.37513, 0.000377619, 0, 0.936508, 
        0.359172, 0.000354418, 0, 0.968254, 
        0.343876, 0.000334823, 0, 1, 
        1, 0.000209042, 0, 0, 
        1, 0.000209045, 0, 0, 
        1, 0.000209093, 0, 0, 
        0.999999, 0.000209304, 0, 0, 
        0.999996, 0.000209871, 0, 0, 
        0.999991, 0.000211078, 0, 0, 
        0.999979, 0.000213304, 0, 0, 
        0.999963, 0.000217061, 0, 0, 
        0.999933, 0.000223042, 0, 0, 
        0.999894, 0.000232206, 0, 0, 
        0.999837, 0.000245901, 0, 0, 
        0.999756, 0.000266023, 0, 1.02927e-06, 
        0.999648, 0.000295204, 0, 0.000233468, 
        0.999499, 0.000336958, 0, 0.00108237, 
        0.999283, 0.000395563, 0, 0.00268832, 
        0.998896, 0.000473785, 0, 0.00511138, 
        0.997006, 0.000520008, 0, 0.00837705, 
        0.993819, 0.000497261, 0, 0.0124928, 
        0.991632, 0.000523722, 0, 0.0174561, 
        0.989875, 0.000587258, 0, 0.0232596, 
        0.988109, 0.000676329, 0, 0.0298932, 
        0.985155, 0.000747701, 0, 0.0373453, 
        0.980479, 0.000768803, 0, 0.0456045, 
        0.976271, 0.000841054, 0, 0.0546593, 
        0.971347, 0.000911469, 0, 0.0644994, 
        0.964528, 0.000953057, 0, 0.0751152, 
        0.957632, 0.00102221, 0, 0.0864981, 
        0.948681, 0.00106122, 0, 0.0986407, 
        0.938716, 0.00111857, 0, 0.111537, 
        0.926629, 0.00114762, 0, 0.125182, 
        0.914025, 0.00118995, 0, 0.139571, 
        0.901026, 0.00121228, 0, 0.154703, 
        0.890358, 0.00123946, 0, 0.170576, 
        0.878283, 0.0012527, 0, 0.18719, 
        0.865459, 0.00125536, 0, 0.204547, 
        0.851407, 0.00126134, 0, 0.222648, 
        0.836276, 0.00124759, 0, 0.241498, 
        0.820436, 0.00124443, 0, 0.261101, 
        0.803253, 0.00122071, 0, 0.281465, 
        0.785562, 0.00120107, 0, 0.302595, 
        0.76718, 0.00117762, 0, 0.324501, 
        0.748551, 0.00114289, 0, 0.347192, 
        0.730564, 0.00110872, 0, 0.370679, 
        0.712253, 0.00107636, 0, 0.394973, 
        0.692867, 0.00103646, 0, 0.420085, 
        0.673695, 0.000996793, 0, 0.446027, 
        0.653912, 0.00095675, 0, 0.47281, 
        0.634129, 0.000916739, 0, 0.500441, 
        0.615004, 0.000874401, 0, 0.528921, 
        0.595587, 0.000833411, 0, 0.558244, 
        0.575965, 0.000794556, 0, 0.588384, 
        0.5566, 0.00075196, 0, 0.619281, 
        0.537428, 0.000716381, 0, 0.650795, 
        0.518623, 0.000676558, 0, 0.68254, 
        0.499964, 0.00064074, 0, 0.714286, 
        0.481356, 0.000605984, 0, 0.746032, 
        0.463279, 0.000570256, 0, 0.777778, 
        0.445673, 0.000540138, 0, 0.809524, 
        0.428032, 0.000507299, 0, 0.84127, 
        0.411112, 0.000479553, 0, 0.873016, 
        0.394444, 0.000450737, 0, 0.904762, 
        0.378247, 0.000424269, 0, 0.936508, 
        0.362415, 0.000399111, 0, 0.968254, 
        0.347103, 0.000375274, 0, 1, 
        1, 0.000300729, 0, 0, 
        1, 0.000300733, 0, 0, 
        1, 0.000300797, 0, 0, 
        0.999998, 0.000301072, 0, 0, 
        0.999996, 0.000301817, 0, 0, 
        0.999989, 0.000303398, 0, 0, 
        0.999977, 0.000306309, 0, 0, 
        0.999958, 0.000311209, 0, 0, 
        0.999927, 0.000318975, 0, 0, 
        0.999884, 0.000330804, 0, 0, 
        0.99982, 0.00034834, 0, 0, 
        0.999733, 0.000373854, 0, 3.26995e-05, 
        0.999613, 0.000410424, 0, 0.000477174, 
        0.999447, 0.000462047, 0, 0.00161099, 
        0.999204, 0.000533322, 0, 0.00353153, 
        0.998725, 0.000624964, 0, 0.00627965, 
        0.995871, 0.000631786, 0, 0.0098693, 
        0.993194, 0.000632017, 0, 0.0143011, 
        0.991541, 0.00068923, 0, 0.019568, 
        0.989773, 0.000766892, 0, 0.0256593, 
        0.987647, 0.000863668, 0, 0.0325625, 
        0.984193, 0.000922089, 0, 0.0402647, 
        0.980016, 0.000970749, 0, 0.0487532, 
        0.975859, 0.00106027, 0, 0.058016, 
        0.970514, 0.00112239, 0, 0.0680419, 
        0.963625, 0.00117212, 0, 0.0788208, 
        0.956959, 0.00125211, 0, 0.0903439, 
        0.947956, 0.00129411, 0, 0.102604, 
        0.93809, 0.00135879, 0, 0.115594, 
        0.92659, 0.00139309, 0, 0.129309, 
        0.913829, 0.00143253, 0, 0.143745, 
        0.90005, 0.00145809, 0, 0.158901, 
        0.888129, 0.0014748, 0, 0.174774, 
        0.87607, 0.00148756, 0, 0.191365, 
        0.863461, 0.00148714, 0, 0.208674, 
        0.849594, 0.00148892, 0, 0.226705, 
        0.834531, 0.00146496, 0, 0.245461, 
        0.81903, 0.0014579, 0, 0.264947, 
        0.802122, 0.00143039, 0, 0.28517, 
        0.78445, 0.00139717, 0, 0.306137, 
        0.766434, 0.00136312, 0, 0.327857, 
        0.747816, 0.00132597, 0, 0.350341, 
        0.729519, 0.00128323, 0, 0.373598, 
        0.711454, 0.00123803, 0, 0.397642, 
        0.692699, 0.00119097, 0, 0.422485, 
        0.673723, 0.00114565, 0, 0.448139, 
        0.654386, 0.00109552, 0, 0.474619, 
        0.634673, 0.00104553, 0, 0.501933, 
        0.615554, 0.00099985, 0, 0.530089, 
        0.596462, 0.000948207, 0, 0.559087, 
        0.577385, 0.000902299, 0, 0.588913, 
        0.558257, 0.000856448, 0, 0.619525, 
        0.5392, 0.000810395, 0, 0.650826, 
        0.520543, 0.000768558, 0, 0.68254, 
        0.502206, 0.0007239, 0, 0.714286, 
        0.48402, 0.000685794, 0, 0.746032, 
        0.465779, 0.00064471, 0, 0.777778, 
        0.448455, 0.000609583, 0, 0.809524, 
        0.431091, 0.00057227, 0, 0.84127, 
        0.414147, 0.00054042, 0, 0.873016, 
        0.39765, 0.000506545, 0, 0.904762, 
        0.381576, 0.000477635, 0, 0.936508, 
        0.365881, 0.000448446, 0, 0.968254, 
        0.350582, 0.000421424, 0, 1, 
        1, 0.000427144, 0, 0, 
        1, 0.000427151, 0, 0, 
        1, 0.000427232, 0, 0, 
        0.999998, 0.00042759, 0, 0, 
        0.999995, 0.000428555, 0, 0, 
        0.999988, 0.000430603, 0, 0, 
        0.999976, 0.000434368, 0, 0, 
        0.999952, 0.000440688, 0, 0, 
        0.999919, 0.000450667, 0, 0, 
        0.999871, 0.00046578, 0, 0, 
        0.999801, 0.000488024, 0, 0, 
        0.999704, 0.000520092, 0, 0.000129791, 
        0.999572, 0.000565553, 0, 0.000821056, 
        0.999389, 0.000628906, 0, 0.00225241, 
        0.999114, 0.000714911, 0, 0.00449109, 
        0.998488, 0.000819218, 0, 0.00756249, 
        0.995234, 0.00080415, 0, 0.0114716, 
        0.993021, 0.000830181, 0, 0.0162131, 
        0.991407, 0.000902645, 0, 0.021776, 
        0.989625, 0.000996934, 0, 0.0281471, 
        0.987064, 0.00109707, 0, 0.0353118, 
        0.983265, 0.00114353, 0, 0.0432562, 
        0.979535, 0.0012272, 0, 0.0519665, 
        0.975224, 0.00132642, 0, 0.0614298, 
        0.969574, 0.00138092, 0, 0.0716348, 
        0.963021, 0.00145896, 0, 0.0825709, 
        0.956046, 0.00152834, 0, 0.094229, 
        0.947136, 0.00158217, 0, 0.106602, 
        0.937313, 0.0016347, 0, 0.119682, 
        0.926073, 0.00168383, 0, 0.133465, 
        0.913121, 0.00171627, 0, 0.147947, 
        0.899165, 0.00174229, 0, 0.163125, 
        0.885891, 0.00176137, 0, 0.178998, 
        0.873783, 0.00176406, 0, 0.195566, 
        0.861331, 0.00176156, 0, 0.21283, 
        0.847569, 0.00175346, 0, 0.230793, 
        0.832785, 0.00172753, 0, 0.249459, 
        0.817442, 0.00170204, 0, 0.268832, 
        0.800613, 0.00166576, 0, 0.28892, 
        0.783597, 0.00162909, 0, 0.30973, 
        0.76571, 0.0015826, 0, 0.331271, 
        0.747021, 0.00153106, 0, 0.353554, 
        0.728593, 0.00148036, 0, 0.37659, 
        0.710661, 0.00142808, 0, 0.400391, 
        0.692426, 0.00136906, 0, 0.424973, 
        0.673623, 0.00131066, 0, 0.450347, 
        0.65494, 0.00125569, 0, 0.476531, 
        0.635448, 0.00119517, 0, 0.503535, 
        0.616221, 0.00113828, 0, 0.531372, 
        0.597531, 0.0010816, 0, 0.560047, 
        0.578795, 0.00102673, 0, 0.589554, 
        0.559892, 0.000970985, 0, 0.619869, 
        0.541307, 0.000919773, 0, 0.650923, 
        0.522608, 0.000868479, 0, 0.68254, 
        0.504484, 0.00082137, 0, 0.714286, 
        0.486603, 0.000772916, 0, 0.746032, 
        0.468802, 0.000730353, 0, 0.777778, 
        0.451172, 0.000684955, 0, 0.809524, 
        0.434348, 0.000647565, 0, 0.84127, 
        0.417445, 0.000605863, 0, 0.873016, 
        0.401077, 0.000571885, 0, 0.904762, 
        0.385039, 0.000536034, 0, 0.936508, 
        0.369483, 0.000504227, 0, 0.968254, 
        0.354272, 0.000473165, 0, 1, 
        1, 0.000599525, 0, 0, 
        1, 0.000599533, 0, 0, 
        1, 0.000599639, 0, 0, 
        0.999998, 0.000600097, 0, 0, 
        0.999994, 0.000601336, 0, 0, 
        0.999987, 0.000603958, 0, 0, 
        0.999972, 0.000608775, 0, 0, 
        0.999949, 0.000616842, 0, 0, 
        0.999912, 0.000629534, 0, 0, 
        0.999857, 0.000648658, 0, 0, 
        0.999781, 0.000676615, 0, 5.38873e-06, 
        0.999674, 0.000716574, 0, 0.000308602, 
        0.999528, 0.000772641, 0, 0.00127003, 
        0.999326, 0.000849806, 0, 0.00300783, 
        0.999009, 0.000952682, 0, 0.00556637, 
        0.998112, 0.00106394, 0, 0.00895889, 
        0.994496, 0.00102228, 0, 0.0131827, 
        0.992806, 0.00108586, 0, 0.0182277, 
        0.991211, 0.0011759, 0, 0.0240795, 
        0.989415, 0.00128955, 0, 0.030723, 
        0.986499, 0.00139038, 0, 0.0381418, 
        0.982679, 0.00144539, 0, 0.046321, 
        0.978839, 0.00153954, 0, 0.0552459, 
        0.974295, 0.00164417, 0, 0.0649034, 
        0.968784, 0.00171517, 0, 0.0752814, 
        0.962324, 0.00180282, 0, 0.0863693, 
        0.954956, 0.00186387, 0, 0.0981578, 
        0.94624, 0.00193817, 0, 0.110639, 
        0.936517, 0.00198156, 0, 0.123806, 
        0.925186, 0.00203042, 0, 0.137655, 
        0.91252, 0.0020664, 0, 0.15218, 
        0.898441, 0.00207822, 0, 0.16738, 
        0.884394, 0.0020992, 0, 0.183253, 
        0.871273, 0.00208748, 0, 0.199799, 
        0.859057, 0.00208686, 0, 0.21702, 
        0.845243, 0.00205519, 0, 0.234918, 
        0.830723, 0.00202868, 0, 0.253496, 
        0.815801, 0.00199501, 0, 0.272761, 
        0.79914, 0.00194193, 0, 0.292719, 
        0.782372, 0.00188824, 0, 0.313377, 
        0.76482, 0.00183695, 0, 0.334745, 
        0.746586, 0.00177418, 0, 0.356833, 
        0.7281, 0.00170628, 0, 0.379654, 
        0.709842, 0.00164063, 0, 0.403221, 
        0.692019, 0.00157355, 0, 0.427548, 
        0.67364, 0.00150262, 0, 0.452651, 
        0.655277, 0.00143473, 0, 0.478545, 
        0.636438, 0.00136371, 0, 0.505246, 
        0.617364, 0.00129911, 0, 0.532768, 
        0.598603, 0.00123014, 0, 0.561122, 
        0.580195, 0.00116587, 0, 0.590309, 
        0.561786, 0.00110398, 0, 0.620318, 
        0.543377, 0.00104148, 0, 0.651102, 
        0.525093, 0.000983984, 0, 0.682545, 
        0.506791, 0.00092667, 0, 0.714286, 
        0.489291, 0.000874326, 0, 0.746032, 
        0.471811, 0.000821734, 0, 0.777778, 
        0.454435, 0.000774698, 0, 0.809524, 
        0.437493, 0.000727302, 0, 0.84127, 
        0.420977, 0.000684039, 0, 0.873016, 
        0.404729, 0.00064373, 0, 0.904762, 
        0.388756, 0.00060285, 0, 0.936508, 
        0.373344, 0.00056765, 0, 0.968254, 
        0.358191, 0.000531929, 0, 1, 
        1, 0.000832169, 0, 0, 
        1, 0.000832178, 0, 0, 
        1, 0.00083231, 0, 0, 
        0.999998, 0.000832893, 0, 0, 
        0.999995, 0.000834465, 0, 0, 
        0.999985, 0.000837791, 0, 0, 
        0.999969, 0.000843893, 0, 0, 
        0.999944, 0.000854086, 0, 0, 
        0.999903, 0.000870071, 0, 0, 
        0.999843, 0.000894042, 0, 0, 
        0.999759, 0.000928865, 0, 5.31805e-05, 
        0.999643, 0.000978242, 0, 0.000579365, 
        0.99948, 0.00104684, 0, 0.00182774, 
        0.999255, 0.00114012, 0, 0.00387804, 
        0.998885, 0.00126188, 0, 0.00675709, 
        0.997405, 0.00135888, 0, 0.010468, 
        0.99424, 0.00133626, 0, 0.0150018, 
        0.992458, 0.00140905, 0, 0.0203443, 
        0.990929, 0.00152305, 0, 0.0264786, 
        0.989116, 0.00165882, 0, 0.0333875, 
        0.985624, 0.00174128, 0, 0.0410536, 
        0.982003, 0.00182108, 0, 0.0494609, 
        0.978336, 0.00194498, 0, 0.0585941, 
        0.973184, 0.00202708, 0, 0.0684396, 
        0.9678, 0.00212166, 0, 0.0789851, 
        0.961348, 0.00221366, 0, 0.0902199, 
        0.953841, 0.00228219, 0, 0.102134, 
        0.94534, 0.00235662, 0, 0.114721, 
        0.935552, 0.00240572, 0, 0.127972, 
        0.924064, 0.00244405, 0, 0.141884, 
        0.911827, 0.00247557, 0, 0.156451, 
        0.897731, 0.00248374, 0, 0.171672, 
        0.883409, 0.00249863, 0, 0.187545, 
        0.868625, 0.00246688, 0, 0.20407, 
        0.856529, 0.00246523, 0, 0.221249, 
        0.842999, 0.00242368, 0, 0.239083, 
        0.828505, 0.00237354, 0, 0.257578, 
        0.813825, 0.00232588, 0, 0.276738, 
        0.797813, 0.00226731, 0, 0.296569, 
        0.781097, 0.00219704, 0, 0.31708, 
        0.764038, 0.00212394, 0, 0.338281, 
        0.746067, 0.00204786, 0, 0.360181, 
        0.727687, 0.00196728, 0, 0.382794, 
        0.709571, 0.00188779, 0, 0.406133, 
        0.691503, 0.00180532, 0, 0.430213, 
        0.673673, 0.00171849, 0, 0.45505, 
        0.655732, 0.00164147, 0, 0.480662, 
        0.637399, 0.00155858, 0, 0.507065, 
        0.618616, 0.00147641, 0, 0.534278, 
        0.60005, 0.00140125, 0, 0.562313, 
        0.581713, 0.00132441, 0, 0.59118, 
        0.563546, 0.00125014, 0, 0.620875, 
        0.545605, 0.00118249, 0, 0.651373, 
        0.527559, 0.0011116, 0, 0.682593, 
        0.509764, 0.00104979, 0, 0.714286, 
        0.49193, 0.000985977, 0, 0.746032, 
        0.475011, 0.000928592, 0, 0.777778, 
        0.457878, 0.000873466, 0, 0.809524, 
        0.440979, 0.000819585, 0, 0.84127, 
        0.424613, 0.000772365, 0, 0.873016, 
        0.408549, 0.000722195, 0, 0.904762, 
        0.392771, 0.000680014, 0, 0.936508, 
        0.377317, 0.000636797, 0, 0.968254, 
        0.362352, 0.000598318, 0, 1, 
        1, 0.00114313, 0, 0, 
        1, 0.00114314, 0, 0, 
        0.999999, 0.00114331, 0, 0, 
        0.999998, 0.00114404, 0, 0, 
        0.999994, 0.00114601, 0, 0, 
        0.999984, 0.00115019, 0, 0, 
        0.999967, 0.00115784, 0, 0, 
        0.999937, 0.0011706, 0, 0, 
        0.999894, 0.00119054, 0, 0, 
        0.999828, 0.00122031, 0, 0, 
        0.999735, 0.00126331, 0, 0.000169263, 
        0.999606, 0.00132382, 0, 0.000949167, 
        0.999426, 0.0014071, 0, 0.00249668, 
        0.999173, 0.00151895, 0, 0.00486392, 
        0.99873, 0.00166102, 0, 0.00806323, 
        0.996243, 0.0017023, 0, 0.0120895, 
        0.993779, 0.00172782, 0, 0.0169288, 
        0.9919, 0.0018108, 0, 0.0225633, 
        0.990524, 0.00196028, 0, 0.028974, 
        0.98868, 0.00212014, 0, 0.036142, 
        0.984663, 0.00217598, 0, 0.044049, 
        0.981457, 0.00230563, 0, 0.0526781, 
        0.977608, 0.00243966, 0, 0.0620137, 
        0.972215, 0.00251336, 0, 0.0720418, 
        0.966798, 0.0026285, 0, 0.0827499, 
        0.960241, 0.00271409, 0, 0.0941271, 
        0.952489, 0.00278381, 0, 0.106164, 
        0.944127, 0.00285399, 0, 0.118852, 
        0.934282, 0.00290994, 0, 0.132185, 
        0.923271, 0.00294558, 0, 0.146157, 
        0.910803, 0.00296269, 0, 0.160766, 
        0.896705, 0.00296803, 0, 0.176007, 
        0.88238, 0.00296637, 0, 0.19188, 
        0.867116, 0.00293163, 0, 0.208385, 
        0.853636, 0.00289418, 0, 0.225523, 
        0.840469, 0.00284663, 0, 0.243296, 
        0.82639, 0.00278594, 0, 0.261709, 
        0.811759, 0.00271618, 0, 0.280767, 
        0.796113, 0.00263187, 0, 0.300476, 
        0.779518, 0.00254589, 0, 0.320845, 
        0.763142, 0.00246003, 0, 0.341883, 
        0.745464, 0.00236529, 0, 0.363601, 
        0.727491, 0.00226536, 0, 0.386011, 
        0.709414, 0.00216375, 0, 0.409128, 
        0.691396, 0.00207127, 0, 0.432967, 
        0.67368, 0.00197106, 0, 0.457545, 
        0.656049, 0.00187022, 0, 0.482881, 
        0.638188, 0.00177605, 0, 0.508992, 
        0.620177, 0.00168482, 0, 0.535899, 
        0.601506, 0.00158909, 0, 0.563619, 
        0.58362, 0.00150583, 0, 0.592165, 
        0.565496, 0.00141791, 0, 0.621544, 
        0.54789, 0.00133693, 0, 0.651743, 
        0.530323, 0.00126038, 0, 0.682709, 
        0.512795, 0.00118556, 0, 0.714286, 
        0.495199, 0.00111527, 0, 0.746032, 
        0.478101, 0.0010489, 0, 0.777778, 
        0.461511, 0.000984264, 0, 0.809524, 
        0.444879, 0.00092591, 0, 0.84127, 
        0.428424, 0.000866582, 0, 0.873016, 
        0.412495, 0.000814463, 0, 0.904762, 
        0.396975, 0.000764498, 0, 0.936508, 
        0.381614, 0.000715967, 0, 0.968254, 
        0.366732, 0.000672483, 0, 1, 
        1, 0.00155501, 0, 0, 
        1, 0.00155503, 0, 0, 
        1, 0.00155524, 0, 0, 
        0.999998, 0.00155615, 0, 0, 
        0.999994, 0.0015586, 0, 0, 
        0.999983, 0.00156379, 0, 0, 
        0.999963, 0.0015733, 0, 0, 
        0.999932, 0.00158911, 0, 0, 
        0.999882, 0.00161376, 0, 0, 
        0.99981, 0.00165041, 0, 1.00875e-05, 
        0.999708, 0.00170304, 0, 0.000367658, 
        0.999565, 0.00177658, 0, 0.0014234, 
        0.999368, 0.00187688, 0, 0.00327939, 
        0.999081, 0.00200989, 0, 0.00596629, 
        0.99852, 0.00217177, 0, 0.0094852, 
        0.99549, 0.0021745, 0, 0.013824, 
        0.993252, 0.00222357, 0, 0.0189642, 
        0.991727, 0.00235022, 0, 0.0248856, 
        0.989951, 0.00250561, 0, 0.0315669, 
        0.988029, 0.00268829, 0, 0.0389882, 
        0.984029, 0.0027496, 0, 0.0471302, 
        0.980683, 0.00289793, 0, 0.0559754, 
        0.976554, 0.00303315, 0, 0.0655081, 
        0.97139, 0.00313257, 0, 0.0757138, 
        0.965544, 0.00323656, 0, 0.08658, 
        0.95912, 0.00333432, 0, 0.0980954, 
        0.951183, 0.0034039, 0, 0.110251, 
        0.942974, 0.00347515, 0, 0.123038, 
        0.932642, 0.00350381, 0, 0.13645, 
        0.922158, 0.00354519, 0, 0.150482, 
        0.909404, 0.00353851, 0, 0.165129, 
        0.896071, 0.0035435, 0, 0.18039, 
        0.881206, 0.00349936, 0, 0.196263, 
        0.866077, 0.00347256, 0, 0.212748, 
        0.85093, 0.003415, 0, 0.229847, 
        0.837703, 0.00333367, 0, 0.247561, 
        0.823878, 0.003249, 0, 0.265895, 
        0.809449, 0.00316347, 0, 0.284854, 
        0.794379, 0.00306351, 0, 0.304445, 
        0.778138, 0.0029499, 0, 0.324675, 
        0.761997, 0.00284099, 0, 0.345555, 
        0.744938, 0.00272104, 0, 0.367095, 
        0.727212, 0.00260715, 0, 0.389309, 
        0.709549, 0.00248855, 0, 0.41221, 
        0.691704, 0.00236783, 0, 0.435814, 
        0.673689, 0.00225178, 0, 0.460138, 
        0.656453, 0.00213765, 0, 0.485203, 
        0.639128, 0.00202178, 0, 0.511028, 
        0.621512, 0.00191443, 0, 0.537634, 
        0.603598, 0.00180977, 0, 0.565041, 
        0.58559, 0.00170456, 0, 0.593268, 
        0.567852, 0.00160927, 0, 0.622327, 
        0.5503, 0.00151395, 0, 0.652217, 
        0.533033, 0.00142499, 0, 0.682907, 
        0.515942, 0.00133955, 0, 0.714296, 
        0.498814, 0.0012602, 0, 0.746032, 
        0.481595, 0.00118188, 0, 0.777778, 
        0.465117, 0.00111171, 0, 0.809524, 
        0.448865, 0.00104091, 0, 0.84127, 
        0.432711, 0.000976618, 0, 0.873016, 
        0.416822, 0.00091859, 0, 0.904762, 
        0.401272, 0.000857704, 0, 0.936508, 
        0.386226, 0.000807172, 0, 0.968254, 
        0.371321, 0.00075464, 0, 1, 
        1, 0.00209596, 0, 0, 
        1, 0.00209598, 0, 0, 
        1, 0.00209624, 0, 0, 
        0.999997, 0.00209736, 0, 0, 
        0.999991, 0.00210039, 0, 0, 
        0.999979, 0.00210678, 0, 0, 
        0.999959, 0.00211847, 0, 0, 
        0.999925, 0.0021379, 0, 0, 
        0.99987, 0.00216809, 0, 0, 
        0.999791, 0.00221281, 0, 6.81487e-05, 
        0.999677, 0.00227669, 0, 0.000658161, 
        0.999521, 0.00236533, 0, 0.00200635, 
        0.999301, 0.00248514, 0, 0.0041779, 
        0.998977, 0.00264185, 0, 0.00718648, 
        0.998191, 0.00281695, 0, 0.0110239, 
        0.994801, 0.00278518, 0, 0.015672, 
        0.993091, 0.00288774, 0, 0.0211091, 
        0.991571, 0.00303931, 0, 0.0273123, 
        0.9897, 0.00321643, 0, 0.034259, 
        0.987023, 0.00337332, 0, 0.0419282, 
        0.983289, 0.00346146, 0, 0.0502998, 
        0.979892, 0.00363704, 0, 0.0593562, 
        0.975111, 0.00373601, 0, 0.069081, 
        0.970351, 0.0038842, 0, 0.0794598, 
        0.964131, 0.00397053, 0, 0.0904798, 
        0.957747, 0.00408078, 0, 0.10213, 
        0.949536, 0.00413533, 0, 0.1144, 
        0.941372, 0.00420305, 0, 0.127284, 
        0.931049, 0.00422815, 0, 0.140772, 
        0.920647, 0.00425048, 0, 0.154862, 
        0.908033, 0.0042281, 0, 0.169548, 
        0.895028, 0.00422026, 0, 0.184828, 
        0.879968, 0.00415042, 0, 0.200701, 
        0.864875, 0.00408821, 0, 0.217167, 
        0.84918, 0.00400909, 0, 0.234227, 
        0.834934, 0.00391178, 0, 0.251884, 
        0.821397, 0.00380066, 0, 0.270141, 
        0.807135, 0.00367974, 0, 0.289004, 
        0.792363, 0.00355172, 0, 0.308479, 
        0.776661, 0.003411, 0, 0.328575, 
        0.760705, 0.00328123, 0, 0.349301, 
        0.744408, 0.00314003, 0, 0.370668, 
        0.726994, 0.0029906, 0, 0.392689, 
        0.709598, 0.00285034, 0, 0.415379, 
        0.692112, 0.00271179, 0, 0.438754, 
        0.674435, 0.00257185, 0, 0.46283, 
        0.65676, 0.00243425, 0, 0.48763, 
        0.639982, 0.00230351, 0, 0.513173, 
        0.622983, 0.0021777, 0, 0.539482, 
        0.605471, 0.00204991, 0, 0.566579, 
        0.58796, 0.00193759, 0, 0.594488, 
        0.570463, 0.00181976, 0, 0.623226, 
        0.553058, 0.00171497, 0, 0.6528, 
        0.535894, 0.00161109, 0, 0.683198, 
        0.519089, 0.00151394, 0, 0.714354, 
        0.502454, 0.00142122, 0, 0.746032, 
        0.485681, 0.00133488, 0, 0.777778, 
        0.468935, 0.00124975, 0, 0.809524, 
        0.452951, 0.00117309, 0, 0.84127, 
        0.437139, 0.00110155, 0, 0.873016, 
        0.421446, 0.00103124, 0, 0.904762, 
        0.405951, 0.000966387, 0, 0.936508, 
        0.391003, 0.000908119, 0, 0.968254, 
        0.376198, 0.000848057, 0, 1, 
        1, 0.00280076, 0, 0, 
        1, 0.00280078, 0, 0, 
        0.999999, 0.00280109, 0, 0, 
        0.999997, 0.00280246, 0, 0, 
        0.999992, 0.00280616, 0, 0, 
        0.999979, 0.00281396, 0, 0, 
        0.999956, 0.00282822, 0, 0, 
        0.999916, 0.00285186, 0, 0, 
        0.999857, 0.0028885, 0, 0, 
        0.999768, 0.00294259, 0, 0.000196026, 
        0.999645, 0.00301946, 0, 0.00104842, 
        0.99947, 0.00312541, 0, 0.00270199, 
        0.999229, 0.00326733, 0, 0.00519449, 
        0.998852, 0.00344992, 0, 0.00852602, 
        0.997558, 0.00361052, 0, 0.0126804, 
        0.994417, 0.0035898, 0, 0.017635, 
        0.992824, 0.00372393, 0, 0.023365, 
        0.991344, 0.00390695, 0, 0.0298456, 
        0.989337, 0.00410392, 0, 0.0370529, 
        0.985811, 0.00420987, 0, 0.0449651, 
        0.982772, 0.00437488, 0, 0.0535615, 
        0.979001, 0.00455069, 0, 0.0628243, 
        0.974102, 0.00464462, 0, 0.0727368, 
        0.969197, 0.00480577, 0, 0.0832844, 
        0.962759, 0.00487818, 0, 0.0944545, 
        0.956207, 0.00498176, 0, 0.106236, 
        0.947909, 0.00503392, 0, 0.118619, 
        0.939596, 0.00507474, 0, 0.131595, 
        0.929642, 0.00509798, 0, 0.145159, 
        0.918807, 0.00508476, 0, 0.159305, 
        0.906921, 0.00505634, 0, 0.174028, 
        0.893312, 0.00498845, 0, 0.189327, 
        0.878933, 0.0049133, 0, 0.2052, 
        0.863986, 0.0048259, 0, 0.221647, 
        0.847936, 0.00470848, 0, 0.23867, 
        0.832253, 0.00456889, 0, 0.25627, 
        0.818619, 0.00442726, 0, 0.274453, 
        0.804788, 0.00427677, 0, 0.293222, 
        0.790241, 0.00411906, 0, 0.312585, 
        0.775162, 0.00394833, 0, 0.33255, 
        0.759463, 0.00377366, 0, 0.353126, 
        0.743598, 0.00361026, 0, 0.374324, 
        0.72697, 0.00343627, 0, 0.396158, 
        0.709646, 0.00326422, 0, 0.418641, 
        0.69277, 0.00309717, 0, 0.44179, 
        0.675371, 0.0029356, 0, 0.465624, 
        0.657863, 0.00277712, 0, 0.490163, 
        0.640772, 0.00261738, 0, 0.515429, 
        0.624441, 0.0024737, 0, 0.541445, 
        0.607497, 0.00233125, 0, 0.568236, 
        0.590438, 0.00218994, 0, 0.595828, 
        0.573224, 0.0020664, 0, 0.624242, 
        0.556168, 0.00193526, 0, 0.653496, 
        0.539232, 0.00182463, 0, 0.683588, 
        0.522352, 0.00170735, 0, 0.714482, 
        0.506172, 0.00160555, 0, 0.746032, 
        0.489842, 0.00150451, 0, 0.777778, 
        0.473463, 0.00140938, 0, 0.809524, 
        0.457266, 0.00132568, 0, 0.84127, 
        0.441609, 0.0012376, 0, 0.873016, 
        0.426348, 0.00116265, 0, 0.904762, 
        0.411002, 0.00108935, 0, 0.936508, 
        0.396045, 0.00101946, 0, 0.968254, 
        0.381448, 0.000955665, 0, 1, 
        1, 0.0037121, 0, 0, 
        1, 0.00371213, 0, 0, 
        1, 0.00371251, 0, 0, 
        0.999997, 0.00371417, 0, 0, 
        0.99999, 0.00371863, 0, 0, 
        0.999977, 0.00372807, 0, 0, 
        0.99995, 0.00374529, 0, 0, 
        0.999908, 0.0037738, 0, 0, 
        0.999843, 0.00381789, 0, 1.23596e-05, 
        0.999745, 0.00388273, 0, 0.000407442, 
        0.999608, 0.00397443, 0, 0.0015447, 
        0.999415, 0.00409998, 0, 0.00351385, 
        0.999143, 0.00426662, 0, 0.0063316, 
        0.9987, 0.00447625, 0, 0.00998679, 
        0.996363, 0.00455323, 0, 0.0144569, 
        0.994021, 0.00461052, 0, 0.0197151, 
        0.992372, 0.00476359, 0, 0.0257344, 
        0.991007, 0.00499101, 0, 0.0324882, 
        0.988767, 0.0051972, 0, 0.0399517, 
        0.984872, 0.00528407, 0, 0.0481022, 
        0.982004, 0.00548926, 0, 0.0569191, 
        0.977714, 0.00564385, 0, 0.0663839, 
        0.973076, 0.0057693, 0, 0.0764801, 
        0.967565, 0.0058924, 0, 0.0871928, 
        0.961384, 0.00599629, 0, 0.0985095, 
        0.954435, 0.00605998, 0, 0.110419, 
        0.946303, 0.0061133, 0, 0.122912, 
        0.937662, 0.00612028, 0, 0.13598, 
        0.927867, 0.00612209, 0, 0.149617, 
        0.916475, 0.00604813, 0, 0.163817, 
        0.90541, 0.00603088, 0, 0.178577, 
        0.891591, 0.00592218, 0, 0.193894, 
        0.877573, 0.00578854, 0, 0.209767, 
        0.862511, 0.00566648, 0, 0.226196, 
        0.846861, 0.00551481, 0, 0.243182, 
        0.83068, 0.00533754, 0, 0.260728, 
        0.815725, 0.00515487, 0, 0.278837, 
        0.802321, 0.0049655, 0, 0.297515, 
        0.787826, 0.00475421, 0, 0.316768, 
        0.773454, 0.00456002, 0, 0.336605, 
        0.758224, 0.00434727, 0, 0.357034, 
        0.74265, 0.00414444, 0, 0.378067, 
        0.726729, 0.00393738, 0, 0.399717, 
        0.710155, 0.00373575, 0, 0.421998, 
        0.693312, 0.00353736, 0, 0.444928, 
        0.67653, 0.00334368, 0, 0.468523, 
        0.659444, 0.00315981, 0, 0.492806, 
        0.642051, 0.00297809, 0, 0.517798, 
        0.625758, 0.00280592, 0, 0.543525, 
        0.609615, 0.00264254, 0, 0.570012, 
        0.592919, 0.00248459, 0, 0.597288, 
        0.576298, 0.00233327, 0, 0.625379, 
        0.559489, 0.00219519, 0, 0.654307, 
        0.542891, 0.00205441, 0, 0.684084, 
        0.526255, 0.00193385, 0, 0.714693, 
        0.509853, 0.00180745, 0, 0.746044, 
        0.494131, 0.00169817, 0, 0.777778, 
        0.478114, 0.0015913, 0, 0.809524, 
        0.462274, 0.00148981, 0, 0.84127, 
        0.446412, 0.00139537, 0, 0.873016, 
        0.431274, 0.00130984, 0, 0.904762, 
        0.41635, 0.00122403, 0, 0.936508, 
        0.401476, 0.00114809, 0, 0.968254, 
        0.386993, 0.00107563, 0, 1, 
        1, 0.00488216, 0, 0, 
        1, 0.0048822, 0, 0, 
        1, 0.00488265, 0, 0, 
        0.999997, 0.00488463, 0, 0, 
        0.999988, 0.00488999, 0, 0, 
        0.999974, 0.00490129, 0, 0, 
        0.999946, 0.00492191, 0, 0, 
        0.999897, 0.00495598, 0, 0, 
        0.999825, 0.00500855, 0, 7.44791e-05, 
        0.999718, 0.00508559, 0, 0.000712744, 
        0.999565, 0.005194, 0, 0.00215249, 
        0.999352, 0.00534147, 0, 0.00444576, 
        0.999046, 0.00553523, 0, 0.00759218, 
        0.998492, 0.00577016, 0, 0.0115714, 
        0.995564, 0.00578487, 0, 0.0163557, 
        0.993339, 0.00586414, 0, 0.021915, 
        0.991834, 0.00606002, 0, 0.0282201, 
        0.990496, 0.00633312, 0, 0.0352433, 
        0.987826, 0.00651941, 0, 0.042959, 
        0.98383, 0.00660842, 0, 0.0513439, 
        0.98109, 0.00685523, 0, 0.0603772, 
        0.976131, 0.00695778, 0, 0.0700402, 
        0.971922, 0.00714236, 0, 0.0803163, 
        0.965901, 0.00721437, 0, 0.0911908, 
        0.959606, 0.00732017, 0, 0.102651, 
        0.952504, 0.00735788, 0, 0.114686, 
        0.944365, 0.00738493, 0, 0.127286, 
        0.935652, 0.00737969, 0, 0.140443, 
        0.925813, 0.00733612, 0, 0.154151, 
        0.914397, 0.00723094, 0, 0.168405, 
        0.903257, 0.00714002, 0, 0.183201, 
        0.890015, 0.00700149, 0, 0.198536, 
        0.876014, 0.00682813, 0, 0.214409, 
        0.861436, 0.00665567, 0, 0.23082, 
        0.845752, 0.00644526, 0, 0.24777, 
        0.829169, 0.00621635, 0, 0.265263, 
        0.813435, 0.00597789, 0, 0.283301, 
        0.799701, 0.00575694, 0, 0.301889, 
        0.785726, 0.00549866, 0, 0.321035, 
        0.77152, 0.0052503, 0, 0.340746, 
        0.75683, 0.00499619, 0, 0.361032, 
        0.741951, 0.0047543, 0, 0.381904, 
        0.726367, 0.0045084, 0, 0.403374, 
        0.710537, 0.00426784, 0, 0.425457, 
        0.693965, 0.00403487, 0, 0.448169, 
        0.677724, 0.0038075, 0, 0.47153, 
        0.66117, 0.00359431, 0, 0.495561, 
        0.644274, 0.00338354, 0, 0.520284, 
        0.627449, 0.00318163, 0, 0.545725, 
        0.611645, 0.00299672, 0, 0.571911, 
        0.595614, 0.00281016, 0, 0.598873, 
        0.579426, 0.00264252, 0, 0.62664, 
        0.563016, 0.00247509, 0, 0.655239, 
        0.546728, 0.00232647, 0, 0.684692, 
        0.530539, 0.00217803, 0, 0.714999, 
        0.514164, 0.00204216, 0, 0.746106, 
        0.498344, 0.00191403, 0, 0.777778, 
        0.482957, 0.00179203, 0, 0.809524, 
        0.467336, 0.00167695, 0, 0.84127, 
        0.451994, 0.00157567, 0, 0.873016, 
        0.436514, 0.00147113, 0, 0.904762, 
        0.42178, 0.00138034, 0, 0.936508, 
        0.407271, 0.00129219, 0, 0.968254, 
        0.392822, 0.0012098, 0, 1, 
        1, 0.00637427, 0, 0, 
        1, 0.00637431, 0, 0, 
        0.999999, 0.00637485, 0, 0, 
        0.999996, 0.00637721, 0, 0, 
        0.999987, 0.00638357, 0, 0, 
        0.999971, 0.006397, 0, 0, 
        0.999939, 0.00642142, 0, 0, 
        0.999888, 0.00646177, 0, 0, 
        0.999807, 0.00652387, 0, 0.000207916, 
        0.999689, 0.00661454, 0, 0.00112051, 
        0.99952, 0.00674155, 0, 0.00287719, 
        0.999283, 0.00691313, 0, 0.00550145, 
        0.998936, 0.00713598, 0, 0.00897928, 
        0.998165, 0.00738501, 0, 0.0132829, 
        0.994847, 0.00734388, 0, 0.01838, 
        0.993182, 0.00749991, 0, 0.0242381, 
        0.991665, 0.0077246, 0, 0.030826, 
        0.989708, 0.00797579, 0, 0.0381152, 
        0.986663, 0.00813011, 0, 0.0460794, 
        0.983288, 0.00830365, 0, 0.0546951, 
        0.980104, 0.00853496, 0, 0.0639411, 
        0.974855, 0.00861045, 0, 0.0737988, 
        0.97045, 0.00879133, 0, 0.0842516, 
        0.964509, 0.00886377, 0, 0.0952848, 
        0.957594, 0.00890346, 0, 0.106886, 
        0.950546, 0.00893289, 0, 0.119044, 
        0.942225, 0.00890074, 0, 0.131749, 
        0.933365, 0.00886826, 0, 0.144994, 
        0.923202, 0.0087316, 0, 0.158772, 
        0.912605, 0.00863082, 0, 0.173078, 
        0.901099, 0.00847403, 0, 0.187908, 
        0.888177, 0.00825838, 0, 0.203261, 
        0.873955, 0.00801834, 0, 0.219134, 
        0.860091, 0.00779026, 0, 0.235527, 
        0.84434, 0.00752478, 0, 0.252443, 
        0.828517, 0.00724074, 0, 0.269883, 
        0.81239, 0.00693769, 0, 0.287851, 
        0.79721, 0.00664817, 0, 0.306352, 
        0.783489, 0.00634763, 0, 0.325393, 
        0.769514, 0.00604221, 0, 0.344981, 
        0.755419, 0.00573568, 0, 0.365126, 
        0.741083, 0.00544359, 0, 0.385839, 
        0.726059, 0.00515515, 0, 0.407132, 
        0.710809, 0.00487139, 0, 0.42902, 
        0.695052, 0.00459846, 0, 0.45152, 
        0.678886, 0.00433412, 0, 0.474651, 
        0.663042, 0.00407981, 0, 0.498433, 
        0.646634, 0.00384264, 0, 0.52289, 
        0.630117, 0.00360897, 0, 0.548048, 
        0.613804, 0.00338863, 0, 0.573936, 
        0.598338, 0.00318486, 0, 0.600584, 
        0.582687, 0.00298377, 0, 0.628027, 
        0.566809, 0.00280082, 0, 0.656295, 
        0.550817, 0.00262255, 0, 0.685417, 
        0.534937, 0.00245835, 0, 0.715406, 
        0.519151, 0.00230574, 0, 0.74624, 
        0.503118, 0.0021549, 0, 0.777778, 
        0.487723, 0.00202008, 0, 0.809524, 
        0.472725, 0.00189355, 0, 0.84127, 
        0.457599, 0.00177108, 0, 0.873016, 
        0.442558, 0.00165843, 0, 0.904762, 
        0.427624, 0.00155494, 0, 0.936508, 
        0.413171, 0.00145273, 0, 0.968254, 
        0.399122, 0.00136454, 0, 1, 
        1, 0.00826496, 0, 0, 
        1, 0.00826499, 0, 0, 
        1, 0.00826564, 0, 0, 
        0.999996, 0.00826842, 0, 0, 
        0.999987, 0.00827589, 0, 0, 
        0.999967, 0.00829167, 0, 0, 
        0.999933, 0.00832037, 0, 0, 
        0.999876, 0.00836768, 0, 1.09338e-05, 
        0.999786, 0.00844031, 0, 0.000427145, 
        0.999655, 0.00854603, 0, 0.0016384, 
        0.999468, 0.00869337, 0, 0.00372392, 
        0.999203, 0.008891, 0, 0.00668513, 
        0.998803, 0.00914387, 0, 0.0104968, 
        0.99748, 0.00935838, 0, 0.015125, 
        0.994446, 0.00933309, 0, 0.0205338, 
        0.99292, 0.00953084, 0, 0.0266884, 
        0.991414, 0.0097893, 0, 0.0335565, 
        0.989049, 0.0100228, 0, 0.0411086, 
        0.98582, 0.0101664, 0, 0.0493181, 
        0.982441, 0.0103582, 0, 0.0581613, 
        0.978595, 0.0105292, 0, 0.0676169, 
        0.973495, 0.0106274, 0, 0.0776661, 
        0.968405, 0.0107261, 0, 0.0882926, 
        0.962717, 0.0108234, 0, 0.0994817, 
        0.955478, 0.0108102, 0, 0.111221, 
        0.948275, 0.0107914, 0, 0.123499, 
        0.940006, 0.0107161, 0, 0.136308, 
        0.930831, 0.0106309, 0, 0.149639, 
        0.920648, 0.0104083, 0, 0.163485, 
        0.910205, 0.0102312, 0, 0.177843, 
        0.898445, 0.0100051, 0, 0.192707, 
        0.885986, 0.00971928, 0, 0.208077, 
        0.872204, 0.00940747, 0, 0.22395, 
        0.858436, 0.0091085, 0, 0.240326, 
        0.843454, 0.00876595, 0, 0.257208, 
        0.827437, 0.00839794, 0, 0.274596, 
        0.811488, 0.00803692, 0, 0.292496, 
        0.796039, 0.00767352, 0, 0.310911, 
        0.781083, 0.0073097, 0, 0.329849, 
        0.767642, 0.00694032, 0, 0.349316, 
        0.753901, 0.00657476, 0, 0.369323, 
        0.740131, 0.00622699, 0, 0.38988, 
        0.725845, 0.0058838, 0, 0.410999, 
        0.710991, 0.00555586, 0, 0.432696, 
        0.696002, 0.00523089, 0, 0.454987, 
        0.680461, 0.00492494, 0, 0.47789, 
        0.664875, 0.00463464, 0, 0.501426, 
        0.649273, 0.00435422, 0, 0.52562, 
        0.63302, 0.0040875, 0, 0.550498, 
        0.61705, 0.00384075, 0, 0.576089, 
        0.601154, 0.00359557, 0, 0.602427, 
        0.586008, 0.00337636, 0, 0.629544, 
        0.570699, 0.00316019, 0, 0.657479, 
        0.555166, 0.00296033, 0, 0.686264, 
        0.539645, 0.00277552, 0, 0.715924, 
        0.524159, 0.00259499, 0, 0.746459, 
        0.508682, 0.00243257, 0, 0.777789, 
        0.493163, 0.00227851, 0, 0.809524, 
        0.478004, 0.00213083, 0, 0.84127, 
        0.46347, 0.00199502, 0, 0.873016, 
        0.448778, 0.00186967, 0, 0.904762, 
        0.434105, 0.00174732, 0, 0.936508, 
        0.419576, 0.00163861, 0, 0.968254, 
        0.405541, 0.00153341, 0, 1, 
        1, 0.0106462, 0, 0, 
        1, 0.0106462, 0, 0, 
        0.999999, 0.010647, 0, 0, 
        0.999995, 0.0106502, 0, 0, 
        0.999985, 0.0106589, 0, 0, 
        0.999964, 0.0106773, 0, 0, 
        0.999925, 0.0107106, 0, 0, 
        0.999861, 0.0107655, 0, 7.12986e-05, 
        0.999763, 0.0108497, 0, 0.000743959, 
        0.999616, 0.0109716, 0, 0.00227361, 
        0.999408, 0.0111408, 0, 0.0046983, 
        0.999112, 0.0113659, 0, 0.00800158, 
        0.998637, 0.0116475, 0, 0.0121493, 
        0.996223, 0.0117231, 0, 0.0171023, 
        0.994006, 0.0118064, 0, 0.0228218, 
        0.992444, 0.0120254, 0, 0.0292711, 
        0.991028, 0.0123314, 0, 0.036417, 
        0.98803, 0.0124954, 0, 0.0442295, 
        0.984816, 0.0126538, 0, 0.0526815, 
        0.981399, 0.0128537, 0, 0.0617492, 
        0.977085, 0.0129694, 0, 0.0714114, 
        0.972154, 0.013091, 0, 0.0816495, 
        0.966617, 0.0131166, 0, 0.0924472, 
        0.960628, 0.0131583, 0, 0.10379, 
        0.953295, 0.0131094, 0, 0.115665, 
        0.94575, 0.0129966, 0, 0.128062, 
        0.937654, 0.0128796, 0, 0.140972, 
        0.927716, 0.0126477, 0, 0.154387, 
        0.917932, 0.0123889, 0, 0.168301, 
        0.907719, 0.012131, 0, 0.182709, 
        0.89584, 0.0118013, 0, 0.197608, 
        0.883526, 0.0114145, 0, 0.212994, 
        0.870301, 0.0110075, 0, 0.228867, 
        0.856272, 0.0106019, 0, 0.245227, 
        0.842251, 0.0101938, 0, 0.262074, 
        0.826466, 0.00973254, 0, 0.279412, 
        0.810859, 0.0092846, 0, 0.297244, 
        0.795051, 0.00883304, 0, 0.315575, 
        0.780053, 0.00840272, 0, 0.334412, 
        0.76575, 0.00796438, 0, 0.35376, 
        0.752298, 0.00752526, 0, 0.373631, 
        0.739153, 0.00711486, 0, 0.394034, 
        0.725514, 0.00670361, 0, 0.414983, 
        0.711473, 0.00632656, 0, 0.436491, 
        0.696936, 0.00595206, 0, 0.458575, 
        0.682126, 0.00559191, 0, 0.481253, 
        0.667027, 0.00525362, 0, 0.504547, 
        0.651875, 0.00493805, 0, 0.528481, 
        0.636463, 0.00462848, 0, 0.553081, 
        0.620641, 0.00433936, 0, 0.578377, 
        0.604931, 0.00407, 0, 0.604404, 
        0.589549, 0.00380864, 0, 0.631197, 
        0.574712, 0.00357049, 0, 0.658795, 
        0.559775, 0.00334466, 0, 0.687238, 
        0.544514, 0.00312505, 0, 0.716559, 
        0.529555, 0.00293199, 0, 0.746776, 
        0.514402, 0.00274204, 0, 0.777849, 
        0.499302, 0.00256647, 0, 0.809524, 
        0.484114, 0.00239901, 0, 0.84127, 
        0.469308, 0.00225148, 0, 0.873016, 
        0.455133, 0.00210178, 0, 0.904762, 
        0.440939, 0.0019727, 0, 0.936508, 
        0.426627, 0.00184382, 0, 0.968254, 
        0.412509, 0.00172548, 0, 1, 
        1, 0.013628, 0, 0, 
        1, 0.0136281, 0, 0, 
        0.999999, 0.0136289, 0, 0, 
        0.999995, 0.0136327, 0, 0, 
        0.999983, 0.0136427, 0, 0, 
        0.99996, 0.0136638, 0, 0, 
        0.999917, 0.0137022, 0, 0, 
        0.999846, 0.0137652, 0, 0.000204597, 
        0.999736, 0.0138615, 0, 0.00116837, 
        0.999573, 0.0140007, 0, 0.00303325, 
        0.99934, 0.0141927, 0, 0.00580613, 
        0.999004, 0.0144457, 0, 0.00945626, 
        0.998407, 0.0147489, 0, 0.0139421, 
        0.995464, 0.014731, 0, 0.0192202, 
        0.993328, 0.0148283, 0, 0.0252495, 
        0.991799, 0.0150797, 0, 0.0319921, 
        0.990397, 0.0154316, 0, 0.0394138, 
        0.986835, 0.0155005, 0, 0.0474843, 
        0.983938, 0.0157308, 0, 0.0561763, 
        0.980154, 0.0158753, 0, 0.0654661, 
        0.975659, 0.0159581, 0, 0.0753326, 
        0.970171, 0.0159832, 0, 0.0857571, 
        0.964803, 0.0160084, 0, 0.0967236, 
        0.958366, 0.0159484, 0, 0.108218, 
        0.950613, 0.0158001, 0, 0.120227, 
        0.942874, 0.0155845, 0, 0.132741, 
        0.935005, 0.0154292, 0, 0.145751, 
        0.924991, 0.0150742, 0, 0.159249, 
        0.914814, 0.0146757, 0, 0.17323, 
        0.904743, 0.0143097, 0, 0.187687, 
        0.893216, 0.0138695, 0, 0.202619, 
        0.880769, 0.0133706, 0, 0.218021, 
        0.868136, 0.0128606, 0, 0.233894, 
        0.85469, 0.0123403, 0, 0.250238, 
        0.840593, 0.0118091, 0, 0.267052, 
        0.825808, 0.011253, 0, 0.284341, 
        0.81009, 0.0107099, 0, 0.302106, 
        0.79504, 0.0101636, 0, 0.320354, 
        0.779757, 0.00964041, 0, 0.33909, 
        0.764697, 0.00911896, 0, 0.358322, 
        0.750913, 0.00859533, 0, 0.378059, 
        0.738175, 0.00811592, 0, 0.398311, 
        0.725242, 0.00764504, 0, 0.41909, 
        0.711864, 0.00718885, 0, 0.440412, 
        0.698009, 0.00675843, 0, 0.462292, 
        0.683841, 0.00634984, 0, 0.484748, 
        0.669391, 0.00595502, 0, 0.507802, 
        0.654731, 0.00558671, 0, 0.531477, 
        0.639805, 0.00523578, 0, 0.555802, 
        0.624789, 0.00490834, 0, 0.580805, 
        0.609325, 0.00459448, 0, 0.606522, 
        0.593975, 0.00430342, 0, 0.63299, 
        0.578983, 0.00403019, 0, 0.66025, 
        0.564442, 0.0037707, 0, 0.688346, 
        0.549835, 0.0035316, 0, 0.717319, 
        0.535039, 0.00330255, 0, 0.7472, 
        0.520403, 0.00308932, 0, 0.777982, 
        0.505687, 0.00289335, 0, 0.809524, 
        0.490939, 0.00270818, 0, 0.84127, 
        0.476233, 0.0025343, 0, 0.873016, 
        0.461624, 0.00237097, 0, 0.904762, 
        0.447833, 0.00222065, 0, 0.936508, 
        0.433992, 0.00207561, 0, 0.968254, 
        0.420147, 0.00194955, 0, 1, 
        1, 0.0173415, 0, 0, 
        1, 0.0173416, 0, 0, 
        0.999999, 0.0173426, 0, 0, 
        0.999995, 0.0173468, 0, 0, 
        0.999983, 0.0173582, 0, 0, 
        0.999954, 0.0173822, 0, 0, 
        0.999908, 0.0174258, 0, 6.69501e-06, 
        0.999828, 0.0174973, 0, 0.000427399, 
        0.999705, 0.0176063, 0, 0.00171019, 
        0.999524, 0.0177631, 0, 0.0039248, 
        0.999263, 0.0179781, 0, 0.00705382, 
        0.998878, 0.018258, 0, 0.0110552, 
        0.998012, 0.0185551, 0, 0.0158812, 
        0.994614, 0.0184264, 0, 0.0214852, 
        0.993132, 0.0186385, 0, 0.0278239, 
        0.991563, 0.0189067, 0, 0.0348585, 
        0.989298, 0.0191577, 0, 0.0425544, 
        0.986036, 0.0192522, 0, 0.050881, 
        0.982558, 0.0194063, 0, 0.059811, 
        0.978531, 0.019486, 0, 0.0693209, 
        0.974198, 0.0195847, 0, 0.0793895, 
        0.968148, 0.0194749, 0, 0.0899984, 
        0.962565, 0.0194277, 0, 0.101132, 
        0.956041, 0.0192991, 0, 0.112775, 
        0.947749, 0.0189893, 0, 0.124917, 
        0.94018, 0.018704, 0, 0.137547, 
        0.93165, 0.0183458, 0, 0.150655, 
        0.921798, 0.0178775, 0, 0.164236, 
        0.911573, 0.0173618, 0, 0.178281, 
        0.901569, 0.0168482, 0, 0.192788, 
        0.890341, 0.016265, 0, 0.207752, 
        0.877835, 0.0156199, 0, 0.223171, 
        0.865472, 0.0149516, 0, 0.239044, 
        0.852905, 0.0143274, 0, 0.255371, 
        0.838906, 0.0136643, 0, 0.272153, 
        0.824888, 0.0129903, 0, 0.289393, 
        0.809977, 0.0123218, 0, 0.307093, 
        0.794697, 0.0116572, 0, 0.325259, 
        0.780028, 0.0110307, 0, 0.343896, 
        0.765124, 0.0104236, 0, 0.363012, 
        0.750411, 0.0098219, 0, 0.382617, 
        0.737264, 0.00924397, 0, 0.402719, 
        0.724799, 0.00868719, 0, 0.423332, 
        0.712253, 0.00816476, 0, 0.444469, 
        0.699267, 0.00767262, 0, 0.466146, 
        0.685618, 0.00719746, 0, 0.488383, 
        0.671736, 0.00673916, 0, 0.511199, 
        0.657777, 0.00631937, 0, 0.534618, 
        0.643497, 0.00592411, 0, 0.558668, 
        0.62889, 0.00553928, 0, 0.58338, 
        0.614299, 0.0051934, 0, 0.608787, 
        0.599197, 0.00485985, 0, 0.634929, 
        0.584175, 0.00454357, 0, 0.661849, 
        0.569541, 0.00425787, 0, 0.689594, 
        0.555193, 0.00397905, 0, 0.718211, 
        0.540947, 0.00372364, 0, 0.747742, 
        0.526593, 0.00348599, 0, 0.778205, 
        0.512335, 0.00326103, 0, 0.80953, 
        0.498017, 0.00305137, 0, 0.84127, 
        0.483609, 0.00285485, 0, 0.873016, 
        0.469368, 0.00267472, 0, 0.904762, 
        0.455037, 0.00249945, 0, 0.936508, 
        0.441493, 0.00234792, 0, 0.968254, 
        0.428147, 0.00219936, 0, 1, 
        1, 0.0219422, 0, 0, 
        1, 0.0219423, 0, 0, 
        0.999998, 0.0219434, 0, 0, 
        0.999993, 0.0219481, 0, 0, 
        0.999981, 0.021961, 0, 0, 
        0.999949, 0.0219879, 0, 0, 
        0.999896, 0.0220367, 0, 5.93194e-05, 
        0.999808, 0.0221167, 0, 0.00075364, 
        0.99967, 0.0222383, 0, 0.00237884, 
        0.999466, 0.0224125, 0, 0.00495612, 
        0.999174, 0.0226495, 0, 0.00844887, 
        0.998725, 0.0229525, 0, 0.0128058, 
        0.996979, 0.0231123, 0, 0.0179742, 
        0.994317, 0.0230742, 0, 0.0239047, 
        0.992781, 0.0232895, 0, 0.0305526, 
        0.991191, 0.0235734, 0, 0.0378786, 
        0.987787, 0.0236152, 0, 0.0458475, 
        0.985092, 0.0237994, 0, 0.0544287, 
        0.981121, 0.0238553, 0, 0.0635952, 
        0.976924, 0.0238706, 0, 0.0733233, 
        0.97218, 0.0238704, 0, 0.0835922, 
        0.965956, 0.0236598, 0, 0.0943839, 
        0.959998, 0.0234735, 0, 0.105682, 
        0.953245, 0.0232277, 0, 0.117474, 
        0.944445, 0.0226973, 0, 0.129747, 
        0.937087, 0.0223527, 0, 0.142491, 
        0.928341, 0.0218144, 0, 0.155697, 
        0.9184, 0.0211516, 0, 0.169358, 
        0.907959, 0.0204553, 0, 0.183469, 
        0.89808, 0.0197673, 0, 0.198024, 
        0.887047, 0.0189915, 0, 0.21302, 
        0.875221, 0.0182082, 0, 0.228455, 
        0.86269, 0.0173584, 0, 0.244329, 
        0.850735, 0.0165718, 0, 0.260639, 
        0.837545, 0.0157524, 0, 0.277389, 
        0.823639, 0.0149482, 0, 0.29458, 
        0.809699, 0.0141431, 0, 0.312216, 
        0.794797, 0.0133527, 0, 0.3303, 
        0.780578, 0.0126193, 0, 0.34884, 
        0.766019, 0.0118914, 0, 0.367842, 
        0.751447, 0.0111839, 0, 0.387315, 
        0.737275, 0.010514, 0, 0.40727, 
        0.724545, 0.00987277, 0, 0.427717, 
        0.712644, 0.00926569, 0, 0.448671, 
        0.700432, 0.00869029, 0, 0.470149, 
        0.687664, 0.00814691, 0, 0.492167, 
        0.674288, 0.00763012, 0, 0.514746, 
        0.660966, 0.00714437, 0, 0.537911, 
        0.647264, 0.00668457, 0, 0.561688, 
        0.633431, 0.00626581, 0, 0.586108, 
        0.619133, 0.00585593, 0, 0.611206, 
        0.604935, 0.00548188, 0, 0.637022, 
        0.590236, 0.00513288, 0, 0.663599, 
        0.575473, 0.0047906, 0, 0.690989, 
        0.561228, 0.00448895, 0, 0.719242, 
        0.547054, 0.00420233, 0, 0.748411, 
        0.533175, 0.00392869, 0, 0.778531, 
        0.519163, 0.00367445, 0, 0.809583, 
        0.505328, 0.00344097, 0, 0.84127, 
        0.491446, 0.00322003, 0, 0.873016, 
        0.477356, 0.00301283, 0, 0.904762, 
        0.46356, 0.00282592, 0, 0.936508, 
        0.449623, 0.00264956, 0, 0.968254, 
        0.436068, 0.00246956, 0, 1, 
        1, 0.0276135, 0, 0, 
        1, 0.0276136, 0, 0, 
        0.999998, 0.0276148, 0, 0, 
        0.999993, 0.0276201, 0, 0, 
        0.999976, 0.0276342, 0, 0, 
        0.999945, 0.027664, 0, 0, 
        0.999884, 0.0277179, 0, 0.00018679, 
        0.999784, 0.027806, 0, 0.00119607, 
        0.99963, 0.0279394, 0, 0.00318407, 
        0.999401, 0.0281295, 0, 0.00613601, 
        0.999066, 0.0283858, 0, 0.00999963, 
        0.998524, 0.0287027, 0, 0.0147164, 
        0.995702, 0.0286256, 0, 0.0202295, 
        0.993593, 0.0286733, 0, 0.0264876, 
        0.992067, 0.0288989, 0, 0.0334452, 
        0.990548, 0.0292135, 0, 0.0410621, 
        0.986775, 0.0291296, 0, 0.0493032, 
        0.984054, 0.0293099, 0, 0.0581381, 
        0.979481, 0.0291881, 0, 0.0675397, 
        0.975297, 0.0291598, 0, 0.0774848, 
        0.96981, 0.028954, 0, 0.0879528, 
        0.963524, 0.028628, 0, 0.0989258, 
        0.957398, 0.0283135, 0, 0.110388, 
        0.950088, 0.0278469, 0, 0.122327, 
        0.941538, 0.0271798, 0, 0.134729, 
        0.933332, 0.0265388, 0, 0.147587, 
        0.924392, 0.0257776, 0, 0.160889, 
        0.914581, 0.024916, 0, 0.174631, 
        0.904347, 0.0240242, 0, 0.188806, 
        0.894324, 0.0231229, 0, 0.203409, 
        0.883724, 0.022153, 0, 0.218437, 
        0.872207, 0.0211355, 0, 0.233888, 
        0.859927, 0.0201048, 0, 0.249761, 
        0.848373, 0.0191263, 0, 0.266056, 
        0.836023, 0.0181306, 0, 0.282774, 
        0.82289, 0.0171718, 0, 0.299917, 
        0.809324, 0.0162196, 0, 0.317488, 
        0.795361, 0.0152622, 0, 0.335493, 
        0.781253, 0.01439, 0, 0.353936, 
        0.767338, 0.013533, 0, 0.372825, 
        0.753156, 0.0127244, 0, 0.392168, 
        0.739122, 0.0119454, 0, 0.411976, 
        0.725358, 0.0112054, 0, 0.432259, 
        0.712949, 0.010487, 0, 0.453032, 
        0.701621, 0.00984032, 0, 0.47431, 
        0.689703, 0.00921495, 0, 0.496111, 
        0.677216, 0.00862492, 0, 0.518456, 
        0.664217, 0.00806882, 0, 0.541367, 
        0.65137, 0.00755922, 0, 0.564872, 
        0.638, 0.00705705, 0, 0.589001, 
        0.62453, 0.00661266, 0, 0.613789, 
        0.610601, 0.00618432, 0, 0.639277, 
        0.59676, 0.00578033, 0, 0.66551, 
        0.582433, 0.00540927, 0, 0.692539, 
        0.568026, 0.00506104, 0, 0.720422, 
        0.55414, 0.0047353, 0, 0.749216, 
        0.540178, 0.00442889, 0, 0.778974, 
        0.526513, 0.00414363, 0, 0.809711, 
        0.512954, 0.00388237, 0, 0.84127, 
        0.499403, 0.00362875, 0, 0.873016, 
        0.486026, 0.00340827, 0, 0.904762, 
        0.472345, 0.00318598, 0, 0.936508, 
        0.458828, 0.00297635, 0, 0.968254, 
        0.445379, 0.00279447, 0, 1, 
        1, 0.0345716, 0, 0, 
        1, 0.0345717, 0, 0, 
        0.999999, 0.034573, 0, 0, 
        0.999991, 0.0345787, 0, 0, 
        0.999974, 0.0345941, 0, 0, 
        0.999937, 0.0346263, 0, 1.88589e-06, 
        0.999869, 0.0346847, 0, 0.000409238, 
        0.999757, 0.0347798, 0, 0.0017674, 
        0.999582, 0.0349233, 0, 0.00413658, 
        0.999322, 0.0351265, 0, 0.00747408, 
        0.998939, 0.0353967, 0, 0.0117157, 
        0.998219, 0.0357018, 0, 0.0167966, 
        0.994974, 0.0354726, 0, 0.0226572, 
        0.993201, 0.0355621, 0, 0.0292445, 
        0.991573, 0.0357641, 0, 0.0365123, 
        0.989301, 0.0359252, 0, 0.0444203, 
        0.985712, 0.0358017, 0, 0.0529334, 
        0.982411, 0.0358353, 0, 0.0620214, 
        0.977827, 0.035617, 0, 0.0716574, 
        0.973278, 0.0354398, 0, 0.0818186, 
        0.967397, 0.0350483, 0, 0.0924846, 
        0.960696, 0.0344795, 0, 0.103638, 
        0.954349, 0.0339861, 0, 0.115263, 
        0.946066, 0.0331323, 0, 0.127348, 
        0.938012, 0.032359, 0, 0.13988, 
        0.929413, 0.0314413, 0, 0.152849, 
        0.920355, 0.0304103, 0, 0.166248, 
        0.910586, 0.0292785, 0, 0.18007, 
        0.900609, 0.0281391, 0, 0.194308, 
        0.890093, 0.0269103, 0, 0.208958, 
        0.880013, 0.0257269, 0, 0.224018, 
        0.869001, 0.0244671, 0, 0.239485, 
        0.85751, 0.0232252, 0, 0.255359, 
        0.84582, 0.0220117, 0, 0.271638, 
        0.834383, 0.0208274, 0, 0.288324, 
        0.822158, 0.0196628, 0, 0.305419, 
        0.809056, 0.0185306, 0, 0.322927, 
        0.795832, 0.0174174, 0, 0.340851, 
        0.782547, 0.0163758, 0, 0.359199, 
        0.7689, 0.015391, 0, 0.377975, 
        0.755526, 0.0144488, 0, 0.397189, 
        0.741681, 0.0135372, 0, 0.416851, 
        0.728178, 0.0126957, 0, 0.436971, 
        0.714642, 0.0118812, 0, 0.457564, 
        0.702756, 0.0111165, 0, 0.478644, 
        0.69175, 0.0104145, 0, 0.500229, 
        0.680159, 0.00974439, 0, 0.522339, 
        0.668073, 0.00911926, 0, 0.544997, 
        0.655405, 0.00851393, 0, 0.56823, 
        0.642921, 0.00797637, 0, 0.592068, 
        0.629993, 0.00745119, 0, 0.616546, 
        0.616828, 0.00696972, 0, 0.641705, 
        0.603305, 0.00652425, 0, 0.66759, 
        0.589833, 0.00610188, 0, 0.694255, 
        0.575945, 0.00570834, 0, 0.72176, 
        0.561745, 0.00533384, 0, 0.750168, 
        0.548277, 0.00500001, 0, 0.779545, 
        0.534467, 0.00467582, 0, 0.809933, 
        0.521032, 0.00438092, 0, 0.841272, 
        0.507877, 0.00410348, 0, 0.873016, 
        0.494654, 0.00383618, 0, 0.904762, 
        0.481592, 0.00358699, 0, 0.936508, 
        0.468509, 0.00337281, 0, 0.968254, 
        0.455293, 0.00316196, 0, 1, 
        1, 0.0430698, 0, 0, 
        1, 0.0430699, 0, 0, 
        0.999998, 0.0430713, 0, 0, 
        0.999991, 0.0430773, 0, 0, 
        0.99997, 0.0430936, 0, 0, 
        0.999928, 0.0431277, 0, 4.06396e-05, 
        0.999852, 0.0431893, 0, 0.000744376, 
        0.999724, 0.0432895, 0, 0.0024806, 
        0.999527, 0.0434397, 0, 0.00524779, 
        0.99923, 0.0436507, 0, 0.00898164, 
        0.998783, 0.0439255, 0, 0.0136083, 
        0.997507, 0.0441104, 0, 0.0190582, 
        0.994418, 0.0438225, 0, 0.0252694, 
        0.992864, 0.0439396, 0, 0.0321879, 
        0.991127, 0.0440962, 0, 0.039767, 
        0.987331, 0.0438408, 0, 0.0479667, 
        0.984819, 0.0438991, 0, 0.056752, 
        0.980384, 0.0435906, 0, 0.0660929, 
        0.975846, 0.0432543, 0, 0.075963, 
        0.970748, 0.0428293, 0, 0.0863398, 
        0.964303, 0.042153, 0, 0.0972035, 
        0.95772, 0.0414111, 0, 0.108537, 
        0.950747, 0.0405893, 0, 0.120325, 
        0.942533, 0.0394887, 0, 0.132554, 
        0.934045, 0.0383544, 0, 0.145215, 
        0.924942, 0.037057, 0, 0.158296, 
        0.915811, 0.0356993, 0, 0.17179, 
        0.90612, 0.0342401, 0, 0.185691, 
        0.896434, 0.0328078, 0, 0.199993, 
        0.886021, 0.031288, 0, 0.214691, 
        0.876081, 0.0297776, 0, 0.229782, 
        0.865608, 0.0282334, 0, 0.245265, 
        0.854924, 0.026749, 0, 0.261138, 
        0.843607, 0.02526, 0, 0.277401, 
        0.832456, 0.0238214, 0, 0.294056, 
        0.821342, 0.0224682, 0, 0.311104, 
        0.809303, 0.0211297, 0, 0.328548, 
        0.796468, 0.0198387, 0, 0.346394, 
        0.784046, 0.0186227, 0, 0.364645, 
        0.771262, 0.0174561, 0, 0.38331, 
        0.758118, 0.0163806, 0, 0.402396, 
        0.745075, 0.0153287, 0, 0.421912, 
        0.731926, 0.0143647, 0, 0.44187, 
        0.71863, 0.0134363, 0, 0.462283, 
        0.705414, 0.0125603, 0, 0.483165, 
        0.693792, 0.0117508, 0, 0.504535, 
        0.683108, 0.0110016, 0, 0.52641, 
        0.67183, 0.0102757, 0, 0.548816, 
        0.66015, 0.00962044, 0, 0.571776, 
        0.647907, 0.00898031, 0, 0.595323, 
        0.635734, 0.00840811, 0, 0.619489, 
        0.623208, 0.00786211, 0, 0.644317, 
        0.610438, 0.00734953, 0, 0.669852, 
        0.597345, 0.00687688, 0, 0.696148, 
        0.584138, 0.00643469, 0, 0.723267, 
        0.5707, 0.00602236, 0, 0.75128, 
        0.556966, 0.0056324, 0, 0.780258, 
        0.543607, 0.00528277, 0, 0.810268, 
        0.530213, 0.00493999, 0, 0.841311, 
        0.516912, 0.00462265, 0, 0.873016, 
        0.503916, 0.0043307, 0, 0.904762, 
        0.491146, 0.00406858, 0, 0.936508, 
        0.478439, 0.00381436, 0, 0.968254, 
        0.465834, 0.00358003, 0, 1, 
        1, 0.0534039, 0, 0, 
        1, 0.053404, 0, 0, 
        0.999998, 0.0534055, 0, 0, 
        0.999989, 0.0534116, 0, 0, 
        0.999968, 0.0534283, 0, 0, 
        0.999918, 0.0534633, 0, 0.000155895, 
        0.99983, 0.0535262, 0, 0.00120914, 
        0.999685, 0.0536281, 0, 0.00334944, 
        0.999461, 0.0537799, 0, 0.00653077, 
        0.999119, 0.0539902, 0, 0.0106718, 
        0.998582, 0.0542524, 0, 0.0156907, 
        0.995919, 0.0540318, 0, 0.0215147, 
        0.993735, 0.0538914, 0, 0.0280801, 
        0.992126, 0.0539557, 0, 0.0353323, 
        0.990266, 0.0540401, 0, 0.0432247, 
        0.986317, 0.0536064, 0, 0.0517172, 
        0.983213, 0.0534425, 0, 0.0607754, 
        0.978303, 0.0528622, 0, 0.0703698, 
        0.973665, 0.0523363, 0, 0.0804742, 
        0.968091, 0.0516165, 0, 0.0910667, 
        0.961026, 0.0505434, 0, 0.102128, 
        0.954333, 0.049523, 0, 0.113641, 
        0.946372, 0.0481698, 0, 0.125591, 
        0.938254, 0.0467674, 0, 0.137965, 
        0.929516, 0.0452341, 0, 0.150754, 
        0.920106, 0.0435083, 0, 0.163947, 
        0.910899, 0.0417399, 0, 0.177537, 
        0.901532, 0.0399389, 0, 0.191516, 
        0.891919, 0.0380901, 0, 0.205881, 
        0.882006, 0.0362341, 0, 0.220626, 
        0.871965, 0.0343444, 0, 0.235749, 
        0.862145, 0.0324832, 0, 0.251248, 
        0.852058, 0.0306681, 0, 0.267121, 
        0.84161, 0.0289097, 0, 0.283368, 
        0.830806, 0.0272079, 0, 0.299992, 
        0.820476, 0.0256089, 0, 0.316992, 
        0.809514, 0.0240394, 0, 0.334374, 
        0.797865, 0.0225379, 0, 0.35214, 
        0.785621, 0.0211235, 0, 0.370296, 
        0.773765, 0.0197908, 0, 0.388849, 
        0.761629, 0.0185235, 0, 0.407807, 
        0.748891, 0.0173358, 0, 0.427178, 
        0.736437, 0.0162305, 0, 0.446974, 
        0.723707, 0.0151778, 0, 0.467207, 
        0.710606, 0.0141791, 0, 0.487892, 
        0.698019, 0.0132592, 0, 0.509046, 
        0.686203, 0.0123887, 0, 0.530687, 
        0.675692, 0.0115976, 0, 0.552839, 
        0.664826, 0.0108325, 0, 0.575527, 
        0.65349, 0.0101348, 0, 0.59878, 
        0.641774, 0.00947756, 0, 0.622634, 
        0.629794, 0.00886058, 0, 0.647128, 
        0.617647, 0.00828526, 0, 0.672308, 
        0.60534, 0.00775312, 0, 0.698231, 
        0.592718, 0.00726033, 0, 0.724958, 
        0.579746, 0.00679731, 0, 0.752563, 
        0.566763, 0.00636111, 0, 0.781127, 
        0.553515, 0.00595228, 0, 0.810733, 
        0.540118, 0.00556876, 0, 0.841426, 
        0.527325, 0.00523051, 0, 0.873016, 
        0.514265, 0.00490712, 0, 0.904762, 
        0.501406, 0.00460297, 0, 0.936508, 
        0.488922, 0.00431247, 0, 0.968254, 
        0.476541, 0.0040472, 0, 1, 
        1, 0.0659184, 0, 0, 
        1, 0.0659185, 0, 0, 
        0.999998, 0.06592, 0, 0, 
        0.999988, 0.0659259, 0, 0, 
        0.999963, 0.0659423, 0, 0, 
        0.999907, 0.0659764, 0, 0.000374198, 
        0.999806, 0.0660376, 0, 0.00182071, 
        0.999639, 0.0661361, 0, 0.0043894, 
        0.999378, 0.0662814, 0, 0.00800055, 
        0.998985, 0.0664779, 0, 0.0125594, 
        0.998285, 0.0666914, 0, 0.0179786, 
        0.995071, 0.0661989, 0, 0.0241822, 
        0.993172, 0.0660454, 0, 0.031106, 
        0.991438, 0.0660105, 0, 0.0386952, 
        0.988428, 0.0656875, 0, 0.0469032, 
        0.985218, 0.0652913, 0, 0.0556905, 
        0.981128, 0.0647107, 0, 0.065023, 
        0.976015, 0.0638491, 0, 0.0748717, 
        0.97097, 0.062993, 0, 0.0852112, 
        0.964582, 0.0617927, 0, 0.0960199, 
        0.957383, 0.0603626, 0, 0.107279, 
        0.949969, 0.0588128, 0, 0.118971, 
        0.941843, 0.0570274, 0, 0.131084, 
        0.933624, 0.0551885, 0, 0.143604, 
        0.924543, 0.053122, 0, 0.156521, 
        0.914919, 0.0508897, 0, 0.169825, 
        0.905773, 0.0486418, 0, 0.18351, 
        0.896434, 0.0463364, 0, 0.197569, 
        0.887195, 0.0440623, 0, 0.211997, 
        0.877706, 0.0417799, 0, 0.226789, 
        0.867719, 0.03945, 0, 0.241944, 
        0.858587, 0.037243, 0, 0.257458, 
        0.849317, 0.0350956, 0, 0.273331, 
        0.839585, 0.0329852, 0, 0.289563, 
        0.829856, 0.0310028, 0, 0.306154, 
        0.819589, 0.0290953, 0, 0.323108, 
        0.809714, 0.0272738, 0, 0.340426, 
        0.79934, 0.0255631, 0, 0.358113, 
        0.788224, 0.0239175, 0, 0.376175, 
        0.776619, 0.0223831, 0, 0.394616, 
        0.76521, 0.0209298, 0, 0.413445, 
        0.753716, 0.0195786, 0, 0.432671, 
        0.741564, 0.0183001, 0, 0.452305, 
        0.729413, 0.0171259, 0, 0.472358, 
        0.717146, 0.0159933, 0, 0.492845, 
        0.70436, 0.0149495, 0, 0.513783, 
        0.69219, 0.0139681, 0, 0.535189, 
        0.680289, 0.0130577, 0, 0.557087, 
        0.669611, 0.0122198, 0, 0.5795, 
        0.659113, 0.0114174, 0, 0.602459, 
        0.648148, 0.0106729, 0, 0.625997, 
        0.636905, 0.00998997, 0, 0.650154, 
        0.625154, 0.00934313, 0, 0.674976, 
        0.613481, 0.00874839, 0, 0.700518, 
        0.60154, 0.00818265, 0, 0.726845, 
        0.58943, 0.00766889, 0, 0.754032, 
        0.576828, 0.00717153, 0, 0.782167, 
        0.564194, 0.00672696, 0, 0.811344, 
        0.551501, 0.00630863, 0, 0.841644, 
        0.538635, 0.00592177, 0, 0.873016, 
        0.525724, 0.00554888, 0, 0.904762, 
        0.513209, 0.00520225, 0, 0.936508, 
        0.500457, 0.00488231, 0, 0.968254, 
        0.48799, 0.00457153, 0, 1, 
        1, 0.0810131, 0, 0, 
        1, 0.0810133, 0, 0, 
        0.999997, 0.0810145, 0, 0, 
        0.999985, 0.08102, 0, 0, 
        0.999956, 0.0810347, 0, 1.95026e-05, 
        0.999893, 0.0810656, 0, 0.000719316, 
        0.999777, 0.0811205, 0, 0.00259774, 
        0.999583, 0.081208, 0, 0.00561807, 
        0.999281, 0.0813343, 0, 0.00967472, 
        0.998813, 0.0814969, 0, 0.0146627, 
        0.997597, 0.0815217, 0, 0.0204902, 
        0.994379, 0.0808502, 0, 0.0270802, 
        0.992744, 0.0806792, 0, 0.0343674, 
        0.990745, 0.0804589, 0, 0.0422974, 
        0.986646, 0.0796107, 0, 0.0508242, 
        0.983611, 0.0790913, 0, 0.0599087, 
        0.978869, 0.0780746, 0, 0.0695175, 
        0.973475, 0.0768218, 0, 0.0796223, 
        0.967845, 0.0754926, 0, 0.0901983, 
        0.960778, 0.0737063, 0, 0.101224, 
        0.953333, 0.0718052, 0, 0.112682, 
        0.945274, 0.0695946, 0, 0.124555, 
        0.936955, 0.0672492, 0, 0.136831, 
        0.928319, 0.0647732, 0, 0.149496, 
        0.919075, 0.0620947, 0, 0.162542, 
        0.909114, 0.0591816, 0, 0.175958, 
        0.900137, 0.0563917, 0, 0.189739, 
        0.891069, 0.0535392, 0, 0.203877, 
        0.882262, 0.0507642, 0, 0.218368, 
        0.873232, 0.0479793, 0, 0.233208, 
        0.864042, 0.045226, 0, 0.248393, 
        0.855002, 0.0425413, 0, 0.263923, 
        0.846569, 0.0400126, 0, 0.279796, 
        0.837714, 0.0375269, 0, 0.296012, 
        0.828918, 0.0352027, 0, 0.312573, 
        0.819783, 0.0330011, 0, 0.329479, 
        0.810129, 0.0308908, 0, 0.346734, 
        0.800866, 0.0289112, 0, 0.364342, 
        0.79093, 0.0270255, 0, 0.382307, 
        0.780593, 0.0252758, 0, 0.400637, 
        0.769511, 0.0236178, 0, 0.419337, 
        0.758558, 0.0220652, 0, 0.438418, 
        0.747632, 0.0206289, 0, 0.457889, 
        0.736146, 0.0192873, 0, 0.477761, 
        0.724093, 0.0180333, 0, 0.49805, 
        0.71234, 0.0168264, 0, 0.51877, 
        0.700201, 0.015746, 0, 0.53994, 
        0.687949, 0.0147027, 0, 0.561581, 
        0.676163, 0.0137512, 0, 0.583718, 
        0.665001, 0.0128655, 0, 0.60638, 
        0.65472, 0.0120366, 0, 0.629599, 
        0.644213, 0.0112604, 0, 0.653415, 
        0.633382, 0.0105413, 0, 0.677874, 
        0.62212, 0.00986498, 0, 0.70303, 
        0.610631, 0.00923308, 0, 0.728948, 
        0.599078, 0.00864206, 0, 0.755706, 
        0.587519, 0.00811784, 0, 0.783396, 
        0.575505, 0.00761237, 0, 0.812121, 
        0.563148, 0.00713949, 0, 0.841989, 
        0.550828, 0.00668379, 0, 0.873035, 
        0.538458, 0.00627715, 0, 0.904762, 
        0.525905, 0.00588336, 0, 0.936508, 
        0.513517, 0.00552687, 0, 0.968254, 
        0.501395, 0.00519681, 0, 1, 
        1, 0.0991506, 0, 0, 
        1, 0.0991504, 0, 0, 
        0.999996, 0.0991515, 0, 0, 
        0.999984, 0.0991558, 0, 0, 
        0.999947, 0.0991672, 0, 0.000114389, 
        0.999874, 0.0991912, 0, 0.00121503, 
        0.999739, 0.0992331, 0, 0.00356108, 
        0.999514, 0.0992983, 0, 0.00705578, 
        0.999159, 0.0993877, 0, 0.011574, 
        0.998586, 0.0994837, 0, 0.017003, 
        0.995731, 0.0988425, 0, 0.0232484, 
        0.993384, 0.098276, 0, 0.0302318, 
        0.991615, 0.0979269, 0, 0.0378884, 
        0.989029, 0.0973432, 0, 0.0461641, 
        0.985373, 0.0963539, 0, 0.0550136, 
        0.981278, 0.0952306, 0, 0.0643988, 
        0.975777, 0.0936233, 0, 0.0742868, 
        0.970526, 0.0920219, 0, 0.0846501, 
        0.963755, 0.0898912, 0, 0.0954644, 
        0.956676, 0.0876064, 0, 0.106709, 
        0.948099, 0.0847751, 0, 0.118367, 
        0.939718, 0.0818638, 0, 0.130423, 
        0.931305, 0.078857, 0, 0.142862, 
        0.922342, 0.0756127, 0, 0.155674, 
        0.912842, 0.0721473, 0, 0.168849, 
        0.903304, 0.0686195, 0, 0.182378, 
        0.89411, 0.0650589, 0, 0.196255, 
        0.885512, 0.0616022, 0, 0.210473, 
        0.877193, 0.0582434, 0, 0.225027, 
        0.86877, 0.0548979, 0, 0.239915, 
        0.860267, 0.0516095, 0, 0.255132, 
        0.851915, 0.048468, 0, 0.270678, 
        0.843912, 0.0454447, 0, 0.286551, 
        0.83604, 0.0425612, 0, 0.302751, 
        0.828245, 0.0398752, 0, 0.31928, 
        0.820159, 0.0373198, 0, 0.336138, 
        0.81167, 0.034916, 0, 0.35333, 
        0.802659, 0.0326402, 0, 0.370858, 
        0.793921, 0.0304901, 0, 0.388728, 
        0.784713, 0.0284857, 0, 0.406944, 
        0.774946, 0.0266186, 0, 0.425515, 
        0.76448, 0.0248593, 0, 0.444449, 
        0.753793, 0.0232114, 0, 0.463756, 
        0.743506, 0.0217039, 0, 0.483447, 
        0.732555, 0.0202841, 0, 0.503535, 
        0.720965, 0.0189648, 0, 0.524036, 
        0.709422, 0.0177189, 0, 0.544968, 
        0.697756, 0.0165626, 0, 0.56635, 
        0.685565, 0.015483, 0, 0.588208, 
        0.673987, 0.0144892, 0, 0.610569, 
        0.66244, 0.0135607, 0, 0.633466, 
        0.651675, 0.0126956, 0, 0.656936, 
        0.641598, 0.0118788, 0, 0.681025, 
        0.63121, 0.0111261, 0, 0.705788, 
        0.620514, 0.010437, 0, 0.731289, 
        0.609366, 0.00978747, 0, 0.757606, 
        0.598137, 0.00917257, 0, 0.784834, 
        0.586966, 0.00859778, 0, 0.813085, 
        0.575549, 0.00806803, 0, 0.842485, 
        0.563797, 0.00757294, 0, 0.87313, 
        0.551758, 0.00710592, 0, 0.904762, 
        0.539894, 0.0066841, 0, 0.936508, 
        0.527901, 0.00627901, 0, 0.968254, 
        0.515819, 0.00590506, 0, 1, 
        1, 0.120864, 0, 0, 
        1, 0.120864, 0, 0, 
        0.999996, 0.120864, 0, 0, 
        0.99998, 0.120867, 0, 0, 
        0.99994, 0.120872, 0, 0.000323781, 
        0.999852, 0.120884, 0, 0.00188693, 
        0.999693, 0.120903, 0, 0.00473489, 
        0.999426, 0.120929, 0, 0.00872704, 
        0.999002, 0.120955, 0, 0.0137237, 
        0.998235, 0.120918, 0, 0.0196068, 
        0.994608, 0.119764, 0, 0.0262803, 
        0.992997, 0.119265, 0, 0.0336657, 
        0.990968, 0.11863, 0, 0.0416987, 
        0.987002, 0.117261, 0, 0.0503261, 
        0.983524, 0.116009, 0, 0.0595035, 
        0.97875, 0.114252, 0, 0.0691935, 
        0.972652, 0.11193, 0, 0.0793645, 
        0.966613, 0.109555, 0, 0.0899894, 
        0.959275, 0.106612, 0, 0.101045, 
        0.951272, 0.103375, 0, 0.112512, 
        0.942323, 0.0996594, 0, 0.124372, 
        0.933679, 0.0958841, 0, 0.136611, 
        0.924822, 0.0919265, 0, 0.149216, 
        0.915742, 0.0878061, 0, 0.162176, 
        0.906348, 0.0834894, 0, 0.175482, 
        0.896883, 0.079085, 0, 0.189125, 
        0.88774, 0.0746745, 0, 0.203098, 
        0.87986, 0.0705773, 0, 0.217396, 
        0.871998, 0.0665005, 0, 0.232015, 
        0.864325, 0.0625413, 0, 0.24695, 
        0.856685, 0.0586781, 0, 0.2622, 
        0.84925, 0.0550063, 0, 0.277761, 
        0.841719, 0.0514727, 0, 0.293634, 
        0.834755, 0.0481398, 0, 0.309819, 
        0.827853, 0.0450172, 0, 0.326315, 
        0.820888, 0.0420969, 0, 0.343126, 
        0.813616, 0.0393702, 0, 0.360254, 
        0.805767, 0.0367771, 0, 0.377701, 
        0.797338, 0.0343274, 0, 0.395474, 
        0.789122, 0.0320529, 0, 0.413577, 
        0.780601, 0.0299485, 0, 0.432018, 
        0.771424, 0.0279812, 0, 0.450804, 
        0.761502, 0.0261054, 0, 0.469944, 
        0.751166, 0.0243942, 0, 0.489451, 
        0.741276, 0.0228087, 0, 0.509337, 
        0.730898, 0.0213265, 0, 0.529617, 
        0.719878, 0.0199307, 0, 0.550307, 
        0.708379, 0.0186574, 0, 0.571428, 
        0.697165, 0.0174446, 0, 0.593003, 
        0.685554, 0.0163144, 0, 0.615059, 
        0.673631, 0.015276, 0, 0.637628, 
        0.662385, 0.0143003, 0, 0.660746, 
        0.651059, 0.0134112, 0, 0.68446, 
        0.640451, 0.0125794, 0, 0.70882, 
        0.630536, 0.011793, 0, 0.733893, 
        0.620316, 0.0110547, 0, 0.759756, 
        0.609722, 0.0103668, 0, 0.786505, 
        0.598804, 0.00973009, 0, 0.814259, 
        0.587871, 0.00912812, 0, 0.843157, 
        0.577121, 0.00858916, 0, 0.87334, 
        0.566019, 0.00807333, 0, 0.904762, 
        0.554664, 0.00759687, 0, 0.936508, 
        0.543101, 0.00714759, 0, 0.968254, 
        0.531558, 0.00673418, 0, 1, 
        1, 0.146767, 0, 0, 
        1, 0.146767, 0, 0, 
        0.999997, 0.146767, 0, 0, 
        0.999977, 0.146765, 0, 3.20658e-06, 
        0.999929, 0.146762, 0, 0.000682576, 
        0.999823, 0.146753, 0, 0.00276402, 
        0.999633, 0.146735, 0, 0.00614771, 
        0.999314, 0.146699, 0, 0.0106613, 
        0.998796, 0.14662, 0, 0.0161546, 
        0.997124, 0.146107, 0, 0.0225063, 
        0.994062, 0.144857, 0, 0.0296198, 
        0.992154, 0.144011, 0, 0.037417, 
        0.989186, 0.142712, 0, 0.0458348, 
        0.985279, 0.140926, 0, 0.0548211, 
        0.980826, 0.13885, 0, 0.0643326, 
        0.975056, 0.136168, 0, 0.074333, 
        0.969005, 0.133217, 0, 0.0847917, 
        0.961554, 0.12959, 0, 0.0956828, 
        0.954206, 0.125886, 0, 0.106984, 
        0.945046, 0.121335, 0, 0.118675, 
        0.935678, 0.116492, 0, 0.130741, 
        0.926748, 0.111635, 0, 0.143166, 
        0.917764, 0.106625, 0, 0.155939, 
        0.908358, 0.101325, 0, 0.169049, 
        0.899219, 0.0960249, 0, 0.182487, 
        0.890089, 0.0906527, 0, 0.196245, 
        0.881488, 0.0853905, 0, 0.210317, 
        0.874031, 0.0804177, 0, 0.224697, 
        0.866932, 0.0756005, 0, 0.23938, 
        0.859976, 0.0709019, 0, 0.254364, 
        0.853375, 0.0664391, 0, 0.269646, 
        0.846971, 0.0622012, 0, 0.285223, 
        0.840483, 0.058129, 0, 0.301096, 
        0.833969, 0.0542762, 0, 0.317265, 
        0.82806, 0.0507042, 0, 0.333729, 
        0.822128, 0.047368, 0, 0.350491, 
        0.815989, 0.044272, 0, 0.367554, 
        0.809336, 0.0413444, 0, 0.38492, 
        0.802177, 0.038601, 0, 0.402594, 
        0.79441, 0.0360227, 0, 0.420582, 
        0.786573, 0.0336383, 0, 0.438891, 
        0.778619, 0.0314321, 0, 0.457527, 
        0.77, 0.029362, 0, 0.476499, 
        0.760698, 0.0274102, 0, 0.49582, 
        0.750932, 0.0256146, 0, 0.5155, 
        0.740993, 0.023974, 0, 0.535555, 
        0.731159, 0.0224182, 0, 0.556, 
        0.720836, 0.0209889, 0, 0.576855, 
        0.709913, 0.0196411, 0, 0.598143, 
        0.698415, 0.0183824, 0, 0.619888, 
        0.68745, 0.0172222, 0, 0.642123, 
        0.676154, 0.0161509, 0, 0.664883, 
        0.664383, 0.0151397, 0, 0.688211, 
        0.6533, 0.0141873, 0, 0.71216, 
        0.642072, 0.0133105, 0, 0.736792, 
        0.631412, 0.0124932, 0, 0.762186, 
        0.621622, 0.0117408, 0, 0.788439, 
        0.611681, 0.0110358, 0, 0.815672, 
        0.60142, 0.0103775, 0, 0.844034, 
        0.59083, 0.00975623, 0, 0.873699, 
        0.580254, 0.00918084, 0, 0.904765, 
        0.569841, 0.00864721, 0, 0.936508, 
        0.559224, 0.00815731, 0, 0.968254, 
        0.548315, 0.00767924, 0, 1, 
        1, 0.177563, 0, 0, 
        1, 0.177563, 0, 0, 
        0.999994, 0.177562, 0, 0, 
        0.999972, 0.177555, 0, 6.64171e-05, 
        0.999914, 0.177536, 0, 0.0012276, 
        0.999787, 0.177496, 0, 0.00388025, 
        0.999556, 0.17742, 0, 0.00783463, 
        0.999165, 0.177285, 0, 0.0128953, 
        0.9985, 0.177037, 0, 0.0189053, 
        0.995388, 0.175634, 0, 0.025742, 
        0.993102, 0.174375, 0, 0.033309, 
        0.990992, 0.173121, 0, 0.0415298, 
        0.986932, 0.170896, 0, 0.0503425, 
        0.982786, 0.16847, 0, 0.0596964, 
        0.977592, 0.165455, 0, 0.0695498, 
        0.971075, 0.161676, 0, 0.0798676, 
        0.963967, 0.157458, 0, 0.0906201, 
        0.956397, 0.152836, 0, 0.101783, 
        0.947489, 0.147467, 0, 0.113333, 
        0.937564, 0.14145, 0, 0.125254, 
        0.928182, 0.135383, 0, 0.137529, 
        0.919027, 0.129212, 0, 0.150144, 
        0.909618, 0.12276, 0, 0.163088, 
        0.900492, 0.116273, 0, 0.176351, 
        0.891671, 0.1098, 0, 0.189924, 
        0.883146, 0.103362, 0, 0.203799, 
        0.875151, 0.0970799, 0, 0.21797, 
        0.868338, 0.0911732, 0, 0.232433, 
        0.862033, 0.0854966, 0, 0.247182, 
        0.856107, 0.0800691, 0, 0.262216, 
        0.850644, 0.0749618, 0, 0.27753, 
        0.845261, 0.070079, 0, 0.293124, 
        0.839885, 0.0654321, 0, 0.308997, 
        0.834609, 0.0610975, 0, 0.325149, 
        0.829083, 0.0569741, 0, 0.341581, 
        0.82404, 0.0531736, 0, 0.358294, 
        0.818968, 0.049665, 0, 0.37529, 
        0.813496, 0.0463856, 0, 0.392573, 
        0.807533, 0.0433217, 0, 0.410148, 
        0.80099, 0.0404402, 0, 0.428019, 
        0.793891, 0.0377578, 0, 0.446192, 
        0.786281, 0.0352616, 0, 0.464676, 
        0.778773, 0.0329577, 0, 0.483478, 
        0.770737, 0.030808, 0, 0.502608, 
        0.762094, 0.0287964, 0, 0.522079, 
        0.752898, 0.0269254, 0, 0.541905, 
        0.743306, 0.0251926, 0, 0.5621, 
        0.733416, 0.023595, 0, 0.582684, 
        0.723742, 0.0221155, 0, 0.603677, 
        0.713542, 0.0207435, 0, 0.625106, 
        0.702755, 0.019434, 0, 0.646998, 
        0.691484, 0.0182046, 0, 0.66939, 
        0.680531, 0.0170771, 0, 0.692324, 
        0.66953, 0.0160339, 0, 0.715849, 
        0.658126, 0.0150677, 0, 0.740028, 
        0.646933, 0.0141551, 0, 0.764937, 
        0.636107, 0.0133179, 0, 0.790673, 
        0.625271, 0.0125284, 0, 0.817358, 
        0.615225, 0.0117937, 0, 0.84515, 
        0.605678, 0.0111181, 0, 0.874244, 
        0.59583, 0.0104759, 0, 0.904828, 
        0.585704, 0.00986672, 0, 0.936508, 
        0.575413, 0.00929712, 0, 0.968254, 
        0.565373, 0.00876713, 0, 1, 
        1, 0.214058, 0, 0, 
        0.999999, 0.214058, 0, 0, 
        0.999994, 0.214055, 0, 0, 
        0.999966, 0.214039, 0, 0.000259642, 
        0.999893, 0.213998, 0, 0.00200075, 
        0.999737, 0.21391, 0, 0.00527775, 
        0.999449, 0.213745, 0, 0.00983959, 
        0.99896, 0.213458, 0, 0.0154755, 
        0.9979, 0.212855, 0, 0.0220249, 
        0.994278, 0.210779, 0, 0.0293654, 
        0.992254, 0.20926, 0, 0.0374021, 
        0.98881, 0.206908, 0, 0.0460604, 
        0.984715, 0.204009, 0, 0.0552802, 
        0.979738, 0.200471, 0, 0.0650127, 
        0.972884, 0.195813, 0, 0.0752175, 
        0.965996, 0.190856, 0, 0.0858612, 
        0.957974, 0.185077, 0, 0.0969155, 
        0.949155, 0.17868, 0, 0.108356, 
        0.939288, 0.171513, 0, 0.120163, 
        0.928996, 0.163838, 0, 0.132319, 
        0.919563, 0.156246, 0, 0.144808, 
        0.910004, 0.148359, 0, 0.157618, 
        0.900791, 0.140417, 0, 0.170737, 
        0.892135, 0.132569, 0, 0.184155, 
        0.883803, 0.124741, 0, 0.197866, 
        0.876034, 0.117091, 0, 0.211861, 
        0.869219, 0.109835, 0, 0.226134, 
        0.863062, 0.102859, 0, 0.240682, 
        0.857795, 0.0962928, 0, 0.255499, 
        0.853009, 0.0900725, 0, 0.270583, 
        0.848603, 0.0842101, 0, 0.285931, 
        0.844335, 0.0786527, 0, 0.301542, 
        0.840208, 0.0734397, 0, 0.317415, 
        0.836035, 0.0685334, 0, 0.33355, 
        0.83172, 0.0639275, 0, 0.349948, 
        0.827135, 0.0595909, 0, 0.36661, 
        0.822797, 0.0556204, 0, 0.383539, 
        0.818387, 0.0519394, 0, 0.400738, 
        0.813565, 0.0485317, 0, 0.41821, 
        0.808142, 0.0453138, 0, 0.435961, 
        0.802212, 0.0423354, 0, 0.453997, 
        0.79573, 0.0395553, 0, 0.472324, 
        0.788741, 0.036988, 0, 0.490951, 
        0.781093, 0.0345688, 0, 0.509887, 
        0.773597, 0.0323297, 0, 0.529144, 
        0.765622, 0.0302719, 0, 0.548735, 
        0.757083, 0.0283477, 0, 0.568674, 
        0.747992, 0.0265562, 0, 0.588979, 
        0.738591, 0.0248844, 0, 0.609671, 
        0.728719, 0.0233342, 0, 0.630773, 
        0.719146, 0.0219081, 0, 0.652314, 
        0.709165, 0.0205711, 0, 0.674328, 
        0.69875, 0.0193248, 0, 0.696854, 
        0.687884, 0.0181582, 0, 0.719942, 
        0.676818, 0.0170746, 0, 0.743651, 
        0.666247, 0.0160718, 0, 0.768057, 
        0.655284, 0.0151262, 0, 0.793253, 
        0.64401, 0.0142561, 0, 0.819363, 
        0.633353, 0.0134327, 0, 0.846547, 
        0.622674, 0.012653, 0, 0.875017, 
        0.612265, 0.0119354, 0, 0.905021, 
        0.602455, 0.0112533, 0, 0.936508, 
        0.593147, 0.0106234, 0, 0.968254, 
        0.583592, 0.0100213, 0, 1, 
        1, 0.25717, 0, 0, 
        1, 0.25717, 0, 0, 
        0.999992, 0.257164, 0, 0, 
        0.999958, 0.257135, 0, 0.000641715, 
        0.999864, 0.25706, 0, 0.00305314, 
        0.999666, 0.256897, 0, 0.00700975, 
        0.999302, 0.256596, 0, 0.0122194, 
        0.998663, 0.25607, 0, 0.0184622, 
        0.995607, 0.254123, 0, 0.0255773, 
        0.993094, 0.252081, 0, 0.0334439, 
        0.9907, 0.249867, 0, 0.0419696, 
        0.98594, 0.246118, 0, 0.0510823, 
        0.981214, 0.242049, 0, 0.0607242, 
        0.974966, 0.236869, 0, 0.0708486, 
        0.967589, 0.230724, 0, 0.081417, 
        0.95915, 0.223635, 0, 0.0923974, 
        0.950257, 0.21596, 0, 0.103763, 
        0.940165, 0.207296, 0, 0.115491, 
        0.929396, 0.197901, 0, 0.127562, 
        0.919288, 0.188437, 0, 0.13996, 
        0.909428, 0.178762, 0, 0.15267, 
        0.900105, 0.169072, 0, 0.165679, 
        0.891418, 0.159478, 0, 0.178979, 
        0.883347, 0.15002, 0, 0.192558, 
        0.875992, 0.140813, 0, 0.20641, 
        0.869466, 0.13196, 0, 0.220529, 
        0.863699, 0.123501, 0, 0.234907, 
        0.858553, 0.115436, 0, 0.249542, 
        0.854379, 0.107901, 0, 0.264428, 
        0.850894, 0.10088, 0, 0.279564, 
        0.847632, 0.0942296, 0, 0.294947, 
        0.844571, 0.0879861, 0, 0.310575, 
        0.84163, 0.0821534, 0, 0.326448, 
        0.838542, 0.0766409, 0, 0.342566, 
        0.835412, 0.0715322, 0, 0.358929, 
        0.831899, 0.0666883, 0, 0.37554, 
        0.828177, 0.0622175, 0, 0.392399, 
        0.82416, 0.0580452, 0, 0.409511, 
        0.820393, 0.054267, 0, 0.426878, 
        0.816068, 0.0507172, 0, 0.444506, 
        0.811201, 0.0474041, 0, 0.4624, 
        0.805785, 0.0443174, 0, 0.480566, 
        0.799878, 0.0414562, 0, 0.499013, 
        0.793469, 0.0388147, 0, 0.517749, 
        0.786473, 0.0363453, 0, 0.536785, 
        0.778874, 0.0340225, 0, 0.556134, 
        0.771277, 0.0318599, 0, 0.575809, 
        0.763426, 0.0298859, 0, 0.595827, 
        0.755044, 0.0280357, 0, 0.616207, 
        0.746161, 0.0262979, 0, 0.636973, 
        0.737124, 0.0247295, 0, 0.65815, 
        0.72761, 0.0232514, 0, 0.679772, 
        0.717822, 0.0218755, 0, 0.701876, 
        0.708279, 0.0205942, 0, 0.724509, 
        0.698333, 0.0193947, 0, 0.74773, 
        0.68802, 0.0182717, 0, 0.771609, 
        0.677321, 0.0172044, 0, 0.79624, 
        0.666504, 0.0162122, 0, 0.821743, 
        0.656184, 0.0152924, 0, 0.84828, 
        0.64556, 0.0144326, 0, 0.876069, 
        0.634636, 0.0136157, 0, 0.905404, 
        0.624124, 0.0128612, 0, 0.936508, 
        0.613914, 0.0121435, 0, 0.968254, 
        0.603589, 0.0114887, 0, 1, 
        1, 0.307946, 0, 0, 
        0.999999, 0.307945, 0, 0, 
        0.999988, 0.307934, 0, 2.04479e-05, 
        0.999944, 0.307886, 0, 0.00127833, 
        0.999824, 0.307756, 0, 0.00445047, 
        0.999565, 0.30748, 0, 0.00914673, 
        0.999085, 0.306966, 0, 0.0150498, 
        0.998103, 0.306004, 0, 0.0219367, 
        0.994249, 0.303028, 0, 0.0296485, 
        0.991807, 0.300435, 0, 0.038068, 
        0.987773, 0.296554, 0, 0.0471062, 
        0.982673, 0.2916, 0, 0.0566942, 
        0.976623, 0.285641, 0, 0.0667768, 
        0.968757, 0.27815, 0, 0.0773099, 
        0.959849, 0.269529, 0, 0.088257, 
        0.950663, 0.260248, 0, 0.0995879, 
        0.940129, 0.249704, 0, 0.111277, 
        0.92895, 0.238291, 0, 0.123304, 
        0.917996, 0.226501, 0, 0.13565, 
        0.907813, 0.214669, 0, 0.148299, 
        0.898305, 0.202835, 0, 0.161237, 
        0.889626, 0.191158, 0, 0.174455, 
        0.88175, 0.179695, 0, 0.187941, 
        0.874715, 0.168548, 0, 0.201687, 
        0.868746, 0.15792, 0, 0.215687, 
        0.863703, 0.147807, 0, 0.229933, 
        0.859315, 0.138149, 0, 0.24442, 
        0.855538, 0.128993, 0, 0.259145, 
        0.852428, 0.120414, 0, 0.274103, 
        0.850168, 0.112498, 0, 0.289293, 
        0.848132, 0.105054, 0, 0.304711, 
        0.846291, 0.0981087, 0, 0.320357, 
        0.844431, 0.0915942, 0, 0.33623, 
        0.842493, 0.0855056, 0, 0.35233, 
        0.840368, 0.0798204, 0, 0.368658, 
        0.83798, 0.0745097, 0, 0.385214, 
        0.83523, 0.0695424, 0, 0.402002, 
        0.832091, 0.0649092, 0, 0.419023, 
        0.828667, 0.0606291, 0, 0.436282, 
        0.824805, 0.0566523, 0, 0.453782, 
        0.820988, 0.0530229, 0, 0.471529, 
        0.816635, 0.0496364, 0, 0.489528, 
        0.811725, 0.0464658, 0, 0.507788, 
        0.806316, 0.0435082, 0, 0.526317, 
        0.800469, 0.0407873, 0, 0.545124, 
        0.794107, 0.038255, 0, 0.564221, 
        0.787218, 0.0358825, 0, 0.583621, 
        0.779872, 0.0336785, 0, 0.603341, 
        0.772097, 0.0316379, 0, 0.623397, 
        0.764484, 0.0297379, 0, 0.643812, 
        0.756428, 0.0279581, 0, 0.664611, 
        0.748022, 0.0263153, 0, 0.685824, 
        0.739268, 0.0247799, 0, 0.707488, 
        0.73024, 0.0233385, 0, 0.729646, 
        0.720893, 0.0220035, 0, 0.752354, 
        0.71119, 0.0207555, 0, 0.77568, 
        0.701791, 0.0195843, 0, 0.799715, 
        0.692184, 0.0184891, 0, 0.824574, 
        0.682258, 0.0174541, 0, 0.850417, 
        0.67206, 0.0164873, 0, 0.877466, 
        0.661717, 0.0155959, 0, 0.90604, 
        0.651462, 0.0147519, 0, 0.936528, 
        0.641467, 0.0139727, 0, 0.968254, 
        0.631229, 0.0132363, 0, 1, 
        1, 0.367573, 0, 0, 
        0.999999, 0.367571, 0, 0, 
        0.999984, 0.367553, 0, 0.000183382, 
        0.999925, 0.367473, 0, 0.00225254, 
        0.999759, 0.367259, 0, 0.00628165, 
        0.99941, 0.366801, 0, 0.0117858, 
        0.998739, 0.365946, 0, 0.0184359, 
        0.995529, 0.363191, 0, 0.0260114, 
        0.992875, 0.360171, 0, 0.0343581, 
        0.989135, 0.355981, 0, 0.0433637, 
        0.984166, 0.350401, 0, 0.0529438, 
        0.977871, 0.343348, 0, 0.0630334, 
        0.96951, 0.334341, 0, 0.0735805, 
        0.959964, 0.323862, 0, 0.0845437, 
        0.950162, 0.312521, 0, 0.095889, 
        0.938882, 0.299577, 0, 0.107588, 
        0.926992, 0.285573, 0, 0.119617, 
        0.915589, 0.271212, 0, 0.131957, 
        0.904791, 0.256611, 0, 0.144591, 
        0.895177, 0.242224, 0, 0.157503, 
        0.886403, 0.227952, 0, 0.170682, 
        0.878957, 0.214192, 0, 0.184117, 
        0.872418, 0.200795, 0, 0.197799, 
        0.867029, 0.188015, 0, 0.21172, 
        0.862835, 0.175975, 0, 0.225873, 
        0.859411, 0.164526, 0, 0.240253, 
        0.856655, 0.153693, 0, 0.254854, 
        0.854519, 0.14352, 0, 0.269673, 
        0.852828, 0.13397, 0, 0.284707, 
        0.851412, 0.124984, 0, 0.299953, 
        0.850609, 0.116748, 0, 0.315408, 
        0.849855, 0.10905, 0, 0.331073, 
        0.849017, 0.101839, 0, 0.346946, 
        0.848079, 0.0951359, 0, 0.363028, 
        0.846911, 0.0888774, 0, 0.379318, 
        0.845445, 0.0830375, 0, 0.395818, 
        0.84362, 0.0775844, 0, 0.41253, 
        0.841411, 0.0725054, 0, 0.429457, 
        0.838768, 0.0677691, 0, 0.446602, 
        0.835801, 0.0634016, 0, 0.463968, 
        0.832341, 0.0593095, 0, 0.481561, 
        0.828424, 0.0555121, 0, 0.499386, 
        0.824312, 0.052024, 0, 0.51745, 
        0.819918, 0.0487865, 0, 0.535761, 
        0.815072, 0.0457801, 0, 0.554328, 
        0.809863, 0.0430184, 0, 0.573162, 
        0.804164, 0.0404245, 0, 0.592275, 
        0.798034, 0.0380146, 0, 0.611681, 
        0.791436, 0.0357436, 0, 0.631398, 
        0.784498, 0.0336475, 0, 0.651445, 
        0.777125, 0.0316666, 0, 0.671845, 
        0.769365, 0.0298122, 0, 0.692628, 
        0.761579, 0.0281001, 0, 0.713827, 
        0.753746, 0.0265049, 0, 0.735484, 
        0.745573, 0.0250067, 0, 0.75765, 
        0.737083, 0.0236026, 0, 0.78039, 
        0.728545, 0.0223302, 0, 0.803789, 
        0.719691, 0.0211243, 0, 0.82796, 
        0.710569, 0.0199983, 0, 0.853056, 
        0.701216, 0.0189569, 0, 0.879298, 
        0.692094, 0.0179702, 0, 0.907014, 
        0.682909, 0.0170418, 0, 0.936691, 
        0.673509, 0.0161732, 0, 0.968254, 
        0.663863, 0.0153406, 0, 1, 
        1, 0.437395, 0, 0, 
        0.999998, 0.437394, 0, 0, 
        0.99998, 0.437363, 0, 0.000616704, 
        0.999891, 0.437232, 0, 0.00367925, 
        0.999656, 0.436877, 0, 0.00867446, 
        0.999148, 0.436121, 0, 0.0150679, 
        0.997959, 0.434564, 0, 0.022531, 
        0.993464, 0.430134, 0, 0.0308507, 
        0.990606, 0.426077, 0, 0.0398805, 
        0.985027, 0.419397, 0, 0.0495148, 
        0.978491, 0.41118, 0, 0.0596749, 
        0.969643, 0.40048, 0, 0.0703001, 
        0.959189, 0.38769, 0, 0.0813427, 
        0.948223, 0.373575, 0, 0.0927641, 
        0.935955, 0.357622, 0, 0.104533, 
        0.923237, 0.34043, 0, 0.116624, 
        0.911074, 0.322735, 0, 0.129015, 
        0.899724, 0.30479, 0, 0.141687, 
        0.890189, 0.287392, 0, 0.154626, 
        0.881796, 0.270248, 0, 0.167818, 
        0.874781, 0.253659, 0, 0.181252, 
        0.869166, 0.237786, 0, 0.194918, 
        0.864725, 0.222618, 0, 0.208807, 
        0.861565, 0.208356, 0, 0.222913, 
        0.859284, 0.194867, 0, 0.237229, 
        0.857677, 0.18212, 0, 0.25175, 
        0.856714, 0.17018, 0, 0.266473, 
        0.856155, 0.158969, 0, 0.281392, 
        0.8558, 0.148413, 0, 0.296505, 
        0.855672, 0.138578, 0, 0.311811, 
        0.855538, 0.129345, 0, 0.327306, 
        0.855689, 0.120861, 0, 0.342991, 
        0.855767, 0.112969, 0, 0.358864, 
        0.855618, 0.105593, 0, 0.374925, 
        0.85525, 0.0987451, 0, 0.391176, 
        0.854583, 0.0923727, 0, 0.407616, 
        0.853534, 0.0864143, 0, 0.424249, 
        0.852061, 0.0808338, 0, 0.441076, 
        0.850253, 0.0756771, 0, 0.4581, 
        0.848004, 0.0708612, 0, 0.475324, 
        0.845333, 0.0663784, 0, 0.492754, 
        0.842376, 0.0622631, 0, 0.510394, 
        0.838956, 0.0584112, 0, 0.528251, 
        0.835121, 0.0548328, 0, 0.546331, 
        0.830842, 0.0514838, 0, 0.564644, 
        0.826212, 0.048355, 0, 0.583198, 
        0.821522, 0.0454714, 0, 0.602005, 
        0.816551, 0.0428263, 0, 0.621078, 
        0.811211, 0.0403612, 0, 0.640434, 
        0.805479, 0.038039, 0, 0.660089, 
        0.799409, 0.0358739, 0, 0.680066, 
        0.79306, 0.0338727, 0, 0.70039, 
        0.786395, 0.0319985, 0, 0.721094, 
        0.779416, 0.030241, 0, 0.742215, 
        0.77214, 0.0285951, 0, 0.7638, 
        0.764636, 0.0270747, 0, 0.785912, 
        0.756836, 0.0256354, 0, 0.808628, 
        0.749315, 0.0243027, 0, 0.832055, 
        0.741561, 0.0230497, 0, 0.856338, 
        0.733589, 0.0218801, 0, 0.88169, 
        0.725479, 0.020784, 0, 0.908441, 
        0.717255, 0.0197702, 0, 0.937125, 
        0.708829, 0.0188168, 0, 0.968254, 
        0.700191, 0.0179113, 0, 1, 
        1, 0.518937, 0, 0, 
        0.999998, 0.518933, 0, 0, 
        0.999967, 0.518883, 0, 0.00147741, 
        0.999832, 0.51866, 0, 0.00573221, 
        0.999466, 0.518057, 0, 0.011826, 
        0.998644, 0.516752, 0, 0.0192116, 
        0.994458, 0.512347, 0, 0.027573, 
        0.991223, 0.507675, 0, 0.0367099, 
        0.985515, 0.500188, 0, 0.046487, 
        0.978308, 0.490408, 0, 0.0568071, 
        0.968359, 0.477357, 0, 0.0675984, 
        0.95682, 0.461752, 0, 0.0788059, 
        0.943929, 0.443796, 0, 0.090386, 
        0.930224, 0.423893, 0, 0.102304, 
        0.916514, 0.402682, 0, 0.114532, 
        0.903653, 0.380914, 0, 0.127047, 
        0.892315, 0.359212, 0, 0.139828, 
        0.882942, 0.338102, 0, 0.152861, 
        0.875438, 0.31773, 0, 0.16613, 
        0.869642, 0.298186, 0, 0.179624, 
        0.865304, 0.279491, 0, 0.193332, 
        0.862382, 0.261804, 0, 0.207247, 
        0.860666, 0.245146, 0, 0.22136, 
        0.859788, 0.229406, 0, 0.235666, 
        0.859608, 0.214605, 0, 0.250158, 
        0.859912, 0.200691, 0, 0.264832, 
        0.86053, 0.187623, 0, 0.279684, 
        0.861368, 0.17539, 0, 0.294711, 
        0.862237, 0.163901, 0, 0.309911, 
        0.863127, 0.153175, 0, 0.32528, 
        0.863923, 0.143147, 0, 0.340819, 
        0.864567, 0.133781, 0, 0.356524, 
        0.865013, 0.125042, 0, 0.372397, 
        0.86539, 0.116952, 0, 0.388438, 
        0.865591, 0.109476, 0, 0.404645, 
        0.865517, 0.102542, 0, 0.421022, 
        0.865084, 0.0960688, 0, 0.437569, 
        0.864309, 0.0900499, 0, 0.454287, 
        0.863151, 0.0844328, 0, 0.471181, 
        0.861649, 0.0792218, 0, 0.488253, 
        0.859742, 0.0743482, 0, 0.505507, 
        0.857446, 0.0697963, 0, 0.522947, 
        0.854757, 0.0655364, 0, 0.54058, 
        0.851783, 0.061608, 0, 0.558412, 
        0.848516, 0.0579701, 0, 0.576449, 
        0.844897, 0.0545742, 0, 0.594701, 
        0.840956, 0.0514167, 0, 0.613178, 
        0.836676, 0.0484598, 0, 0.631892, 
        0.832075, 0.0456934, 0, 0.650856, 
        0.827191, 0.0431178, 0, 0.670088, 
        0.822295, 0.0407718, 0, 0.689606, 
        0.817294, 0.0386032, 0, 0.709434, 
        0.812013, 0.0365675, 0, 0.7296, 
        0.806465, 0.0346547, 0, 0.750138, 
        0.800691, 0.0328717, 0, 0.771093, 
        0.794709, 0.031211, 0, 0.792519, 
        0.788493, 0.0296504, 0, 0.814488, 
        0.782049, 0.0281782, 0, 0.837097, 
        0.775403, 0.0267965, 0, 0.860481, 
        0.76857, 0.0255002, 0, 0.884842, 
        0.761536, 0.0242759, 0, 0.910494, 
        0.754303, 0.0231142, 0, 0.937985, 
        0.74692, 0.0220305, 0, 0.968254, 
        0.739745, 0.0210192, 0, 1, 
        1, 0.613914, 0, 0, 
        0.999996, 0.613907, 0, 9.63597e-05, 
        0.999942, 0.613814, 0, 0.00301247, 
        0.999704, 0.613407, 0, 0.00870385, 
        0.999046, 0.612302, 0, 0.0160714, 
        0.995516, 0.608266, 0, 0.0245899, 
        0.991726, 0.602863, 0, 0.0339681, 
        0.985157, 0.593956, 0, 0.0440254, 
        0.97642, 0.581748, 0, 0.0546409, 
        0.964404, 0.565183, 0, 0.0657284, 
        0.950601, 0.545273, 0, 0.0772246, 
        0.935158, 0.522129, 0, 0.0890812, 
        0.919364, 0.496782, 0, 0.10126, 
        0.904754, 0.470571, 0, 0.113731, 
        0.89176, 0.444037, 0, 0.126469, 
        0.881492, 0.418322, 0, 0.139454, 
        0.873656, 0.393522, 0, 0.15267, 
        0.868053, 0.369795, 0, 0.166101, 
        0.864336, 0.347171, 0, 0.179736, 
        0.862259, 0.325737, 0, 0.193565, 
        0.861556, 0.305532, 0, 0.207578, 
        0.861776, 0.286416, 0, 0.221769, 
        0.862661, 0.268355, 0, 0.23613, 
        0.864015, 0.251334, 0, 0.250656, 
        0.865711, 0.235352, 0, 0.265343, 
        0.867519, 0.220302, 0, 0.280187, 
        0.869351, 0.206161, 0, 0.295183, 
        0.871144, 0.192908, 0, 0.31033, 
        0.872839, 0.180505, 0, 0.325624, 
        0.874307, 0.168848, 0, 0.341065, 
        0.875667, 0.158021, 0, 0.35665, 
        0.876758, 0.147877, 0, 0.37238, 
        0.87764, 0.138441, 0, 0.388253, 
        0.878237, 0.129627, 0, 0.404269, 
        0.878563, 0.121415, 0, 0.42043, 
        0.878572, 0.113741, 0, 0.436735, 
        0.87842, 0.106652, 0, 0.453187, 
        0.878057, 0.100097, 0, 0.469786, 
        0.877413, 0.0940128, 0, 0.486536, 
        0.87646, 0.0883462, 0, 0.503439, 
        0.875233, 0.0830924, 0, 0.520498, 
        0.8737, 0.0781975, 0, 0.537717, 
        0.871873, 0.07364, 0, 0.555102, 
        0.86978, 0.0694103, 0, 0.572657, 
        0.867405, 0.0654696, 0, 0.59039, 
        0.864751, 0.0617914, 0, 0.608307, 
        0.861818, 0.0583491, 0, 0.626419, 
        0.858645, 0.0551443, 0, 0.644733, 
        0.855307, 0.0521894, 0, 0.663264, 
        0.851736, 0.0494334, 0, 0.682025, 
        0.847927, 0.0468504, 0, 0.701032, 
        0.843888, 0.0444261, 0, 0.720308, 
        0.839629, 0.0421497, 0, 0.739875, 
        0.835158, 0.0400082, 0, 0.759764, 
        0.830509, 0.0380076, 0, 0.780014, 
        0.825714, 0.0361488, 0, 0.800673, 
        0.820729, 0.0343956, 0, 0.821803, 
        0.815751, 0.0327781, 0, 0.843492, 
        0.810752, 0.031275, 0, 0.86586, 
        0.805587, 0.0298542, 0, 0.889087, 
        0.800317, 0.0285397, 0, 0.913466, 
        0.79489, 0.0272948, 0, 0.93952, 
        0.789314, 0.0261139, 0, 0.96835, 
        0.783593, 0.0249938, 0, 1, 
        1, 0.724258, 0, 0, 
        0.999992, 0.724243, 0, 0.000726889, 
        0.99987, 0.724044, 0, 0.00569574, 
        0.999336, 0.72317, 0, 0.0131702, 
        0.996271, 0.719432, 0, 0.0220738, 
        0.991159, 0.712576, 0, 0.0319405, 
        0.982465, 0.700927, 0, 0.0425202, 
        0.97049, 0.684297, 0, 0.0536599, 
        0.953973, 0.661244, 0, 0.065258, 
        0.935546, 0.633804, 0, 0.0772427, 
        0.916596, 0.603071, 0, 0.0895616, 
        0.899353, 0.57105, 0, 0.102175, 
        0.885216, 0.539206, 0, 0.11505, 
        0.875076, 0.508714, 0, 0.128164, 
        0.868334, 0.479571, 0, 0.141495, 
        0.864414, 0.451796, 0, 0.155026, 
        0.862678, 0.425328, 0, 0.168745, 
        0.862835, 0.400352, 0, 0.182639, 
        0.864067, 0.376532, 0, 0.196699, 
        0.866086, 0.35391, 0, 0.210915, 
        0.868557, 0.332424, 0, 0.225282, 
        0.871271, 0.312053, 0, 0.239792, 
        0.874058, 0.292764, 0, 0.25444, 
        0.8768, 0.27453, 0, 0.269223, 
        0.87939, 0.257297, 0, 0.284135, 
        0.8819, 0.24114, 0, 0.299174, 
        0.884187, 0.225934, 0, 0.314337, 
        0.886262, 0.211669, 0, 0.329622, 
        0.888119, 0.198311, 0, 0.345026, 
        0.889709, 0.185783, 0, 0.360549, 
        0.891054, 0.174063, 0, 0.376189, 
        0.892196, 0.163143, 0, 0.391946, 
        0.893101, 0.152952, 0, 0.407819, 
        0.893803, 0.143475, 0, 0.423808, 
        0.894277, 0.134647, 0, 0.439914, 
        0.894532, 0.126434, 0, 0.456137, 
        0.894576, 0.1188, 0, 0.472479, 
        0.894393, 0.111694, 0, 0.48894, 
        0.893976, 0.105069, 0, 0.505523, 
        0.893346, 0.0989077, 0, 0.52223, 
        0.892502, 0.0931724, 0, 0.539064, 
        0.891441, 0.0878276, 0, 0.556028, 
        0.890276, 0.082903, 0, 0.573125, 
        0.888972, 0.0783505, 0, 0.590361, 
        0.887469, 0.0741083, 0, 0.607741, 
        0.885785, 0.0701633, 0, 0.62527, 
        0.883914, 0.0664835, 0, 0.642957, 
        0.881872, 0.0630567, 0, 0.660809, 
        0.879651, 0.0598527, 0, 0.678836, 
        0.877267, 0.0568615, 0, 0.69705, 
        0.874717, 0.05406, 0, 0.715465, 
        0.872012, 0.0514378, 0, 0.734098, 
        0.869157, 0.0489805, 0, 0.752968, 
        0.866155, 0.0466727, 0, 0.772101, 
        0.863014, 0.0445056, 0, 0.791529, 
        0.859748, 0.0424733, 0, 0.81129, 
        0.856416, 0.0405957, 0, 0.831438, 
        0.852958, 0.0388273, 0, 0.852044, 
        0.849382, 0.0371619, 0, 0.87321, 
        0.845694, 0.0355959, 0, 0.89509, 
        0.841893, 0.0341155, 0, 0.917932, 
        0.837981, 0.0327141, 0, 0.942204, 
        0.833963, 0.0313856, 0, 0.968981, 
        0.829847, 0.0301275, 0, 1, 
        1, 0.85214, 0, 0, 
        0.999969, 0.852095, 0, 0.00279627, 
        0.999483, 0.851408, 0, 0.0107635, 
        0.994545, 0.84579, 0, 0.0206454, 
        0.986188, 0.835231, 0, 0.0315756, 
        0.969847, 0.814687, 0, 0.0432021, 
        0.945951, 0.783735, 0, 0.0553396, 
        0.91917, 0.746074, 0, 0.0678766, 
        0.895488, 0.706938, 0, 0.0807395, 
        0.878232, 0.669534, 0, 0.0938767, 
        0.868252, 0.635168, 0, 0.10725, 
        0.863873, 0.603069, 0, 0.120832, 
        0.863369, 0.572514, 0, 0.134598, 
        0.86545, 0.543169, 0, 0.148533, 
        0.868803, 0.514578, 0, 0.16262, 
        0.872794, 0.486762, 0, 0.176849, 
        0.87702, 0.459811, 0, 0.19121, 
        0.881054, 0.433654, 0, 0.205694, 
        0.884974, 0.408574, 0, 0.220294, 
        0.888587, 0.384525, 0, 0.235005, 
        0.891877, 0.36156, 0, 0.24982, 
        0.894793, 0.339661, 0, 0.264737, 
        0.89743, 0.318913, 0, 0.279751, 
        0.899796, 0.299302, 0, 0.294859, 
        0.901943, 0.280843, 0, 0.310058, 
        0.903858, 0.263481, 0, 0.325346, 
        0.905574, 0.247197, 0, 0.340721, 
        0.907069, 0.231915, 0, 0.356181, 
        0.908379, 0.217614, 0, 0.371725, 
        0.90952, 0.20425, 0, 0.387353, 
        0.910483, 0.191758, 0, 0.403063, 
        0.91128, 0.180092, 0, 0.418854, 
        0.911936, 0.169222, 0, 0.434727, 
        0.912454, 0.159098, 0, 0.450682, 
        0.912835, 0.149668, 0, 0.466718, 
        0.913078, 0.140884, 0, 0.482837, 
        0.913192, 0.132709, 0, 0.499038, 
        0.913175, 0.125095, 0, 0.515324, 
        0.91304, 0.118012, 0, 0.531695, 
        0.912781, 0.111417, 0, 0.548153, 
        0.91241, 0.105281, 0, 0.5647, 
        0.911924, 0.0995691, 0, 0.581338, 
        0.911331, 0.0942531, 0, 0.59807, 
        0.910637, 0.0893076, 0, 0.6149, 
        0.90984, 0.0846998, 0, 0.63183, 
        0.908941, 0.0804044, 0, 0.648865, 
        0.907944, 0.0763984, 0, 0.666011, 
        0.906857, 0.0726638, 0, 0.683273, 
        0.90568, 0.0691783, 0, 0.700659, 
        0.904416, 0.0659222, 0, 0.718176, 
        0.903067, 0.0628782, 0, 0.735834, 
        0.901637, 0.0600307, 0, 0.753646, 
        0.900128, 0.0573647, 0, 0.771625, 
        0.898544, 0.0548668, 0, 0.78979, 
        0.89689, 0.052527, 0, 0.808162, 
        0.895165, 0.0503306, 0, 0.826771, 
        0.893371, 0.0482668, 0, 0.845654, 
        0.891572, 0.0463605, 0, 0.864863, 
        0.889763, 0.0445998, 0, 0.884472, 
        0.887894, 0.0429451, 0, 0.904592, 
        0.885967, 0.0413884, 0, 0.925407, 
        0.883984, 0.0399225, 0, 0.947271, 
        0.881945, 0.0385405, 0, 0.97105, 
        0.879854, 0.0372362, 0, 1, 
        0.999804, 0.995833, 0, 0, 
        0.938155, 0.933611, 0, 0.0158731, 
        0.864755, 0.854311, 0, 0.0317461, 
        0.888594, 0.865264, 0, 0.0476191, 
        0.905575, 0.863922, 0, 0.0634921, 
        0.915125, 0.850558, 0, 0.0793651, 
        0.920665, 0.829254, 0, 0.0952381, 
        0.924073, 0.802578, 0, 0.111111, 
        0.926304, 0.772211, 0, 0.126984, 
        0.927829, 0.739366, 0, 0.142857, 
        0.928924, 0.705033, 0, 0.15873, 
        0.92973, 0.670019, 0, 0.174603, 
        0.930339, 0.634993, 0, 0.190476, 
        0.930811, 0.600485, 0, 0.206349, 
        0.931191, 0.566897, 0, 0.222222, 
        0.93149, 0.534485, 0, 0.238095, 
        0.931737, 0.503429, 0, 0.253968, 
        0.931939, 0.473811, 0, 0.269841, 
        0.932108, 0.445668, 0, 0.285714, 
        0.93225, 0.418993, 0, 0.301587, 
        0.932371, 0.393762, 0, 0.31746, 
        0.932474, 0.369939, 0, 0.333333, 
        0.932562, 0.347479, 0, 0.349206, 
        0.932638, 0.326336, 0, 0.365079, 
        0.932703, 0.306462, 0, 0.380952, 
        0.93276, 0.287805, 0, 0.396825, 
        0.932809, 0.270313, 0, 0.412698, 
        0.932851, 0.253933, 0, 0.428571, 
        0.932887, 0.23861, 0, 0.444444, 
        0.932917, 0.224289, 0, 0.460317, 
        0.932943, 0.210917, 0, 0.47619, 
        0.932965, 0.19844, 0, 0.492063, 
        0.932982, 0.186807, 0, 0.507937, 
        0.932995, 0.175966, 0, 0.52381, 
        0.933005, 0.165869, 0, 0.539683, 
        0.933011, 0.156468, 0, 0.555556, 
        0.933013, 0.147719, 0, 0.571429, 
        0.933013, 0.139579, 0, 0.587302, 
        0.93301, 0.132007, 0, 0.603175, 
        0.933004, 0.124965, 0, 0.619048, 
        0.932994, 0.118416, 0, 0.634921, 
        0.932982, 0.112326, 0, 0.650794, 
        0.932968, 0.106663, 0, 0.666667, 
        0.93295, 0.101397, 0, 0.68254, 
        0.932931, 0.0964993, 0, 0.698413, 
        0.932908, 0.0919438, 0, 0.714286, 
        0.932883, 0.0877057, 0, 0.730159, 
        0.932856, 0.0837623, 0, 0.746032, 
        0.932827, 0.0800921, 0, 0.761905, 
        0.932796, 0.0766754, 0, 0.777778, 
        0.932762, 0.0734936, 0, 0.793651, 
        0.932727, 0.0705296, 0, 0.809524, 
        0.932689, 0.0677676, 0, 0.825397, 
        0.93265, 0.0651929, 0, 0.84127, 
        0.932609, 0.0627917, 0, 0.857143, 
        0.932565, 0.0605515, 0, 0.873016, 
        0.932521, 0.0584606, 0, 0.888889, 
        0.932474, 0.0565082, 0, 0.904762, 
        0.932427, 0.0546841, 0, 0.920635, 
        0.932377, 0.0529793, 0, 0.936508, 
        0.932326, 0.0513851, 0, 0.952381, 
        0.932274, 0.0498936, 0, 0.968254, 
        0.93222, 0.0484975, 0, 0.984127, 
        0.932164, 0.0471899, 0, 1, 
        ];

export default g_ltc_2;